/* tslint:disable */
/* eslint-disable */
/**
 * ProLogsApi API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbpLoginResult
 */
export interface AbpLoginResult {
    /**
     * 
     * @type {LoginResultType}
     * @memberof AbpLoginResult
     */
    'result'?: LoginResultType;
    /**
     * 
     * @type {string}
     * @memberof AbpLoginResult
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionApiDescriptionModel
 */
export interface ActionApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'uniqueName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'httpMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'url'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionApiDescriptionModel
     */
    'supportedVersions'?: Array<string> | null;
    /**
     * 
     * @type {Array<MethodParameterApiDescriptionModel>}
     * @memberof ActionApiDescriptionModel
     */
    'parametersOnMethod'?: Array<MethodParameterApiDescriptionModel> | null;
    /**
     * 
     * @type {Array<ParameterApiDescriptionModel>}
     * @memberof ActionApiDescriptionModel
     */
    'parameters'?: Array<ParameterApiDescriptionModel> | null;
    /**
     * 
     * @type {ActionApiDescriptionModelReturnValue}
     * @memberof ActionApiDescriptionModel
     */
    'returnValue'?: ActionApiDescriptionModelReturnValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActionApiDescriptionModel
     */
    'allowAnonymous'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModel
     */
    'implementFrom'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionApiDescriptionModelReturnValue
 */
export interface ActionApiDescriptionModelReturnValue {
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModelReturnValue
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionApiDescriptionModelReturnValue
     */
    'typeSimple'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionDefinitionGroup
 */
export interface ActionPermissionDefinitionGroup {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionGroup
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionGroup
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionDefinitionPermission
 */
export interface ActionPermissionDefinitionPermission {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionDefinitionPermission
     */
    'parent'?: string | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGrantInfoDto
 */
export interface ActionPermissionGrantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGrantInfoDto
     */
    'parentName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ActionPermissionGrantInfoDto
     */
    'isGranted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionPermissionGrantInfoDto
     */
    'allowedProviders'?: Array<string> | null;
    /**
     * 
     * @type {Array<ActionPermissionProviderInfoDto>}
     * @memberof ActionPermissionGrantInfoDto
     */
    'grantedProviders'?: Array<ActionPermissionProviderInfoDto> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGroup
 */
export interface ActionPermissionGroup {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroup
     */
    'permissionGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroup
     */
    'permissionGroupDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionDefinitionPermission>}
     * @memberof ActionPermissionGroup
     */
    'permissions'?: Array<ActionPermissionDefinitionPermission> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionGroupDto
 */
export interface ActionPermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGrantInfoDto>}
     * @memberof ActionPermissionGroupDto
     */
    'permissions'?: Array<ActionPermissionGrantInfoDto> | null;
}
/**
 * 
 * @export
 * @interface ActionPermissionProviderInfoDto
 */
export interface ActionPermissionProviderInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionProviderInfoDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionPermissionProviderInfoDto
     */
    'providerKey'?: string | null;
}
/**
 * 
 * @export
 * @interface AddExceptionDto
 */
export interface AddExceptionDto {
    /**
     * 
     * @type {number}
     * @memberof AddExceptionDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddExceptionDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddExceptionDto
     */
    'exceptionId'?: number;
}
/**
 * 
 * @export
 * @interface AddRemarkDto
 */
export interface AddRemarkDto {
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddRemarkDto
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddRemarkDto
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface AddShipmentNumberInputDto
 */
export interface AddShipmentNumberInputDto {
    /**
     * 
     * @type {number}
     * @memberof AddShipmentNumberInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentNumberInputDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddShipmentNumberInputDto
     */
    'shippingDocs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AddStatusDto
 */
export interface AddStatusDto {
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddStatusDto
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddStatusDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface AdvancedSearchListDto
 */
export interface AdvancedSearchListDto {
    /**
     * 
     * @type {Array<DriverAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'drivers'?: Array<DriverAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<VehicleAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'vehicles'?: Array<VehicleAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<EldDeviceAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'eldDevices'?: Array<EldDeviceAdvancedSearchListDto> | null;
    /**
     * 
     * @type {Array<TrailerAdvancedSearchListDto>}
     * @memberof AdvancedSearchListDto
     */
    'trailers'?: Array<TrailerAdvancedSearchListDto> | null;
}
/**
 * 
 * @export
 * @interface AllDriversDto
 */
export interface AllDriversDto {
    /**
     * 
     * @type {string}
     * @memberof AllDriversDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllDriversDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'offDutyIdleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'onDutyIdleValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'fuelConsumptionValueAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'fuelConsumptionValueTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'maxIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'minIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'averageIdleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'totalIdleTime'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AllDriversDto
     */
    'eventScale'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AllDriversDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllDriversDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AllDriversDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface AllDriversDtoPagedResultDto
 */
export interface AllDriversDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof AllDriversDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<AllDriversDto>}
     * @memberof AllDriversDtoPagedResultDto
     */
    'items'?: Array<AllDriversDto> | null;
}
/**
 * 
 * @export
 * @interface AllDriversInputDto
 */
export interface AllDriversInputDto {
    /**
     * 
     * @type {string}
     * @memberof AllDriversInputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllDriversInputDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof AllDriversInputDto
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {number}
     * @memberof AllDriversInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AllDriversInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAccountLoginPostRequest
 */
export interface ApiAccountLoginPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountLoginPostRequest
     */
    'userNameOrEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountLoginPostRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAccountLoginPostRequest
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAccountMyProfileChangePasswordPostRequest
 */
export interface ApiAccountMyProfileChangePasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileChangePasswordPostRequest
     */
    'currentPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileChangePasswordPostRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ApiAccountMyProfileGetRequest
 */
export interface ApiAccountMyProfileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAccountMyProfileGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAccountRegisterPostRequest
 */
export interface ApiAccountRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountRegisterPostRequest
     */
    'appName': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAccountRegisterPostRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAccountResetPasswordPostRequest
 */
export interface ApiAccountResetPasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'resetToken': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountResetPasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAccountSendPasswordResetCodePostRequest
 */
export interface ApiAccountSendPasswordResetCodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'appName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'returnUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAccountSendPasswordResetCodePostRequest
     */
    'returnUrlHash'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyExportPostRequest
 */
export interface ApiAppCompanyExportPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'exportFormat'?: string | null;
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyExportPostRequest
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyGetFilteredListPostRequest
 */
export interface ApiAppCompanyGetFilteredListPostRequest {
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetFilteredListPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyGetRequest
 */
export interface ApiAppCompanyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyGetRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppCompanyGetRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyGetRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppCompanyGetRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppCompanyGetRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppCompanyGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppCompanyGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyIdDeleteRequest
 */
export interface ApiAppCompanyIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'dutyCycleId'?: Array<number> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppCompanyIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppCompanyUpdateManyPutRequest
 */
export interface ApiAppCompanyUpdateManyPutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppCompanyUpdateManyPutRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppCompanyUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppCustomerserviceaccountServiceaccountPostRequest
 */
export interface ApiAppCustomerserviceaccountServiceaccountPostRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppCustomerserviceaccountServiceaccountPostRequest
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountChangePasswordPostRequest
 */
export interface ApiAppDemoaccountChangePasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountChangePasswordPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountChangePasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountIdDeleteRequest
 */
export interface ApiAppDemoaccountIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountIdDeleteRequest
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountPostRequest
 */
export interface ApiAppDemoaccountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'tenantId': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDemoaccountPostRequest
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface ApiAppDemoaccountUpdateManyPutRequest
 */
export interface ApiAppDemoaccountUpdateManyPutRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppDemoaccountUpdateManyPutRequest
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppDemoaccountUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppDocumentcenterDocumentforentityDeleteRequest
 */
export interface ApiAppDocumentcenterDocumentforentityDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'entityType': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'entityId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDocumentcenterDocumentforentityDeleteRequest
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppDocumentcenterGetdocumentbyidPostRequest
 */
export interface ApiAppDocumentcenterGetdocumentbyidPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterGetdocumentbyidPostRequest
     */
    'documentId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDocumentcenterGetdocumentbyidPostRequest
     */
    'entityType': number;
}
/**
 * 
 * @export
 * @interface ApiAppDriverChangepasswordPostRequest
 */
export interface ApiAppDriverChangepasswordPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverChangepasswordPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverChangepasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppDriverGetRequest
 */
export interface ApiAppDriverGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppDriverGetRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDriverGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppDriverGetRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverGetRequest
     */
    'password': string;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppDriverGetRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppDriverGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverGetRequest
     */
    'hideUnidentifiedEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppDriverIdDeleteRequest
 */
export interface ApiAppDriverIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDriverIdDeleteRequest
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ApiAppDriverRolloverPostRequest
 */
export interface ApiAppDriverRolloverPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverRolloverPostRequest
     */
    'fromDriverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverRolloverPostRequest
     */
    'toCoDriverId': number;
}
/**
 * 
 * @export
 * @interface ApiAppDriverSignaturePostRequest
 */
export interface ApiAppDriverSignaturePostRequest {
    /**
     * 
     * @type {Array<SignatureDto>}
     * @memberof ApiAppDriverSignaturePostRequest
     */
    'signatures'?: Array<SignatureDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
 */
export interface ApiAppDriverlogsGetdriverdutystatuseventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDriverlogsGetdriverdutystatuseventsPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppDvirDvirreportPostRequest
 */
export interface ApiAppDvirDvirreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {Array<DvirDefectDto>}
     * @memberof ApiAppDvirDvirreportPostRequest
     */
    'defects'?: Array<DvirDefectDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppDvirformGetRequest
 */
export interface ApiAppDvirformGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirformGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDvirformGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof ApiAppDvirformGetRequest
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDvirformGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirformGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDvirformIdDeleteRequest
 */
export interface ApiAppDvirformIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirformIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppDvirvehicledefectsResolvePostRequest
 */
export interface ApiAppDvirvehicledefectsResolvePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'defectId'?: number;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'isCorrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppDvirvehicledefectsResolvePostRequest
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceGetRequest
 */
export interface ApiAppElddeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppElddeviceGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppElddeviceGetRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppElddeviceGetRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceGetRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddeviceGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceIdDeleteRequest
 */
export interface ApiAppElddeviceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddeviceIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
 */
export interface ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface ApiAppElddisconnectionReporteldconnectionPostRequest
 */
export interface ApiAppElddisconnectionReporteldconnectionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'time'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppElddisconnectionReporteldconnectionPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppEventAddremarkPostRequest
 */
export interface ApiAppEventAddremarkPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddremarkPostRequest
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventAddstatusPostRequest
 */
export interface ApiAppEventAddstatusPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAddstatusPostRequest
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventAssignPutRequest
 */
export interface ApiAppEventAssignPutRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventAssignPutRequest
     */
    'eventIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventAssignPutRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventAssignPutRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventAssignPutRequest
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBatchPostRequest
 */
export interface ApiAppEventBatchPostRequest {
    /**
     * 
     * @type {Array<CreateOrUpdateEventDto>}
     * @memberof ApiAppEventBatchPostRequest
     */
    'events'?: Array<CreateOrUpdateEventDto> | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetcodriverPostRequest
 */
export interface ApiAppEventBulksetcodriverPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetcodriverPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetshippingdocsPostRequest
 */
export interface ApiAppEventBulksetshippingdocsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'shippingDocs'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetshippingdocsPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksettrailersPostRequest
 */
export interface ApiAppEventBulksettrailersPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksettrailersPostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventBulksetvehiclePostRequest
 */
export interface ApiAppEventBulksetvehiclePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventBulksetvehiclePostRequest
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppEventCertifylogdatePostRequest
 */
export interface ApiAppEventCertifylogdatePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventCertifylogdatePostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventCertifylogdatePostRequest
     */
    'logDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventDeleteManyDeleteRequest
 */
export interface ApiAppEventDeleteManyDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppEventDeleteManyDeleteRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppEventDeleteManyDeleteRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventFixeventsPostRequest
 */
export interface ApiAppEventFixeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixEngineHours'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixSequenceNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixOdometer'?: boolean;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'fixDirection': FixEventsDirection;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventFixeventsPostRequest
     */
    'endEvent': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventIdDeleteRequest
 */
export interface ApiAppEventIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'time'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'origin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'state'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'country'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'minTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'maxTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventIdDeleteRequest
     */
    'totalVehicleMiles'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventInvalidatemobileeventsPostRequest
 */
export interface ApiAppEventInvalidatemobileeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventInvalidatemobileeventsPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventInvalidatemobileeventsPostRequest
     */
    'fromStartTime'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventReassigneventsPostRequest
 */
export interface ApiAppEventReassigneventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'endEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventReassigneventsPostRequest
     */
    'driverId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventRebuildcyclePostRequest
 */
export interface ApiAppEventRebuildcyclePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventRebuildcyclePostRequest
     */
    'cycleId': string;
}
/**
 * 
 * @export
 * @interface ApiAppEventRebuildcyclefromeventPostRequest
 */
export interface ApiAppEventRebuildcyclefromeventPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventRebuildcyclefromeventPostRequest
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventRegenerateintermediatesPostRequest
 */
export interface ApiAppEventRegenerateintermediatesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventRegenerateintermediatesPostRequest
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface ApiAppEventResizeeventsPostRequest
 */
export interface ApiAppEventResizeeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'eventId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventResizeeventsPostRequest
     */
    'durationAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventSetdrivingnotePostRequest
 */
export interface ApiAppEventSetdrivingnotePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSetdrivingnotePostRequest
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventShifteventsPostRequest
 */
export interface ApiAppEventShifteventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'endEvent': number;
    /**
     * 
     * @type {ShiftEventsDirection}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'direction': ShiftEventsDirection;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShifteventsPostRequest
     */
    'timeAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppEventShipmentnumberPostRequest
 */
export interface ApiAppEventShipmentnumberPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppEventShipmentnumberPostRequest
     */
    'shippingDocs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiAppEventSmartfixeventsPostRequest
 */
export interface ApiAppEventSmartfixeventsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'to': string;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof ApiAppEventSmartfixeventsPostRequest
     */
    'fixEventsDirection': FixEventsDirection;
}
/**
 * 
 * @export
 * @interface ApiAppFleetmanagerGetRequest
 */
export interface ApiAppFleetmanagerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerGetRequest
     */
    'groupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppFleetmanagerIdDeleteRequest
 */
export interface ApiAppFleetmanagerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFleetmanagerIdDeleteRequest
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionGetRequest
 */
export interface ApiAppFmcsainspectionGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'base64EncodedEldFileContents': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionGetRequest
     */
    'mobileAppType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionIdDeleteRequest
 */
export interface ApiAppFmcsainspectionIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'eldFileUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionIdDeleteRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
 */
export interface ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'timeOfReport': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'eldFileComment': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest
     */
    'mobileApplicationType': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsainspectionMarkunofficialPostRequest
 */
export interface ApiAppFmcsainspectionMarkunofficialPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionMarkunofficialPostRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsainspectionMarkunofficialPostRequest
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsatransferSubmittoemailPostRequest
 */
export interface ApiAppFmcsatransferSubmittoemailPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'recipientOverride'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsatransferSubmittoemailPostRequest
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFmcsatransferSubmittowebservicePostRequest
 */
export interface ApiAppFmcsatransferSubmittowebservicePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppFmcsatransferSubmittowebservicePostRequest
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
 */
export interface ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
 */
export interface ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppFuelproviderGetRequest
 */
export interface ApiAppFuelproviderGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppFuelproviderGetRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppFuelproviderIdDeleteRequest
 */
export interface ApiAppFuelproviderIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppFuelproviderIdDeleteRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSenddevicecommandPostRequest
 */
export interface ApiAppGeometrisapiSenddevicecommandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSenddevicecommandPostRequest
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSenddevicecommandPostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSendresetcommandPostRequest
 */
export interface ApiAppGeometrisapiSendresetcommandPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSendresetcommandPostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSetenginebustypePostRequest
 */
export interface ApiAppGeometrisapiSetenginebustypePostRequest {
    /**
     * 
     * @type {GeometrisEngineBusType}
     * @memberof ApiAppGeometrisapiSetenginebustypePostRequest
     */
    'engineBusType'?: GeometrisEngineBusType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSetenginebustypePostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGeometrisapiSetodometervaluePostRequest
 */
export interface ApiAppGeometrisapiSetodometervaluePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppGeometrisapiSetodometervaluePostRequest
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppGeometrisapiSetodometervaluePostRequest
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface ApiAppGlobalsearchAdvancedsearchPostRequest
 */
export interface ApiAppGlobalsearchAdvancedsearchPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'searchText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeDrivers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeVehicles'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeTrailers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppGlobalsearchAdvancedsearchPostRequest
     */
    'includeEldDevices'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppGroupGetRequest
 */
export interface ApiAppGroupGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppGroupGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppGroupGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppGroupGetRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppGroupGetRequest
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
 */
export interface ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
 */
export interface ApiAppHarsheventreportGetharshaccelerationeventsPostRequest {
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHarsheventreportGetharshaccelerationeventsPostRequest
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppHoslogsAddexceptionPostRequest
 */
export interface ApiAppHoslogsAddexceptionPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'logDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppHoslogsAddexceptionPostRequest
     */
    'exceptionId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppIdlingreportsGetidlingdatafordriversPostRequest
 */
export interface ApiAppIdlingreportsGetidlingdatafordriversPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppIdlingreportsGetidlingdatafordriversPostRequest
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
 */
export interface ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest
     */
    'periodType'?: PeriodType;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenGetRequest
 */
export interface ApiAppLivetracktokenGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenGetRequest
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenIdDeleteRequest
 */
export interface ApiAppLivetracktokenIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLivetracktokenIdDeleteRequest
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppLivetracktokenUpdateManyPutRequest
 */
export interface ApiAppLivetracktokenUpdateManyPutRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppLivetracktokenUpdateManyPutRequest
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppLivetracktokenUpdateManyPutRequest
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppLocationLiveTrackPostRequest
 */
export interface ApiAppLocationLiveTrackPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'deviceTimestamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'lat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'lng'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationLiveTrackPostRequest
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppLocationhistoryvehiclesGetRequest
 */
export interface ApiAppLocationhistoryvehiclesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppLocationhistoryvehiclesGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
 */
export interface ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest {
    /**
     * 
     * @type {MaintenanceDashboardSaveType}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'saveType': MaintenanceDashboardSaveType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'maintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'vehicleMaintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest
     */
    'vehicleMaintenanceDashboardWidgetsConfiguration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceAssigntotenantPostRequest
 */
export interface ApiAppMasterelddeviceAssigntotenantPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceAssigntotenantPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppMasterelddeviceAssigntotenantPostRequest
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceGetRequest
 */
export interface ApiAppMasterelddeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceGetRequest
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceIdDeleteRequest
 */
export interface ApiAppMasterelddeviceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceMultipleelddevicesPostRequest
 */
export interface ApiAppMasterelddeviceMultipleelddevicesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'uploadInfoId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'hasHeader'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'serialNumberColumnIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterelddeviceMultipleelddevicesPostRequest
     */
    'macAddressColumnIndex'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterelddeviceUnassignfromtenantsPostRequest
 */
export interface ApiAppMasterelddeviceUnassignfromtenantsPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppMasterelddeviceUnassignfromtenantsPostRequest
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppMastereventIdGetRequest
 */
export interface ApiAppMastereventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'accumulatedVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'elapsedEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventIdGetRequest
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMastereventPostRequest
 */
export interface ApiAppMastereventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'accumulatedVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'elapsedEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof ApiAppMastereventPostRequest
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMastereventPostRequest
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMastereventPostRequest
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerGetRequest
 */
export interface ApiAppMasterfleetmanagerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppMasterfleetmanagerGetRequest
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerIdDeleteRequest
 */
export interface ApiAppMasterfleetmanagerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerIdDeleteRequest
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerResetpasswordPostRequest
 */
export interface ApiAppMasterfleetmanagerResetpasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMasterfleetmanagerResetpasswordPostRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest
 */
export interface ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMobileappversionIdDeleteRequest
 */
export interface ApiAppMobileappversionIdDeleteRequest {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'mobileApplicationType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'timestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'buildNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobileappversionIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppMobiletrailerPostRequest
 */
export interface ApiAppMobiletrailerPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'trailerType'?: TrailerType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppMobiletrailerPostRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSavenotificationpreferencePostRequest
 */
export interface ApiAppNotificationcenterSavenotificationpreferencePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'notificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationcenterSavenotificationpreferencePostRequest
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
 */
export interface ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest
     */
    'trailerId'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
 */
export interface ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest
     */
    'lastReadNotificationTime': string;
}
/**
 * 
 * @export
 * @interface ApiAppNotificationsubscriptionGetRequest
 */
export interface ApiAppNotificationsubscriptionGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'name': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'sendWindowStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'sendWindowEndTime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<EventPreferenceDto>; }}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'eventPreferences'?: { [key: string]: Array<EventPreferenceDto>; } | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'selectedDrivers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'selectedVehicles'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'isAllDriversSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'isAllVehiclesSelected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppNotificationsubscriptionGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppPrologsidentityroleGetRequest
 */
export interface ApiAppPrologsidentityroleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppPrologsidentityroleGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppPrologsidentityroleIdDeleteRequest
 */
export interface ApiAppPrologsidentityroleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppPrologsidentityroleIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppPublicapiclientGetRequest
 */
export interface ApiAppPublicapiclientGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppPublicapiclientGetRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest
     */
    'stateIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest
     */
    'stateIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
 */
export interface ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppRoleGetRequest
 */
export interface ApiAppRoleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleGetRequest
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleGetRequest
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleGetRequest
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleGetRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleGetRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleGetRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppRoleGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppRoleIdDeleteRequest
 */
export interface ApiAppRoleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppRoleIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantAcquiretenantadminaccesstokenPostRequest
 */
export interface ApiAppTenantAcquiretenantadminaccesstokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantAcquiretenantadminaccesstokenPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiAppTenantAcquiretenantadminaccesstokenPostRequest
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantGetRequest
 */
export interface ApiAppTenantGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'dbServer': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'dbName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'appUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'webApiUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantGetRequest
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantGetRequest
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'adminName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantGetRequest
     */
    'domainName': string;
}
/**
 * 
 * @export
 * @interface ApiAppTenantIdDeleteRequest
 */
export interface ApiAppTenantIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'domainName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantIdDeleteRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationApproveordenypendingrequestPostRequest
 */
export interface ApiAppTenantregistrationApproveordenypendingrequestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {ApiAppTenantGetRequest}
     * @memberof ApiAppTenantregistrationApproveordenypendingrequestPostRequest
     */
    'tenantInfo'?: ApiAppTenantGetRequest | null;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationGetRequest
 */
export interface ApiAppTenantregistrationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantregistrationGetRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationIdDeleteRequest
 */
export interface ApiAppTenantregistrationIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTenantregistrationIdDeleteRequest
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppTenantregistrationReassigntenantPostRequest
 */
export interface ApiAppTenantregistrationReassigntenantPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationReassigntenantPostRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTenantregistrationReassigntenantPostRequest
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppTrailerGetRequest
 */
export interface ApiAppTrailerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppTrailerGetRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppTrailerGetRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppTrailerGetRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerGetRequest
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppTrailerGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailerGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTrailerIdDeleteRequest
 */
export interface ApiAppTrailerIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailerIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppTrailertrackingproviderGetRequest
 */
export interface ApiAppTrailertrackingproviderGetRequest {
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof ApiAppTrailertrackingproviderGetRequest
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppTrailertrackingproviderGetRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppTrailertrackingproviderIdDeleteRequest
 */
export interface ApiAppTrailertrackingproviderIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'editable'?: boolean;
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiAppTrailertrackingproviderIdDeleteRequest
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsSavePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsSavePostRequest {
    /**
     * 
     * @type {TwoFactorAuthenticationType}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'selectedAuthenticationType'?: TwoFactorAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'authenticatorSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsSavePostRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest
 */
export interface ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface ApiAppUnidentifiedeventsDeleteRequest
 */
export interface ApiAppUnidentifiedeventsDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUnidentifiedeventsDeleteRequest
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiAppUnidentifiedeventsIdGetRequest
 */
export interface ApiAppUnidentifiedeventsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsIdGetRequest
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUnidentifiedeventsIdGetRequest
     */
    'driverId'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppUserpreferenceSaveuserpreferencesPostRequest
 */
export interface ApiAppUserpreferenceSaveuserpreferencesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppUserpreferenceSaveuserpreferencesPostRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUserpreferenceSaveuserpreferencesPostRequest
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppUtilObtainfmcsacredentialsPostRequest
 */
export interface ApiAppUtilObtainfmcsacredentialsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilObtainfmcsacredentialsPostRequest
     */
    'key': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppUtilObtainfmcsacredentialsPostRequest
     */
    'os': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface ApiAppUtilSetmobileappversionPostRequest
 */
export interface ApiAppUtilSetmobileappversionPostRequest {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'os'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobileappversionPostRequest
     */
    'buildNumber'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppUtilSetmobiledeviceinformationPostRequest
 */
export interface ApiAppUtilSetmobiledeviceinformationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'sdkLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'appVersionCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'coarseLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'fineLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'backgroundLocationPermission'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'storageSpace'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'status'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'connectedToEld'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiAppUtilSetmobiledeviceinformationPostRequest
     */
    'deviceTime'?: string | null;
}
/**
 * 
 * @export
 * @interface ApiAppVehicleGetRequest
 */
export interface ApiAppVehicleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppVehicleGetRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleGetRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppVehicleGetRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleGetRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleGetRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehicleGetRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppVehicleGetRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleGetRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppVehicleIdDeleteRequest
 */
export interface ApiAppVehicleIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehicleIdDeleteRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ApiAppVehiclemaintenanceIdDeleteRequest
 */
export interface ApiAppVehiclemaintenanceIdDeleteRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiAppVehiclemaintenanceIdDeleteRequest
     */
    'previousOilChangeId'?: number | null;
}
/**
 * 
 * @export
 * @interface ApiAppVirtualtenantGetvehicledriversPostRequest
 */
export interface ApiAppVirtualtenantGetvehicledriversPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantGetvehicledriversPostRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppVirtualtenantGetvehicledriversPostRequest
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiAppVirtualtenantIdDeleteRequest
 */
export interface ApiAppVirtualtenantIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ApiAppVirtualtenantIdDeleteRequest
     */
    'driverIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ApiClientDto
 */
export interface ApiClientDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'clientId': string;
    /**
     * 
     * @type {number}
     * @memberof ApiClientDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {Array<ApiClientSecretValueDto>}
     * @memberof ApiClientDto
     */
    'deletedSecrets'?: Array<ApiClientSecretValueDto> | null;
    /**
     * 
     * @type {Array<ApiClientSecretDto>}
     * @memberof ApiClientDto
     */
    'secrets'?: Array<ApiClientSecretDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ApiClientDtoPagedResultDto
 */
export interface ApiClientDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ApiClientDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ApiClientDto>}
     * @memberof ApiClientDtoPagedResultDto
     */
    'items'?: Array<ApiClientDto> | null;
}
/**
 * 
 * @export
 * @interface ApiClientSecretDto
 */
export interface ApiClientSecretDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiClientSecretDto
     */
    'isExisting'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ApiClientSecretValueDto
 */
export interface ApiClientSecretValueDto {
    /**
     * 
     * @type {string}
     * @memberof ApiClientSecretValueDto
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ApiFeatureManagementFeaturesGetRequest
 */
export interface ApiFeatureManagementFeaturesGetRequest {
    /**
     * 
     * @type {Array<UpdateFeatureDto>}
     * @memberof ApiFeatureManagementFeaturesGetRequest
     */
    'features'?: Array<UpdateFeatureDto> | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersGetRequest
 */
export interface ApiIdentityUsersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersGetRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersGetRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersGetRequest
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersGetRequest
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiIdentityUsersGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersIdDeleteRequest
 */
export interface ApiIdentityUsersIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiIdentityUsersIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiIdentityUsersIdRolesGetRequest
 */
export interface ApiIdentityUsersIdRolesGetRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiIdentityUsersIdRolesGetRequest
     */
    'roleNames': Array<string>;
}
/**
 * 
 * @export
 * @interface ApiMultiTenancyTenantsGetRequest
 */
export interface ApiMultiTenancyTenantsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'adminPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiMultiTenancyTenantsGetRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiMultiTenancyTenantsIdDeleteRequest
 */
export interface ApiMultiTenancyTenantsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ApiMultiTenancyTenantsIdDeleteRequest
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ApiPermissionManagementPermissionsGetRequest
 */
export interface ApiPermissionManagementPermissionsGetRequest {
    /**
     * 
     * @type {Array<UpdatePermissionDto>}
     * @memberof ApiPermissionManagementPermissionsGetRequest
     */
    'permissions'?: Array<UpdatePermissionDto> | null;
}
/**
 * 
 * @export
 * @interface AppData
 */
export interface AppData {
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'sensorAttributes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'cargoTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'odometerTypes'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<Int32DropDownAppData>; }}
     * @memberof AppData
     */
    'knownDocumentTypes'?: { [key: string]: Array<Int32DropDownAppData>; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'driverTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<CompanyAppData>}
     * @memberof AppData
     */
    'companies'?: Array<CompanyAppData> | null;
    /**
     * 
     * @type {Array<GuidDropDownAppData>}
     * @memberof AppData
     */
    'roles'?: Array<GuidDropDownAppData> | null;
    /**
     * 
     * @type {Array<Int32DropDownAppData>}
     * @memberof AppData
     */
    'fleetManagerGroups'?: Array<Int32DropDownAppData> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'fuelTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerOwnershipTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerSuspensionTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'trailerTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<TerminalTimeZoneAppData>}
     * @memberof AppData
     */
    'terminalTimeZones'?: Array<TerminalTimeZoneAppData> | null;
    /**
     * 
     * @type {Array<RootActionPermissionGroup>}
     * @memberof AppData
     */
    'actionPermissionDefinitions'?: Array<RootActionPermissionGroup> | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof AppData
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {Array<EldDeviceAppData>}
     * @memberof AppData
     */
    'eldDevices'?: Array<EldDeviceAppData> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'violationTypes'?: Array<string> | null;
    /**
     * 
     * @type {AppDataTenant}
     * @memberof AppData
     */
    'tenant'?: AppDataTenant | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'databaseServers'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'dutyStatuses'?: Array<string> | null;
    /**
     * 
     * @type {Array<GuidDropDownAppData>}
     * @memberof AppData
     */
    'tenants'?: Array<GuidDropDownAppData> | null;
    /**
     * 
     * @type {MultiTenancySides}
     * @memberof AppData
     */
    'multiTenancySide'?: MultiTenancySides;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'webAppUrl'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<HosExceptionAppData>; }}
     * @memberof AppData
     */
    'hosExceptions'?: { [key: string]: Array<HosExceptionAppData>; } | null;
    /**
     * 
     * @type {string}
     * @memberof AppData
     */
    'userPreferences'?: string | null;
    /**
     * 
     * @type {Array<CountryAppData>}
     * @memberof AppData
     */
    'countries'?: Array<CountryAppData> | null;
    /**
     * 
     * @type {{ [key: string]: EventTypeCode; }}
     * @memberof AppData
     */
    'eventTypeCodes'?: { [key: string]: EventTypeCode; } | null;
    /**
     * 
     * @type {AppDataCurrentCompanyTimeZone}
     * @memberof AppData
     */
    'currentCompanyTimeZone'?: AppDataCurrentCompanyTimeZone | null;
    /**
     * 
     * @type {AppDataUserPermissions}
     * @memberof AppData
     */
    'userPermissions'?: AppDataUserPermissions | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppData
     */
    'masterAdminExclusivePermissions'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AppDataCurrentCompanyTimeZone
 */
export interface AppDataCurrentCompanyTimeZone {
    /**
     * 
     * @type {string}
     * @memberof AppDataCurrentCompanyTimeZone
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AppDataCurrentCompanyTimeZone
     */
    'utcOffset'?: number;
}
/**
 * 
 * @export
 * @interface AppDataTenant
 */
export interface AppDataTenant {
    /**
     * 
     * @type {string}
     * @memberof AppDataTenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppDataTenant
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppDataTenant
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface AppDataUserPermissions
 */
export interface AppDataUserPermissions {
    /**
     * 
     * @type {string}
     * @memberof AppDataUserPermissions
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGroupDto>}
     * @memberof AppDataUserPermissions
     */
    'actionPermissionGroups'?: Array<ActionPermissionGroupDto> | null;
    /**
     * 
     * @type {Array<FieldPermissionGroupDto>}
     * @memberof AppDataUserPermissions
     */
    'fieldPermissionGroups'?: Array<FieldPermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ApplicationApiDescriptionModel
 */
export interface ApplicationApiDescriptionModel {
    /**
     * 
     * @type {{ [key: string]: ModuleApiDescriptionModel; }}
     * @memberof ApplicationApiDescriptionModel
     */
    'modules'?: { [key: string]: ModuleApiDescriptionModel; } | null;
    /**
     * 
     * @type {{ [key: string]: TypeApiDescriptionModel; }}
     * @memberof ApplicationApiDescriptionModel
     */
    'types'?: { [key: string]: TypeApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationAuthConfigurationDto
 */
export interface ApplicationAuthConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationAuthConfigurationDto
     */
    'policies'?: { [key: string]: boolean; } | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationAuthConfigurationDto
     */
    'grantedPolicies'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDto
 */
export interface ApplicationConfigurationDto {
    /**
     * 
     * @type {ApplicationConfigurationDtoLocalization}
     * @memberof ApplicationConfigurationDto
     */
    'localization'?: ApplicationConfigurationDtoLocalization | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoAuth}
     * @memberof ApplicationConfigurationDto
     */
    'auth'?: ApplicationConfigurationDtoAuth | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoSetting}
     * @memberof ApplicationConfigurationDto
     */
    'setting'?: ApplicationConfigurationDtoSetting | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoCurrentUser}
     * @memberof ApplicationConfigurationDto
     */
    'currentUser'?: ApplicationConfigurationDtoCurrentUser | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoFeatures}
     * @memberof ApplicationConfigurationDto
     */
    'features'?: ApplicationConfigurationDtoFeatures | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoGlobalFeatures}
     * @memberof ApplicationConfigurationDto
     */
    'globalFeatures'?: ApplicationConfigurationDtoGlobalFeatures | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoMultiTenancy}
     * @memberof ApplicationConfigurationDto
     */
    'multiTenancy'?: ApplicationConfigurationDtoMultiTenancy | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoCurrentTenant}
     * @memberof ApplicationConfigurationDto
     */
    'currentTenant'?: ApplicationConfigurationDtoCurrentTenant | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoTiming}
     * @memberof ApplicationConfigurationDto
     */
    'timing'?: ApplicationConfigurationDtoTiming | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoClock}
     * @memberof ApplicationConfigurationDto
     */
    'clock'?: ApplicationConfigurationDtoClock | null;
    /**
     * 
     * @type {ApplicationConfigurationDtoObjectExtensions}
     * @memberof ApplicationConfigurationDto
     */
    'objectExtensions'?: ApplicationConfigurationDtoObjectExtensions | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoAuth
 */
export interface ApplicationConfigurationDtoAuth {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationConfigurationDtoAuth
     */
    'policies'?: { [key: string]: boolean; } | null;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ApplicationConfigurationDtoAuth
     */
    'grantedPolicies'?: { [key: string]: boolean; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoClock
 */
export interface ApplicationConfigurationDtoClock {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoClock
     */
    'kind'?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoCurrentTenant
 */
export interface ApplicationConfigurationDtoCurrentTenant {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentTenant
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoCurrentUser
 */
export interface ApplicationConfigurationDtoCurrentUser {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'isAuthenticated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'impersonatorTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'surName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationConfigurationDtoCurrentUser
     */
    'roles'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoFeatures
 */
export interface ApplicationConfigurationDtoFeatures {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationConfigurationDtoFeatures
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoGlobalFeatures
 */
export interface ApplicationConfigurationDtoGlobalFeatures {
    /**
     * 
     * @type {Set<string>}
     * @memberof ApplicationConfigurationDtoGlobalFeatures
     */
    'enabledFeatures'?: Set<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoLocalization
 */
export interface ApplicationConfigurationDtoLocalization {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'values'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {Array<LanguageInfo>}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languages'?: Array<LanguageInfo> | null;
    /**
     * 
     * @type {ApplicationLocalizationConfigurationDtoCurrentCulture}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'currentCulture'?: ApplicationLocalizationConfigurationDtoCurrentCulture | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'defaultResourceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languagesMap'?: { [key: string]: Array<NameValue>; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationConfigurationDtoLocalization
     */
    'languageFilesMap'?: { [key: string]: Array<NameValue>; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoMultiTenancy
 */
export interface ApplicationConfigurationDtoMultiTenancy {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationConfigurationDtoMultiTenancy
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoObjectExtensions
 */
export interface ApplicationConfigurationDtoObjectExtensions {
    /**
     * 
     * @type {{ [key: string]: ModuleExtensionDto; }}
     * @memberof ApplicationConfigurationDtoObjectExtensions
     */
    'modules'?: { [key: string]: ModuleExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: ExtensionEnumDto; }}
     * @memberof ApplicationConfigurationDtoObjectExtensions
     */
    'enums'?: { [key: string]: ExtensionEnumDto; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoSetting
 */
export interface ApplicationConfigurationDtoSetting {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationConfigurationDtoSetting
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationConfigurationDtoTiming
 */
export interface ApplicationConfigurationDtoTiming {
    /**
     * 
     * @type {TimingDtoTimeZone}
     * @memberof ApplicationConfigurationDtoTiming
     */
    'timeZone'?: TimingDtoTimeZone | null;
}
/**
 * 
 * @export
 * @interface ApplicationFeatureConfigurationDto
 */
export interface ApplicationFeatureConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationFeatureConfigurationDto
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationGlobalFeatureConfigurationDto
 */
export interface ApplicationGlobalFeatureConfigurationDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof ApplicationGlobalFeatureConfigurationDto
     */
    'enabledFeatures'?: Set<string> | null;
}
/**
 * 
 * @export
 * @interface ApplicationLocalizationConfigurationDto
 */
export interface ApplicationLocalizationConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'values'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {Array<LanguageInfo>}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languages'?: Array<LanguageInfo> | null;
    /**
     * 
     * @type {ApplicationLocalizationConfigurationDtoCurrentCulture}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'currentCulture'?: ApplicationLocalizationConfigurationDtoCurrentCulture | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'defaultResourceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languagesMap'?: { [key: string]: Array<NameValue>; } | null;
    /**
     * 
     * @type {{ [key: string]: Array<NameValue>; }}
     * @memberof ApplicationLocalizationConfigurationDto
     */
    'languageFilesMap'?: { [key: string]: Array<NameValue>; } | null;
}
/**
 * 
 * @export
 * @interface ApplicationLocalizationConfigurationDtoCurrentCulture
 */
export interface ApplicationLocalizationConfigurationDtoCurrentCulture {
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'threeLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'twoLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'isRightToLeft'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'nativeName'?: string | null;
    /**
     * 
     * @type {CurrentCultureDtoDateTimeFormat}
     * @memberof ApplicationLocalizationConfigurationDtoCurrentCulture
     */
    'dateTimeFormat'?: CurrentCultureDtoDateTimeFormat | null;
}
/**
 * 
 * @export
 * @interface ApplicationSettingConfigurationDto
 */
export interface ApplicationSettingConfigurationDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApplicationSettingConfigurationDto
     */
    'values'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface ApproveOrDenyTenantRegistrationDto
 */
export interface ApproveOrDenyTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'status'?: TenantRegistrationStatus;
    /**
     * 
     * @type {ApiAppTenantGetRequest}
     * @memberof ApproveOrDenyTenantRegistrationDto
     */
    'tenantInfo'?: ApiAppTenantGetRequest | null;
}
/**
 * 
 * @export
 * @interface AssignEventsDto
 */
export interface AssignEventsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignEventsDto
     */
    'eventIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AssignEventsDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignEventsDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignEventsDto
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface AssignToTenantInputDto
 */
export interface AssignToTenantInputDto {
    /**
     * 
     * @type {string}
     * @memberof AssignToTenantInputDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignToTenantInputDto
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AssignUnidentifiedEventDto
 */
export interface AssignUnidentifiedEventDto {
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventDto
     */
    'driverId'?: number;
}
/**
 * 
 * @export
 * @interface AssignUnidentifiedEventsDto
 */
export interface AssignUnidentifiedEventsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignUnidentifiedEventsDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof AssignUnidentifiedEventsDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignUnidentifiedEventsDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignUnidentifiedEventsDto
     */
    'shouldAssignImmediately'?: boolean;
}
/**
 * 
 * @export
 * @interface AverageIdleTimeDto
 */
export interface AverageIdleTimeDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'nightValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AverageIdleTimeDto
     */
    'morningValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AxleStatusDto
 */
export interface AxleStatusDto {
    /**
     * 
     * @type {number}
     * @memberof AxleStatusDto
     */
    'axle'?: number;
    /**
     * 
     * @type {Array<TireStatusDto>}
     * @memberof AxleStatusDto
     */
    'tires'?: Array<TireStatusDto> | null;
}
/**
 * 
 * @export
 * @interface BareVehicleLocationDto
 */
export interface BareVehicleLocationDto {
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof BareVehicleLocationDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BareVehicleLocationDto
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseSearchListDto
 */
export interface BaseSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof BaseSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface BestGeolocationCoordinatesOutput
 */
export interface BestGeolocationCoordinatesOutput {
    /**
     * 
     * @type {number}
     * @memberof BestGeolocationCoordinatesOutput
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof BestGeolocationCoordinatesOutput
     */
    'lng': number;
}
/**
 * 
 * @export
 * @interface BulkSetCoDriverInputDto
 */
export interface BulkSetCoDriverInputDto {
    /**
     * 
     * @type {number}
     * @memberof BulkSetCoDriverInputDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetCoDriverInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetCoDriverInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetShippingDocsInputDto
 */
export interface BulkSetShippingDocsInputDto {
    /**
     * 
     * @type {string}
     * @memberof BulkSetShippingDocsInputDto
     */
    'shippingDocs'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetShippingDocsInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetShippingDocsInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetTrailersInputDto
 */
export interface BulkSetTrailersInputDto {
    /**
     * 
     * @type {string}
     * @memberof BulkSetTrailersInputDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetTrailersInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetTrailersInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkSetVehicleInputDto
 */
export interface BulkSetVehicleInputDto {
    /**
     * 
     * @type {number}
     * @memberof BulkSetVehicleInputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkSetVehicleInputDto
     */
    'selectedEvents': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkSetVehicleInputDto
     */
    'isLatestEventSelected'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CargoType = {
    Property: 'Property',
    Passenger: 'Passenger'
} as const;

export type CargoType = typeof CargoType[keyof typeof CargoType];


/**
 * 
 * @export
 * @interface CertifyLogDateInputDto
 */
export interface CertifyLogDateInputDto {
    /**
     * 
     * @type {number}
     * @memberof CertifyLogDateInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CertifyLogDateInputDto
     */
    'logDate'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordDemoAccountInputDto
 */
export interface ChangePasswordDemoAccountInputDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDemoAccountInputDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDemoAccountInputDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordInput
 */
export interface ChangePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'currentPassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordInputDto
 */
export interface ChangePasswordInputDto {
    /**
     * 
     * @type {number}
     * @memberof ChangePasswordInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInputDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ClockDto
 */
export interface ClockDto {
    /**
     * 
     * @type {string}
     * @memberof ClockDto
     */
    'kind'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyAppData
 */
export interface CompanyAppData {
    /**
     * 
     * @type {CompanyAppDataDefaultHosData}
     * @memberof CompanyAppData
     */
    'defaultHosData'?: CompanyAppDataDefaultHosData | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyAppDataDefaultHosData
 */
export interface CompanyAppDataDefaultHosData {
    /**
     * 
     * @type {string}
     * @memberof CompanyAppDataDefaultHosData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'twentyFourHourCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAppDataDefaultHosData
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CompanyAppDataDefaultHosData
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CompanyAppDataDefaultHosData
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {Array<EntityCycleRules>}
     * @memberof CompanyAppDataDefaultHosData
     */
    'cycleRules'?: Array<EntityCycleRules> | null;
}
/**
 * 
 * @export
 * @interface CompanyDto
 */
export interface CompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof CompanyDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof CompanyDto
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<DutyCycleDto>}
     * @memberof CompanyDto
     */
    'dutyCycles'?: Array<DutyCycleDto> | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof CompanyDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyDtoPagedResultDto
 */
export interface CompanyDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CompanyDto>}
     * @memberof CompanyDtoPagedResultDto
     */
    'items'?: Array<CompanyDto> | null;
}
/**
 * 
 * @export
 * @interface CompanyDtoState
 */
export interface CompanyDtoState {
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoState
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDtoState
     */
    'icon'?: string | null;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof CompanyDtoState
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDtoState
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyListDto
 */
export interface CompanyListDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyListDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CompanyListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CompanyListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CompanyListDtoPagedResultDto
 */
export interface CompanyListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CompanyListDto>}
     * @memberof CompanyListDtoPagedResultDto
     */
    'items'?: Array<CompanyListDto> | null;
}
/**
 * 
 * @export
 * @interface ControllerApiDescriptionModel
 */
export interface ControllerApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'controllerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'controllerGroupName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControllerApiDescriptionModel
     */
    'isRemoteService'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'apiVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControllerApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {Array<ControllerInterfaceApiDescriptionModel>}
     * @memberof ControllerApiDescriptionModel
     */
    'interfaces'?: Array<ControllerInterfaceApiDescriptionModel> | null;
    /**
     * 
     * @type {{ [key: string]: ActionApiDescriptionModel; }}
     * @memberof ControllerApiDescriptionModel
     */
    'actions'?: { [key: string]: ActionApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ControllerInterfaceApiDescriptionModel
 */
export interface ControllerInterfaceApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ControllerInterfaceApiDescriptionModel
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface CountryAppData
 */
export interface CountryAppData {
    /**
     * 
     * @type {Array<StateAppData>}
     * @memberof CountryAppData
     */
    'states'?: Array<StateAppData> | null;
    /**
     * 
     * @type {Array<Int32DropDownAppData>}
     * @memberof CountryAppData
     */
    'dutyCycles'?: Array<Int32DropDownAppData> | null;
    /**
     * 
     * @type {number}
     * @memberof CountryAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountryDto
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CountryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateBatchEventsDto
 */
export interface CreateBatchEventsDto {
    /**
     * 
     * @type {Array<CreateOrUpdateEventDto>}
     * @memberof CreateBatchEventsDto
     */
    'events'?: Array<CreateOrUpdateEventDto> | null;
}
/**
 * 
 * @export
 * @interface CreateChangeRequestEvent
 */
export interface CreateChangeRequestEvent {
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'time'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'notes'?: string | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof CreateChangeRequestEvent
     */
    'origin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'state'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'country'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'minTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'maxTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChangeRequestEvent
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChangeRequestEvent
     */
    'totalVehicleMiles'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateCompanyDto
 */
export interface CreateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof CreateCompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof CreateCompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CreateCompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateCompanyDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateCompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateDemoAccountDto
 */
export interface CreateDemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDemoAccountDto
     */
    'tenantId': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDemoAccountDto
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface CreateDocumentForEntityDto
 */
export interface CreateDocumentForEntityDto {
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'entityType': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'entityId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentForEntityDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentForEntityDto
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDriverDto
 */
export interface CreateDriverDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof CreateDriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof CreateDriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverDto
     */
    'password': string;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof CreateDriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateDriverDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDriverDto
     */
    'hideUnidentifiedEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDvirFormDto
 */
export interface CreateDvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof CreateDvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateDvirFormDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateDvirReportDto
 */
export interface CreateDvirReportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof CreateDvirReportDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirReportDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'trailerNames'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDvirReportDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDvirReportDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {Array<DvirDefectDto>}
     * @memberof CreateDvirReportDto
     */
    'defects'?: Array<DvirDefectDto> | null;
}
/**
 * 
 * @export
 * @interface CreateEldDeviceDto
 */
export interface CreateEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateEldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateEldDisconnectionDto
 */
export interface CreateEldDisconnectionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEldDisconnectionDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEldDisconnectionDto
     */
    'time'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEldDisconnectionDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateEldDisconnectionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateEventOutputDto
 */
export interface CreateEventOutputDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEventOutputDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventOutputDto
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventOutputDto
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateFleetManagerDto
 */
export interface CreateFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateFleetManagerDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateFleetManagerDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateFleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateFleetManagerDto
     */
    'groupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateFmcsaInspectionDto
 */
export interface CreateFmcsaInspectionDto {
    /**
     * 
     * @type {number}
     * @memberof CreateFmcsaInspectionDto
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFmcsaInspectionDto
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'base64EncodedEldFileContents': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFmcsaInspectionDto
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFmcsaInspectionDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof CreateFmcsaInspectionDto
     */
    'mobileAppType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface CreateFuelProviderDto
 */
export interface CreateFuelProviderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof CreateFuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateLiveTrackTokenDto
 */
export interface CreateLiveTrackTokenDto {
    /**
     * 
     * @type {number}
     * @memberof CreateLiveTrackTokenDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveTrackTokenDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveTrackTokenDto
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface CreateMasterEldDeviceDto
 */
export interface CreateMasterEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateMasterEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateMasterEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMasterEldDeviceDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMasterEldDeviceDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEldDeviceDto
     */
    'deviceName'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateMasterEventInput
 */
export interface CreateMasterEventInput {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'accumulatedVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'elapsedEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof CreateMasterEventInput
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMasterEventInput
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterEventInput
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateMasterFleetManagerDto
 */
export interface CreateMasterFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterFleetManagerDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateMasterFleetManagerDto
     */
    'status'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface CreateMultipleMasterEldDevicesDto
 */
export interface CreateMultipleMasterEldDevicesDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'uploadInfoId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'hasHeader'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'serialNumberColumnIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMultipleMasterEldDevicesDto
     */
    'macAddressColumnIndex'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateOrUpdateEventDto
 */
export interface CreateOrUpdateEventDto {
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'dutyStatusId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventSequenceIdNumber': string;
    /**
     * 
     * @type {EventRecordStatus}
     * @memberof CreateOrUpdateEventDto
     */
    'eventRecordStatus'?: EventRecordStatus | null;
    /**
     * 
     * @type {EventRecordOrigin}
     * @memberof CreateOrUpdateEventDto
     */
    'eventRecordOrigin'?: EventRecordOrigin | null;
    /**
     * 
     * @type {EventType}
     * @memberof CreateOrUpdateEventDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'totalEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'distanceSinceLastValidCoordinates'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEventDto
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventDataCheckValue': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'direction': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEventDto
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'reasonForEdit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'recordOriginator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEventDto
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof CreateOrUpdateEventDto
     */
    'totalVehicleMilesSource'?: OdometerSource | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrUpdateEventDto
     */
    'dvirId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CreateRoleDto
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CreateRoleDto
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'dbServer': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'dbName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'appUrl': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'webApiUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantDto
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'adminName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantDto
     */
    'domainName': string;
}
/**
 * 
 * @export
 * @interface CreateTenantRegistrationDto
 */
export interface CreateTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateTrailerDto
 */
export interface CreateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof CreateTrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof CreateTrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof CreateTrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateTrailerDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateTrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateTrailerTrackingProviderDto
 */
export interface CreateTrailerTrackingProviderDto {
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof CreateTrailerTrackingProviderDto
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateTrailerTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateUpdateGroupDto
 */
export interface CreateUpdateGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateGroupDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateGroupDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUpdateGroupDto
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CreateVehicleDto
 */
export interface CreateVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof CreateVehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof CreateVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof CreateVehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof CreateVehicleDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateVehicleMaintenanceDto
 */
export interface CreateVehicleMaintenanceDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateVehicleMaintenanceDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVehicleMaintenanceDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateVehicleMaintenanceDto
     */
    'previousOilChangeId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateVirtualTenantDto
 */
export interface CreateVirtualTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVirtualTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof CreateVirtualTenantDto
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateVirtualTenantDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateVirtualTenantDto
     */
    'driverIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CurrentCultureDto
 */
export interface CurrentCultureDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'englishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'threeLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'twoLetterIsoLanguageName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentCultureDto
     */
    'isRightToLeft'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDto
     */
    'nativeName'?: string | null;
    /**
     * 
     * @type {CurrentCultureDtoDateTimeFormat}
     * @memberof CurrentCultureDto
     */
    'dateTimeFormat'?: CurrentCultureDtoDateTimeFormat | null;
}
/**
 * 
 * @export
 * @interface CurrentCultureDtoDateTimeFormat
 */
export interface CurrentCultureDtoDateTimeFormat {
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'calendarAlgorithmType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'dateTimeFormatLong'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'shortDatePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'fullDateTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'dateSeparator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'shortTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentCultureDtoDateTimeFormat
     */
    'longTimePattern'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentLocationDto
 */
export interface CurrentLocationDto {
    /**
     * 
     * @type {VehicleIgnitionStatus}
     * @memberof CurrentLocationDto
     */
    'ignitionStatus'?: VehicleIgnitionStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'safetyStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'healthStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'violationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'geometrisSafetyEventsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'diagnosticRecordsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDto
     */
    'eldConnected'?: boolean | null;
    /**
     * 
     * @type {CurrentLocationDtoHosDetails}
     * @memberof CurrentLocationDto
     */
    'hosDetails'?: CurrentLocationDtoHosDetails | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof CurrentLocationDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDto
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentLocationDtoHosDetails
 */
export interface CurrentLocationDtoHosDetails {
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrentLocationDtoHosDetails
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDtoHosDetails
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentLocationDtoHosDetails
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentLocationDtoHosDetails
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface CurrentTenantDto
 */
export interface CurrentTenantDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentTenantDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentTenantDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface CurrentTimeZoneInfoDto
 */
export interface CurrentTimeZoneInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentTimeZoneInfoDto
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CurrentTimeZoneInfoDto
     */
    'utcOffset'?: number;
}
/**
 * 
 * @export
 * @interface CurrentUserDto
 */
export interface CurrentUserDto {
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'isAuthenticated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'impersonatorTenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'surName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserDto
     */
    'roles'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CustomerEldDevicesViewList
 */
export interface CustomerEldDevicesViewList {
    /**
     * 
     * @type {number}
     * @memberof CustomerEldDevicesViewList
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerEldDevicesViewList
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerEldDevicesViewList
     */
    'assignedToCustomer'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomerEldDevicesViewListPagedResultDto
 */
export interface CustomerEldDevicesViewListPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerEldDevicesViewListPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<CustomerEldDevicesViewList>}
     * @memberof CustomerEldDevicesViewListPagedResultDto
     */
    'items'?: Array<CustomerEldDevicesViewList> | null;
}
/**
 * 
 * @export
 * @interface CycleRuleDto
 */
export interface CycleRuleDto {
    /**
     * 
     * @type {number}
     * @memberof CycleRuleDto
     */
    'drivingCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CycleRuleDto
     */
    'cycleRuleId'?: number;
}
/**
 * 
 * @export
 * @interface DailyLogReportInput
 */
export interface DailyLogReportInput {
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'graphHtml'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DailyLogReportInput
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DailyLogReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface DailyLogSummary
 */
export interface DailyLogSummary {
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'remainingWorkingMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'minutesGainedAfterToday'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyLogSummary
     */
    'isCurrentDay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DailyLogSummary
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'workingHours'?: string;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'workingMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogSummary
     */
    'totalWorkingHours'?: string;
    /**
     * 
     * @type {number}
     * @memberof DailyLogSummary
     */
    'totalWorkingMinutes'?: number;
}
/**
 * 
 * @export
 * @interface DailyLogsReportInput
 */
export interface DailyLogsReportInput {
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DailyLogsReportInput
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyLogsReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface DailyRefuelDto
 */
export interface DailyRefuelDto {
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'customProviderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DailyRefuelDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof DailyRefuelDto
     */
    'provider'?: FuelProviders | null;
    /**
     * 
     * @type {boolean}
     * @memberof DailyRefuelDto
     */
    'isFromProvider'?: boolean;
}
/**
 * 
 * @export
 * @interface DashboardDriverDto
 */
export interface DashboardDriverDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverId': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'vehicleNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverDto
     */
    'lastActivity'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverDto
     */
    'lastGeolocation'?: string | null;
}
/**
 * 
 * @export
 * @interface DashboardDriverHosEventsOutput
 */
export interface DashboardDriverHosEventsOutput {
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverHosEventsOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDriverHosEventsOutput
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardDriverHosEventsOutput
     */
    'hoursToday'?: number;
    /**
     * 
     * @type {Array<EventViewDto>}
     * @memberof DashboardDriverHosEventsOutput
     */
    'basicEvents'?: Array<EventViewDto> | null;
}
/**
 * 
 * @export
 * @interface DateTimeFormatDto
 */
export interface DateTimeFormatDto {
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'calendarAlgorithmType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'dateTimeFormatLong'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'shortDatePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'fullDateTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'dateSeparator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'shortTimePattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateTimeFormatDto
     */
    'longTimePattern'?: string | null;
}
/**
 * 
 * @export
 * @interface DefaultHosData
 */
export interface DefaultHosData {
    /**
     * 
     * @type {string}
     * @memberof DefaultHosData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'twentyFourHourCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultHosData
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof DefaultHosData
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DefaultHosData
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {Array<EntityCycleRules>}
     * @memberof DefaultHosData
     */
    'cycleRules'?: Array<EntityCycleRules> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DefectCorrectedStatus = {
    Corrected: 'Corrected',
    NoNeedToCorrect: 'NoNeedToCorrect'
} as const;

export type DefectCorrectedStatus = typeof DefectCorrectedStatus[keyof typeof DefectCorrectedStatus];


/**
 * 
 * @export
 * @interface DemoAccountDto
 */
export interface DemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DemoAccountListDto
 */
export interface DemoAccountListDto {
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemoAccountListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemoAccountListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface DemoAccountListDtoPagedResultDto
 */
export interface DemoAccountListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DemoAccountListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DemoAccountListDto>}
     * @memberof DemoAccountListDtoPagedResultDto
     */
    'items'?: Array<DemoAccountListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeviceType = {
    Invalid: 'Invalid',
    Series87: 'Series87',
    Series88: 'Series88',
    PacificTrack30: 'PacificTrack30',
    PacificTrack40: 'PacificTrack40'
} as const;

export type DeviceType = typeof DeviceType[keyof typeof DeviceType];


/**
 * 
 * @export
 * @interface DeviceUsageDetail
 */
export interface DeviceUsageDetail {
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'endTime'?: string;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof DeviceUsageDetail
     */
    'usageType'?: EldDeviceUsageType;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageDetail
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageOutput
 */
export interface DeviceUsageOutput {
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceUsageOutput
     */
    'tenantId'?: string;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof DeviceUsageOutput
     */
    'currentStatus'?: EldDeviceUsageType;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceUsageOutput
     */
    'used'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceUsageOutput
     */
    'usedInVehicles'?: Array<string> | null;
    /**
     * 
     * @type {Array<DeviceUsageDetail>}
     * @memberof DeviceUsageOutput
     */
    'usage'?: Array<DeviceUsageDetail> | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageOutputPagedResultDto
 */
export interface DeviceUsageOutputPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageOutputPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DeviceUsageOutput>}
     * @memberof DeviceUsageOutputPagedResultDto
     */
    'items'?: Array<DeviceUsageOutput> | null;
}
/**
 * 
 * @export
 * @interface DeviceUsageSummary
 */
export interface DeviceUsageSummary {
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageSummary
     */
    'totalDevicesUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceUsageSummary
     */
    'totalDevicesUsedInVehicles'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiagnosticCodeType = {
    J1939: 'J1939',
    J1708: 'J1708',
    Obd2: 'Obd2'
} as const;

export type DiagnosticCodeType = typeof DiagnosticCodeType[keyof typeof DiagnosticCodeType];


/**
 * 
 * @export
 * @interface DiagnosticRecordListDto
 */
export interface DiagnosticRecordListDto {
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'dtcSourceCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'dtcSourceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'spnCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'fmiCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'oc'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiagnosticRecordListDto
     */
    'acknowledged'?: boolean;
    /**
     * 
     * @type {DiagnosticCodeType}
     * @memberof DiagnosticRecordListDto
     */
    'type'?: DiagnosticCodeType;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticRecordListDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DiagnosticRecordListDtoPagedResultDto
 */
export interface DiagnosticRecordListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DiagnosticRecordListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DiagnosticRecordListDto>}
     * @memberof DiagnosticRecordListDtoPagedResultDto
     */
    'items'?: Array<DiagnosticRecordListDto> | null;
}
/**
 * 
 * @export
 * @interface DiagnosticResponse
 */
export interface DiagnosticResponse {
    /**
     * 
     * @type {string}
     * @memberof DiagnosticResponse
     */
    'boradcast'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiagnosticResponse
     */
    'detail'?: string | null;
    /**
     * 
     * @type {DiagnosticResponseStatus}
     * @memberof DiagnosticResponse
     */
    'status'?: DiagnosticResponseStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiagnosticResponseStatus = {
    Success: 'Success',
    InvalidRegistrationData: 'InvalidRegistrationData',
    EldDecertified: 'ELDDecertified',
    UnexpectedError: 'UnexpectedError',
    ExpiredCertificate: 'ExpiredCertificate'
} as const;

export type DiagnosticResponseStatus = typeof DiagnosticResponseStatus[keyof typeof DiagnosticResponseStatus];


/**
 * 
 * @export
 * @interface DocumentCreateOrUpdateDto
 */
export interface DocumentCreateOrUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentCreateOrUpdateDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentCreateOrUpdateDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentCreateOrUpdateDto
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'documentNameId'?: number | null;
    /**
     * 
     * @type {DocumentDtoDocumentName}
     * @memberof DocumentDto
     */
    'documentName'?: DocumentDtoDocumentName | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DocumentDtoDocumentName
 */
export interface DocumentDtoDocumentName {
    /**
     * 
     * @type {string}
     * @memberof DocumentDtoDocumentName
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDtoDocumentName
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDtoDocumentName
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DocumentListDto
 */
export interface DocumentListDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentListDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentListDto
     */
    'id'?: number;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DocumentListDto
     */
    'documents'?: Array<DocumentDto> | null;
}
/**
 * 
 * @export
 * @interface DocumentListDtoPagedResultDto
 */
export interface DocumentListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DocumentListDto>}
     * @memberof DocumentListDtoPagedResultDto
     */
    'items'?: Array<DocumentListDto> | null;
}
/**
 * 
 * @export
 * @interface DocumentNameDto
 */
export interface DocumentNameDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentNameDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentNameDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentNameDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverActivityDto
 */
export interface DriverActivityDto {
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverActivityDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverActivityDto
     */
    'hasViolations'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'lastSync'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverActivityDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverActivityDto
     */
    'driverStatus'?: RecordStatus;
}
/**
 * 
 * @export
 * @interface DriverActivityDtoPagedResultDto
 */
export interface DriverActivityDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverActivityDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverActivityDto>}
     * @memberof DriverActivityDtoPagedResultDto
     */
    'items'?: Array<DriverActivityDto> | null;
}
/**
 * 
 * @export
 * @interface DriverAdvancedSearchListDto
 */
export interface DriverAdvancedSearchListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverAdvancedSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogInput
 */
export interface DriverDailyLogInput {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogInput
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecap
 */
export interface DriverDailyLogRecap {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecap
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecap
     */
    'cycleWorkingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecap
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {Array<DailyLogSummary>}
     * @memberof DriverDailyLogRecap
     */
    'days'?: Array<DailyLogSummary> | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecapResult
 */
export interface DriverDailyLogRecapResult {
    /**
     * 
     * @type {DriverDailyLogRecapResultResult}
     * @memberof DriverDailyLogRecapResult
     */
    'result'?: DriverDailyLogRecapResultResult | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResult
     */
    'eventId'?: number | null;
}
/**
 * 
 * @export
 * @interface DriverDailyLogRecapResultResult
 */
export interface DriverDailyLogRecapResultResult {
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleWorkingHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverDailyLogRecapResultResult
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {Array<DailyLogSummary>}
     * @memberof DriverDailyLogRecapResultResult
     */
    'days'?: Array<DailyLogSummary> | null;
}
/**
 * 
 * @export
 * @interface DriverDto
 */
export interface DriverDto {
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof DriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DriverDto
     */
    'licenceCountry'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof DriverDto
     */
    'licenceState'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {DriverDtoCompany}
     * @memberof DriverDto
     */
    'company'?: DriverDtoCompany | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof DriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DriverDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDto
     */
    'editable'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverDtoCompany
 */
export interface DriverDtoCompany {
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoCompany
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DriverDtoCompany
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoCompany
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof DriverDtoCompany
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverDtoCompany
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof DriverDtoCompany
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoCompany
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoCompany
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoCompany
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof DriverDtoCompany
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoCompany
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<DutyCycleDto>}
     * @memberof DriverDtoCompany
     */
    'dutyCycles'?: Array<DutyCycleDto> | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof DriverDtoCompany
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DriverDtoCompany
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverDtoCompany
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DriverDtoCompany
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverDtoCompany
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverDtoPagedResultDto
 */
export interface DriverDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverDto>}
     * @memberof DriverDtoPagedResultDto
     */
    'items'?: Array<DriverDto> | null;
}
/**
 * 
 * @export
 * @interface DriverFmcsaInspectionDto
 */
export interface DriverFmcsaInspectionDto {
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverFmcsaInspectionDto
     */
    'reportTimeTo'?: string;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsBreakdownDto
 */
export interface DriverHarshEventsBreakdownDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshAccelerationEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshBrakeEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshTurnEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'harshStopEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'speedingEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsBreakdownDto
     */
    'physicalEldDisconnectionEvents'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsSummaryDto
 */
export interface DriverHarshEventsSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsSummaryDto
     */
    'operator'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverHarshEventsSummaryDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsSummaryDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHarshEventsSummaryDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsSummaryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsTotalDto
 */
export interface DriverHarshEventsTotalDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshBrakes'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshTurns'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshAccelerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'speedingOccurrences'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'harshStops'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsTotalDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHarshEventsTotalDto
     */
    'operator'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverHarshEventsTotalDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHarshEventsTotalDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverHarshEventsTotalDtoPagedResultDto
 */
export interface DriverHarshEventsTotalDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverHarshEventsTotalDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverHarshEventsTotalDto>}
     * @memberof DriverHarshEventsTotalDtoPagedResultDto
     */
    'items'?: Array<DriverHarshEventsTotalDto> | null;
}
/**
 * 
 * @export
 * @interface DriverHistoryStatusInfoDto
 */
export interface DriverHistoryStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverHistoryStatusInfoDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverHistoryStatusInfoDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverHistoryStatusInfoDto
     */
    'mobileAppType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverHistoryStatusInfoDto
     */
    'trailerNumbers'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverListDto
 */
export interface DriverListDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'drivingCycles'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'multiAccount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'personalAllowed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DriverListDto
     */
    'yardMoveAllowed'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverListDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverListDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverListDtoPagedResultDto
 */
export interface DriverListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverListDto>}
     * @memberof DriverListDtoPagedResultDto
     */
    'items'?: Array<DriverListDto> | null;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedView
 */
export interface DriverLogDetailedView {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'windowsHomeTerminalZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'hoursToday'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'driverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {Array<ViolationViewDto>}
     * @memberof DriverLogDetailedView
     */
    'violations'?: Array<ViolationViewDto> | null;
    /**
     * 
     * @type {Array<EventViewDto>}
     * @memberof DriverLogDetailedView
     */
    'events'?: Array<EventViewDto> | null;
    /**
     * 
     * @type {Array<DriverViewDto>}
     * @memberof DriverLogDetailedView
     */
    'coDrivers'?: Array<DriverViewDto> | null;
    /**
     * 
     * @type {Array<VehicleViewDto>}
     * @memberof DriverLogDetailedView
     */
    'vehicles'?: Array<VehicleViewDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'odometerUnits'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'reassignInProgress'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'companyAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedView
     */
    'minutesWorked'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'cycleRule'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'trailers'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'shippingDocs'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogDetailedView
     */
    'pendingShippingDocs'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'nextLogDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'previousLogDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'certified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'signature'?: string | null;
    /**
     * 
     * @type {Array<InspectionReportViewDto>}
     * @memberof DriverLogDetailedView
     */
    'inspectionReports'?: Array<InspectionReportViewDto> | null;
    /**
     * 
     * @type {Array<ExceptionViewDto>}
     * @memberof DriverLogDetailedView
     */
    'exceptions'?: Array<ExceptionViewDto> | null;
    /**
     * 
     * @type {CurrentLocationDtoHosDetails}
     * @memberof DriverLogDetailedView
     */
    'hosDetails'?: CurrentLocationDtoHosDetails | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'cycleBreak'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'shiftBreak'?: string | null;
    /**
     * 
     * @type {DriverLogDetailedViewDriverFmcsaInspection}
     * @memberof DriverLogDetailedView
     */
    'driverFmcsaInspection'?: DriverLogDetailedViewDriverFmcsaInspection | null;
    /**
     * 
     * @type {Array<DailyRefuelDto>}
     * @memberof DriverLogDetailedView
     */
    'refuels'?: Array<DailyRefuelDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedView
     */
    'firstEventTime'?: string | null;
    /**
     * 
     * @type {DriverLogDetailedViewEngineOnEventData}
     * @memberof DriverLogDetailedView
     */
    'engineOnEventData'?: DriverLogDetailedViewEngineOnEventData | null;
    /**
     * 
     * @type {DriverLogDetailedViewEngineOnEventData}
     * @memberof DriverLogDetailedView
     */
    'engineOnEventDataInnerEvents'?: DriverLogDetailedViewEngineOnEventData | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'isEngineOffFirstEvent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogDetailedView
     */
    'isEngineOffInnerEvents'?: boolean;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedViewDriverFmcsaInspection
 */
export interface DriverLogDetailedViewDriverFmcsaInspection {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewDriverFmcsaInspection
     */
    'reportTimeTo'?: string;
}
/**
 * 
 * @export
 * @interface DriverLogDetailedViewEngineOnEventData
 */
export interface DriverLogDetailedViewEngineOnEventData {
    /**
     * 
     * @type {string}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogDetailedViewEngineOnEventData
     */
    'totalEngineHours'?: number | null;
}
/**
 * 
 * @export
 * @interface DriverLogEventTimeRange
 */
export interface DriverLogEventTimeRange {
    /**
     * 
     * @type {string}
     * @memberof DriverLogEventTimeRange
     */
    'min'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverLogEventTimeRange
     */
    'max'?: string;
}
/**
 * 
 * @export
 * @interface DriverLogGridViewDto
 */
export interface DriverLogGridViewDto {
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'distanceInMiles'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'timeWorked'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'minutesWorked'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'hasInspectionReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'defectsFound'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverLogGridViewDto
     */
    'certified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverLogGridViewDto
     */
    'timeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDto
     */
    'timeZoneOffset'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DriverLogGridViewDto
     */
    'violations'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DriverLogGridViewDtoPagedResultDto
 */
export interface DriverLogGridViewDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverLogGridViewDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverLogGridViewDto>}
     * @memberof DriverLogGridViewDtoPagedResultDto
     */
    'items'?: Array<DriverLogGridViewDto> | null;
}
/**
 * 
 * @export
 * @interface DriverPasswordOutput
 */
export interface DriverPasswordOutput {
    /**
     * 
     * @type {string}
     * @memberof DriverPasswordOutput
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverPasswordOutput
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverPerformaceDto
 */
export interface DriverPerformaceDto {
    /**
     * 
     * @type {string}
     * @memberof DriverPerformaceDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {Array<DriverPerformanceItemDto>}
     * @memberof DriverPerformaceDto
     */
    'data'?: Array<DriverPerformanceItemDto> | null;
}
/**
 * 
 * @export
 * @interface DriverPerformanceItemDto
 */
export interface DriverPerformanceItemDto {
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverPerformanceItemDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'numberOfHarshEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverPerformanceItemDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverPerformanceItemDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriverPerformanceItemDto
     */
    'rank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof DriverPerformanceItemDto
     */
    'rankStatus'?: RankStatus;
    /**
     * 
     * @type {string}
     * @memberof DriverPerformanceItemDto
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverProfileCycleDto
 */
export interface DriverProfileCycleDto {
    /**
     * 
     * @type {string}
     * @memberof DriverProfileCycleDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverProfileCycleDto
     */
    'cycleDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverProfileCycleDto
     */
    'cycleHours'?: number;
}
/**
 * 
 * @export
 * @interface DriverProfileDto
 */
export interface DriverProfileDto {
    /**
     * 
     * @type {number}
     * @memberof DriverProfileDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'licenceState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierDotNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierStateAbbreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'carrierPostalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'isExempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverProfileDto
     */
    'exemptReason'?: string | null;
    /**
     * 
     * @type {Array<DriverProfileCycleDto>}
     * @memberof DriverProfileDto
     */
    'cycles'?: Array<DriverProfileCycleDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverProfileDto
     */
    'hideUnidentified'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DriverQuickSearchListDto
 */
export interface DriverQuickSearchListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverQuickSearchListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverQuickSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverQuickSearchListDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverScoresOutput
 */
export interface DriverScoresOutput {
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'good'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'goodPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'satisfactory'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'satisfactoryPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'critical'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverScoresOutput
     */
    'criticalPercentage'?: number;
}
/**
 * 
 * @export
 * @interface DriverSpeedingEventDetailsDto
 */
export interface DriverSpeedingEventDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'currentVehicleDriverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventDetailsDto
     */
    'drivingSpeed'?: number;
}
/**
 * 
 * @export
 * @interface DriverSpeedingEventsSummaryDto
 */
export interface DriverSpeedingEventsSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverAssignedId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'speedingEventsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriverSpeedingEventsSummaryDto
     */
    'maxDrivingSpeed'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DriverType = {
    CompanyDriver: 'CompanyDriver',
    OwnerOperator: 'OwnerOperator',
    DrivingForOwner: 'DrivingForOwner'
} as const;

export type DriverType = typeof DriverType[keyof typeof DriverType];


/**
 * 
 * @export
 * @interface DriverVehicleIdAndMobileAppTypeDto
 */
export interface DriverVehicleIdAndMobileAppTypeDto {
    /**
     * 
     * @type {number}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'mobileApplicationType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof DriverVehicleIdAndMobileAppTypeDto
     */
    'ianaTimeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverViewDto
 */
export interface DriverViewDto {
    /**
     * 
     * @type {number}
     * @memberof DriverViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriverViewDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface DriverViewListDto
 */
export interface DriverViewListDto {
    /**
     * 
     * @type {string}
     * @memberof DriverViewListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriverViewListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof DriverViewListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriverViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriverViewListDtoPagedResultDto
 */
export interface DriverViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriverViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriverViewListDto>}
     * @memberof DriverViewListDtoPagedResultDto
     */
    'items'?: Array<DriverViewListDto> | null;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionDto
 */
export interface DriversFuelConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'fuelConsumptionAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'speedingFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'accelerationFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'idleFuelConsumption'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'maxFuelConsumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'minFuelConsumption'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriversFuelConsumptionDto
     */
    'eventScale'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DriversFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriversFuelConsumptionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionDtoPagedResultDto
 */
export interface DriversFuelConsumptionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DriversFuelConsumptionDto>}
     * @memberof DriversFuelConsumptionDtoPagedResultDto
     */
    'items'?: Array<DriversFuelConsumptionDto> | null;
}
/**
 * 
 * @export
 * @interface DriversFuelConsumptionInputDto
 */
export interface DriversFuelConsumptionInputDto {
    /**
     * 
     * @type {PeriodType}
     * @memberof DriversFuelConsumptionInputDto
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionInputDto
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriversFuelConsumptionInputDto
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DriversFuelConsumptionInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface DriversVehicleUsageListDto
 */
export interface DriversVehicleUsageListDto {
    /**
     * 
     * @type {number}
     * @memberof DriversVehicleUsageListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DriversVehicleUsageListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface DutyCycleDto
 */
export interface DutyCycleDto {
    /**
     * 
     * @type {string}
     * @memberof DutyCycleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'days'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof DutyCycleDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof DutyCycleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DutyIdleSummaryDto
 */
export interface DutyIdleSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DutyIdleSummaryDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DutyIdleSummaryDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DutyIdleSummaryDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DutyIdleSummaryDto
     */
    'stops'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DvirDefectDto
 */
export interface DvirDefectDto {
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {Array<string>}
     * @memberof DvirDefectDto
     */
    'base64EncodedPhotos'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DvirFormAreaDto
 */
export interface DvirFormAreaDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormAreaDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaDto
     */
    'dvirFormId'?: number;
    /**
     * 
     * @type {Array<DvirFormAreaPointDto>}
     * @memberof DvirFormAreaDto
     */
    'points'?: Array<DvirFormAreaPointDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormAreaPointDto
 */
export interface DvirFormAreaPointDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormAreaPointDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaPointDto
     */
    'dvirFormAreaId'?: number;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirFormAreaPointDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {number}
     * @memberof DvirFormAreaPointDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DvirFormAreaPointSeverity = {
    None: 'None',
    Minor: 'Minor',
    Major: 'Major'
} as const;

export type DvirFormAreaPointSeverity = typeof DvirFormAreaPointSeverity[keyof typeof DvirFormAreaPointSeverity];


/**
 * 
 * @export
 * @interface DvirFormDto
 */
export interface DvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof DvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormDtoPagedResultDto
 */
export interface DvirFormDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirFormDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirFormDto>}
     * @memberof DvirFormDtoPagedResultDto
     */
    'items'?: Array<DvirFormDto> | null;
}
/**
 * 
 * @export
 * @interface DvirFormListDto
 */
export interface DvirFormListDto {
    /**
     * 
     * @type {string}
     * @memberof DvirFormListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormListDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DvirFormListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DvirFormListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface DvirFormListDtoPagedResultDto
 */
export interface DvirFormListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirFormListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirFormListDto>}
     * @memberof DvirFormListDtoPagedResultDto
     */
    'items'?: Array<DvirFormListDto> | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryDefectDto
 */
export interface DvirHistoryDefectDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof DvirHistoryDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'thumbnailPhoto'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDto
     */
    'otherPhotosCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryDefectDto
     */
    'isResolved'?: boolean;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof DvirHistoryDefectDto
     */
    'corrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryDefectDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryDefectDtoPagedResultDto
 */
export interface DvirHistoryDefectDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryDefectDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirHistoryDefectDto>}
     * @memberof DvirHistoryDefectDtoPagedResultDto
     */
    'items'?: Array<DvirHistoryDefectDto> | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryListDto
 */
export interface DvirHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirHistoryListDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryListDto
     */
    'hasDefects'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DvirHistoryListDto
     */
    'hasUnresolvedDefects'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DvirHistoryListDtoPagedResultDto
 */
export interface DvirHistoryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof DvirHistoryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<DvirHistoryListDto>}
     * @memberof DvirHistoryListDtoPagedResultDto
     */
    'items'?: Array<DvirHistoryListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DvirInspectionType = {
    PreTrip: 'PreTrip',
    PostTrip: 'PostTrip'
} as const;

export type DvirInspectionType = typeof DvirInspectionType[keyof typeof DvirInspectionType];


/**
 * 
 * @export
 * @interface DvirInspectionsReportInput
 */
export interface DvirInspectionsReportInput {
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DvirInspectionsReportInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DvirInspectionsReportInput
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DvirInspectionsReportInput
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface ELDSubmissionResponse
 */
export interface ELDSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ELDSubmissionResponse
     */
    'broadcast'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ELDSubmissionResponse
     */
    'errorCount'?: number;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ELDSubmissionResponse
     */
    'errors'?: Array<ValidationError> | null;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ELDSubmissionResponse
     */
    'status'?: ValidationStatus;
    /**
     * 
     * @type {string}
     * @memberof ELDSubmissionResponse
     */
    'submissionId'?: string;
}
/**
 * 
 * @export
 * @interface EldCreationTimeOdometerSourceDto
 */
export interface EldCreationTimeOdometerSourceDto {
    /**
     * 
     * @type {string}
     * @memberof EldCreationTimeOdometerSourceDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {OdometerSource}
     * @memberof EldCreationTimeOdometerSourceDto
     */
    'odometerSource'?: OdometerSource | null;
}
/**
 * 
 * @export
 * @interface EldDeviceAdvancedSearchListDto
 */
export interface EldDeviceAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAdvancedSearchListDto
     */
    'driverName'?: string | null;
}
/**
 * 
 * @export
 * @interface EldDeviceAppData
 */
export interface EldDeviceAppData {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceAppData
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceAppData
     */
    'assigned'?: boolean;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceAppData
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceAppData
     */
    'vendorType'?: Vendor;
}
/**
 * 
 * @export
 * @interface EldDeviceDto
 */
export interface EldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {Vendor}
     * @memberof EldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceDtoPagedResultDto
 */
export interface EldDeviceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceDto>}
     * @memberof EldDeviceDtoPagedResultDto
     */
    'items'?: Array<EldDeviceDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceListDto
 */
export interface EldDeviceListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof EldDeviceListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceListDto
     */
    'assignedByMaster'?: boolean;
    /**
     * 
     * @type {DeviceType}
     * @memberof EldDeviceListDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {number}
     * @memberof EldDeviceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDeviceListDtoPagedResultDto
 */
export interface EldDeviceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceListDto>}
     * @memberof EldDeviceListDtoPagedResultDto
     */
    'items'?: Array<EldDeviceListDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceMessageDto
 */
export interface EldDeviceMessageDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceMessageDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceMessageDtoPagedResultDto
 */
export interface EldDeviceMessageDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDeviceMessageDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDeviceMessageDto>}
     * @memberof EldDeviceMessageDtoPagedResultDto
     */
    'items'?: Array<EldDeviceMessageDto> | null;
}
/**
 * 
 * @export
 * @interface EldDeviceParsedMessageDto
 */
export interface EldDeviceParsedMessageDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EldDeviceParsedMessageDto
     */
    'parsedMessage'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDeviceParsedMessageDto
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'utcTimestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceParsedMessageDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageHistoryInputDto
 */
export interface EldDeviceUsageHistoryInputDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryInputDto
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryInputDto
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface EldDeviceUsageHistoryListDto
 */
export interface EldDeviceUsageHistoryListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceUsageHistoryListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EldDeviceUsageType = {
    MasterAssignedToTenant: 'MasterAssignedToTenant',
    TenantAssignedToVehicle: 'TenantAssignedToVehicle',
    TenantUnassignedFromVehicle: 'TenantUnassignedFromVehicle',
    MasterUnassignedFromTenant: 'MasterUnassignedFromTenant',
    TenantAssignedToInactiveVehicle: 'TenantAssignedToInactiveVehicle'
} as const;

export type EldDeviceUsageType = typeof EldDeviceUsageType[keyof typeof EldDeviceUsageType];


/**
 * 
 * @export
 * @interface EldDisconnectionListDto
 */
export interface EldDisconnectionListDto {
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'customDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'lastDisconnectedEventTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldDisconnectionListDto
     */
    'isConnectedNow'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EldDisconnectionListDto
     */
    'currentVehicleLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'lastDisconnectedDurationMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface EldDisconnectionListDtoPagedResultDto
 */
export interface EldDisconnectionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldDisconnectionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldDisconnectionListDto>}
     * @memberof EldDisconnectionListDtoPagedResultDto
     */
    'items'?: Array<EldDisconnectionListDto> | null;
}
/**
 * 
 * @export
 * @interface EldEventsReportInput
 */
export interface EldEventsReportInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof EldEventsReportInput
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof EldEventsReportInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldEventsReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface EldMalfunctionOrDataDiagnostic
 */
export interface EldMalfunctionOrDataDiagnostic {
    /**
     * 
     * @type {number}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'malfunctionOrDiagnostic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EldMalfunctionOrDataDiagnostic
     */
    'isCleared'?: boolean;
}
/**
 * 
 * @export
 * @interface EldMalfunctionOrDataDiagnosticPagedResultDto
 */
export interface EldMalfunctionOrDataDiagnosticPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof EldMalfunctionOrDataDiagnosticPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<EldMalfunctionOrDataDiagnostic>}
     * @memberof EldMalfunctionOrDataDiagnosticPagedResultDto
     */
    'items'?: Array<EldMalfunctionOrDataDiagnostic> | null;
}
/**
 * 
 * @export
 * @interface EngineOnEventDataDto
 */
export interface EngineOnEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof EngineOnEventDataDto
     */
    'time'?: string;
    /**
     * 
     * @type {number}
     * @memberof EngineOnEventDataDto
     */
    'totalVehicleMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EngineOnEventDataDto
     */
    'totalEngineHours'?: number | null;
}
/**
 * 
 * @export
 * @interface EntityCycleRules
 */
export interface EntityCycleRules {
    /**
     * 
     * @type {number}
     * @memberof EntityCycleRules
     */
    'drivingCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityCycleRules
     */
    'cycleRuleId'?: number;
}
/**
 * 
 * @export
 * @interface EntityExtensionDto
 */
export interface EntityExtensionDto {
    /**
     * 
     * @type {{ [key: string]: ExtensionPropertyDto; }}
     * @memberof EntityExtensionDto
     */
    'properties'?: { [key: string]: ExtensionPropertyDto; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EntityExtensionDto
     */
    'configuration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface EventErrorInfo
 */
export interface EventErrorInfo {
    /**
     * 
     * @type {number}
     * @memberof EventErrorInfo
     */
    'eventId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventErrorInfo
     */
    'ianaTimeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EventLocationSource = {
    ManualInput: 'ManualInput',
    SelectedFromMap: 'SelectedFromMap',
    None: 'None'
} as const;

export type EventLocationSource = typeof EventLocationSource[keyof typeof EventLocationSource];


/**
 * 
 * @export
 * @interface EventManipulationSyncOutputItemDto
 */
export interface EventManipulationSyncOutputItemDto {
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'operation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventManipulationSyncOutputItemDto
     */
    'driverUsername'?: string | null;
}
/**
 * 
 * @export
 * @interface EventPreferenceDto
 */
export interface EventPreferenceDto {
    /**
     * 
     * @type {number}
     * @memberof EventPreferenceDto
     */
    'eventId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventPreferenceDto
     */
    'urgent'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EventRecordOrigin = {
    AutomaticallyRecordedByEld: 'AutomaticallyRecordedByEld',
    EditedOrEnteredByTheDriver: 'EditedOrEnteredByTheDriver',
    EditRequestedByAnAuthenticatedUserOtherThanTheDriver: 'EditRequestedByAnAuthenticatedUserOtherThanTheDriver',
    AssumedFromUnidentifiedDriverProfile: 'AssumedFromUnidentifiedDriverProfile'
} as const;

export type EventRecordOrigin = typeof EventRecordOrigin[keyof typeof EventRecordOrigin];


/**
 * 
 * @export
 * @enum {string}
 */

export const EventRecordStatus = {
    Active: 'Active',
    InactiveChanged: 'InactiveChanged',
    InactiveChangeRequested: 'InactiveChangeRequested',
    InactiveChangeRejected: 'InactiveChangeRejected'
} as const;

export type EventRecordStatus = typeof EventRecordStatus[keyof typeof EventRecordStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EventType = {
    ChangeInDriversDutyStatus: 'ChangeInDriversDutyStatus',
    IntermediateLog: 'IntermediateLog',
    ChangeInDriversIndicationOfAuthorizedPersonalUseOfCmvOrYardMoves: 'ChangeInDriversIndicationOfAuthorizedPersonalUseOfCmvOrYardMoves',
    DriversCertificationOrRecertificationOfRecords: 'DriversCertificationOrRecertificationOfRecords',
    DriversLoginOrLogoutActivity: 'DriversLoginOrLogoutActivity',
    CmvEnginePowerUpOrShutDownActivity: 'CmvEnginePowerUpOrShutDownActivity',
    MalfunctionOrDataDiagnosticDetectionOccurrence: 'MalfunctionOrDataDiagnosticDetectionOccurrence',
    Custom: 'Custom'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];


/**
 * 
 * @export
 * @interface EventTypeCode
 */
export interface EventTypeCode {
    /**
     * 
     * @type {EventType}
     * @memberof EventTypeCode
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof EventTypeCode
     */
    'eventCode'?: number;
}
/**
 * 
 * @export
 * @interface EventViewDto
 */
export interface EventViewDto {
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'realStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'durationInSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'realDurationInSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'locationDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'engineMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'origin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isBasic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {EventType}
     * @memberof EventViewDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'coDriverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'shippingDocuments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'realEndTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'averageSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventViewDto
     */
    'eventSequenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'nextDayFirstEventOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventViewDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventViewDto
     */
    'isEventMissingPowerUp'?: boolean;
}
/**
 * 
 * @export
 * @interface ExceptionViewDto
 */
export interface ExceptionViewDto {
    /**
     * 
     * @type {number}
     * @memberof ExceptionViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExceptionViewDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExceptionViewDto
     */
    'exception'?: string | null;
}
/**
 * 
 * @export
 * @interface ExportFilterInputDto
 */
export interface ExportFilterInputDto {
    /**
     * 
     * @type {number}
     * @memberof ExportFilterInputDto
     */
    'maxResultCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportFilterInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExportFilterInputDto
     */
    'exportFormat'?: string | null;
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof ExportFilterInputDto
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof ExportFilterInputDto
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof ExportFilterInputDto
     */
    'sorting'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionEnumDto
 */
export interface ExtensionEnumDto {
    /**
     * 
     * @type {Array<ExtensionEnumFieldDto>}
     * @memberof ExtensionEnumDto
     */
    'fields'?: Array<ExtensionEnumFieldDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionEnumDto
     */
    'localizationResource'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionEnumFieldDto
 */
export interface ExtensionEnumFieldDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionEnumFieldDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ExtensionEnumFieldDto
     */
    'value'?: any | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiCreateDto
 */
export interface ExtensionPropertyApiCreateDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiCreateDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDto
 */
export interface ExtensionPropertyApiDto {
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnGet}
     * @memberof ExtensionPropertyApiDto
     */
    'onGet'?: ExtensionPropertyApiDtoOnGet | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnCreate}
     * @memberof ExtensionPropertyApiDto
     */
    'onCreate'?: ExtensionPropertyApiDtoOnCreate | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnUpdate}
     * @memberof ExtensionPropertyApiDto
     */
    'onUpdate'?: ExtensionPropertyApiDtoOnUpdate | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnCreate
 */
export interface ExtensionPropertyApiDtoOnCreate {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnCreate
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnGet
 */
export interface ExtensionPropertyApiDtoOnGet {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnGet
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiDtoOnUpdate
 */
export interface ExtensionPropertyApiDtoOnUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiDtoOnUpdate
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiGetDto
 */
export interface ExtensionPropertyApiGetDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiGetDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyApiUpdateDto
 */
export interface ExtensionPropertyApiUpdateDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyApiUpdateDto
     */
    'isAvailable'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyAttributeDto
 */
export interface ExtensionPropertyAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyAttributeDto
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExtensionPropertyAttributeDto
     */
    'config'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDto
 */
export interface ExtensionPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDto
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {ExtensionPropertyDtoDisplayName}
     * @memberof ExtensionPropertyDto
     */
    'displayName'?: ExtensionPropertyDtoDisplayName | null;
    /**
     * 
     * @type {ExtensionPropertyDtoApi}
     * @memberof ExtensionPropertyDto
     */
    'api'?: ExtensionPropertyDtoApi | null;
    /**
     * 
     * @type {ExtensionPropertyDtoUi}
     * @memberof ExtensionPropertyDto
     */
    'ui'?: ExtensionPropertyDtoUi | null;
    /**
     * 
     * @type {Array<ExtensionPropertyAttributeDto>}
     * @memberof ExtensionPropertyDto
     */
    'attributes'?: Array<ExtensionPropertyAttributeDto> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExtensionPropertyDto
     */
    'configuration'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {any}
     * @memberof ExtensionPropertyDto
     */
    'defaultValue'?: any | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoApi
 */
export interface ExtensionPropertyDtoApi {
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnGet}
     * @memberof ExtensionPropertyDtoApi
     */
    'onGet'?: ExtensionPropertyApiDtoOnGet | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnCreate}
     * @memberof ExtensionPropertyDtoApi
     */
    'onCreate'?: ExtensionPropertyApiDtoOnCreate | null;
    /**
     * 
     * @type {ExtensionPropertyApiDtoOnUpdate}
     * @memberof ExtensionPropertyDtoApi
     */
    'onUpdate'?: ExtensionPropertyApiDtoOnUpdate | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoDisplayName
 */
export interface ExtensionPropertyDtoDisplayName {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDtoDisplayName
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyDtoDisplayName
     */
    'resource'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyDtoUi
 */
export interface ExtensionPropertyDtoUi {
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnTable}
     * @memberof ExtensionPropertyDtoUi
     */
    'onTable'?: ExtensionPropertyUiDtoOnTable | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyDtoUi
     */
    'onCreateForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyDtoUi
     */
    'onEditForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoLookup}
     * @memberof ExtensionPropertyDtoUi
     */
    'lookup'?: ExtensionPropertyUiDtoLookup | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDto
 */
export interface ExtensionPropertyUiDto {
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnTable}
     * @memberof ExtensionPropertyUiDto
     */
    'onTable'?: ExtensionPropertyUiDtoOnTable | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyUiDto
     */
    'onCreateForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoOnCreateForm}
     * @memberof ExtensionPropertyUiDto
     */
    'onEditForm'?: ExtensionPropertyUiDtoOnCreateForm | null;
    /**
     * 
     * @type {ExtensionPropertyUiDtoLookup}
     * @memberof ExtensionPropertyUiDto
     */
    'lookup'?: ExtensionPropertyUiDtoLookup | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoLookup
 */
export interface ExtensionPropertyUiDtoLookup {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'resultListPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'displayPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'valuePropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiDtoLookup
     */
    'filterParamName'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoOnCreateForm
 */
export interface ExtensionPropertyUiDtoOnCreateForm {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiDtoOnCreateForm
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiDtoOnTable
 */
export interface ExtensionPropertyUiDtoOnTable {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiDtoOnTable
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiFormDto
 */
export interface ExtensionPropertyUiFormDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiFormDto
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiLookupDto
 */
export interface ExtensionPropertyUiLookupDto {
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'resultListPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'displayPropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'valuePropertyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtensionPropertyUiLookupDto
     */
    'filterParamName'?: string | null;
}
/**
 * 
 * @export
 * @interface ExtensionPropertyUiTableDto
 */
export interface ExtensionPropertyUiTableDto {
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionPropertyUiTableDto
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface FeatureDto
 */
export interface FeatureDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {FeatureDtoProvider}
     * @memberof FeatureDto
     */
    'provider'?: FeatureDtoProvider | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {FeatureDtoValueType}
     * @memberof FeatureDto
     */
    'valueType'?: FeatureDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof FeatureDto
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeatureDto
     */
    'parentName'?: string | null;
}
/**
 * 
 * @export
 * @interface FeatureDtoProvider
 */
export interface FeatureDtoProvider {
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoProvider
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoProvider
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface FeatureDtoValueType
 */
export interface FeatureDtoValueType {
    /**
     * 
     * @type {string}
     * @memberof FeatureDtoValueType
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FeatureDtoValueType
     */
    'properties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {IStringValueTypeValidator}
     * @memberof FeatureDtoValueType
     */
    'validator'?: IStringValueTypeValidator | null;
}
/**
 * 
 * @export
 * @interface FeatureGroupDto
 */
export interface FeatureGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<FeatureDto>}
     * @memberof FeatureGroupDto
     */
    'features'?: Array<FeatureDto> | null;
}
/**
 * 
 * @export
 * @interface FeatureProviderDto
 */
export interface FeatureProviderDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureProviderDto
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface FieldPermissionEntityGroupDto
 */
export interface FieldPermissionEntityGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionEntityGroupDto
     */
    'group'?: string | null;
    /**
     * 
     * @type {Array<FieldPermissionGrantDto>}
     * @memberof FieldPermissionEntityGroupDto
     */
    'permissions'?: Array<FieldPermissionGrantDto> | null;
}
/**
 * 
 * @export
 * @interface FieldPermissionGrantDto
 */
export interface FieldPermissionGrantDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionGrantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {ProtectedFieldLevel}
     * @memberof FieldPermissionGrantDto
     */
    'fieldAccessLevel'?: ProtectedFieldLevel;
}
/**
 * 
 * @export
 * @interface FieldPermissionGroupDto
 */
export interface FieldPermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionGroupDto
     */
    'entity'?: string | null;
    /**
     * 
     * @type {Array<FieldPermissionEntityGroupDto>}
     * @memberof FieldPermissionGroupDto
     */
    'groups'?: Array<FieldPermissionEntityGroupDto> | null;
}
/**
 * 
 * @export
 * @interface FilterBaseInput
 */
export interface FilterBaseInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FilterBaseInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FilterBaseInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterBaseInput
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface FilterInputDto
 */
export interface FilterInputDto {
    /**
     * 
     * @type {FilterInputDtoFilterRule}
     * @memberof FilterInputDto
     */
    'filterRule'?: FilterInputDtoFilterRule | null;
    /**
     * 
     * @type {FilterInputDtoSearchRule}
     * @memberof FilterInputDto
     */
    'searchRule'?: FilterInputDtoSearchRule | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDto
     */
    'sorting'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FilterInputDto
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterInputDto
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface FilterInputDtoFilterRule
 */
export interface FilterInputDtoFilterRule {
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'operator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoFilterRule
     */
    'condition'?: string | null;
    /**
     * 
     * @type {Array<FilterRule>}
     * @memberof FilterInputDtoFilterRule
     */
    'filterRules'?: Array<FilterRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilterInputDtoFilterRule
     */
    'isNestedRule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterInputDtoFilterRule
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface FilterInputDtoSearchRule
 */
export interface FilterInputDtoSearchRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterInputDtoSearchRule
     */
    'columns'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FilterInputDtoSearchRule
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface FilterRule
 */
export interface FilterRule {
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'operator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRule
     */
    'condition'?: string | null;
    /**
     * 
     * @type {Array<FilterRule>}
     * @memberof FilterRule
     */
    'filterRules'?: Array<FilterRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilterRule
     */
    'isNestedRule'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterRule
     */
    'isValid'?: boolean;
}
/**
 * 
 * @export
 * @interface FilteredHarshEventBaseInput
 */
export interface FilteredHarshEventBaseInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FilteredHarshEventBaseInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FilteredHarshEventBaseInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilteredHarshEventBaseInput
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof FilteredHarshEventBaseInput
     */
    'skipCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof FilteredHarshEventBaseInput
     */
    'maxResultCount'?: number;
}
/**
 * 
 * @export
 * @interface FindTenantResultDto
 */
export interface FindTenantResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof FindTenantResultDto
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindTenantResultDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindTenantResultDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FindTenantResultDto
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FixEventsDirection = {
    FromLastEvent: 'FromLastEvent',
    FromFirstEvent: 'FromFirstEvent'
} as const;

export type FixEventsDirection = typeof FixEventsDirection[keyof typeof FixEventsDirection];


/**
 * 
 * @export
 * @interface FixEventsInputDto
 */
export interface FixEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixEngineHours'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixSequenceNumbers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FixEventsInputDto
     */
    'fixOdometer'?: boolean;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof FixEventsInputDto
     */
    'fixDirection': FixEventsDirection;
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof FixEventsInputDto
     */
    'endEvent': number;
}
/**
 * 
 * @export
 * @interface FleetManagerDto
 */
export interface FleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerDto
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<CompanyDto>}
     * @memberof FleetManagerDto
     */
    'companies'?: Array<CompanyDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof FleetManagerDto
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof FleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FleetManagerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FleetManagerDtoPagedResultDto
 */
export interface FleetManagerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FleetManagerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FleetManagerDto>}
     * @memberof FleetManagerDtoPagedResultDto
     */
    'items'?: Array<FleetManagerDto> | null;
}
/**
 * 
 * @export
 * @interface FleetManagerListDto
 */
export interface FleetManagerListDto {
    /**
     * 
     * @type {RecordStatus}
     * @memberof FleetManagerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'companies'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetManagerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FleetManagerListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'fleetManagerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FleetManagerListDto
     */
    'role'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FleetManagerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface FleetManagerListDtoPagedResultDto
 */
export interface FleetManagerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FleetManagerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FleetManagerListDto>}
     * @memberof FleetManagerListDtoPagedResultDto
     */
    'items'?: Array<FleetManagerListDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaCredentialsDto
 */
export interface FmcsaCredentialsDto {
    /**
     * 
     * @type {string}
     * @memberof FmcsaCredentialsDto
     */
    'key': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaCredentialsDto
     */
    'os': MobileApplicationType;
}
/**
 * 
 * @export
 * @interface FmcsaEldFileOutputDto
 */
export interface FmcsaEldFileOutputDto {
    /**
     * 
     * @type {string}
     * @memberof FmcsaEldFileOutputDto
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEldFileOutputDto
     */
    'fileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaEmailTransferInput
 */
export interface FmcsaEmailTransferInput {
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'replyTo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'recipientOverride'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaEmailTransferInput
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaEmailTransferInput
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaEmailTransferInput
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionDto
 */
export interface FmcsaInspectionDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportTimeTo'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'reportEmailRecipient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'eldFileComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'eldFileUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'submissionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaInspectionDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionDtoPagedResultDto
 */
export interface FmcsaInspectionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FmcsaInspectionDto>}
     * @memberof FmcsaInspectionDtoPagedResultDto
     */
    'items'?: Array<FmcsaInspectionDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionListDto
 */
export interface FmcsaInspectionListDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionListDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'time'?: string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionListDto
     */
    'reportType'?: FmcsaInspectionReportType;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FmcsaInspectionListDto
     */
    'isUnofficial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionListDtoPagedResultDto
 */
export interface FmcsaInspectionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FmcsaInspectionListDto>}
     * @memberof FmcsaInspectionListDtoPagedResultDto
     */
    'items'?: Array<FmcsaInspectionListDto> | null;
}
/**
 * 
 * @export
 * @interface FmcsaInspectionManualCreateInputDto
 */
export interface FmcsaInspectionManualCreateInputDto {
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'vehicleId': number;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportTimeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportTimeTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'timeOfReport': string;
    /**
     * 
     * @type {FmcsaInspectionReportType}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'reportType': FmcsaInspectionReportType;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'geolocation': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'eldFileComment': string;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaInspectionManualCreateInputDto
     */
    'mobileApplicationType': MobileApplicationType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FmcsaInspectionReportType = {
    Bluetooth: 'Bluetooth',
    Usb: 'USB',
    Web: 'Web',
    Email: 'Email',
    TestWeb: 'TestWeb',
    TestEmail: 'TestEmail',
    RoadsideInspectionOnly: 'RoadsideInspectionOnly'
} as const;

export type FmcsaInspectionReportType = typeof FmcsaInspectionReportType[keyof typeof FmcsaInspectionReportType];


/**
 * 
 * @export
 * @interface FmcsaMobileCredentials
 */
export interface FmcsaMobileCredentials {
    /**
     * 
     * @type {string}
     * @memberof FmcsaMobileCredentials
     */
    'certificatePassword'?: string | null;
    /**
     * 
     * @type {{ [key: string]: SmtpConfiguration; }}
     * @memberof FmcsaMobileCredentials
     */
    'mailServerSettings'?: { [key: string]: SmtpConfiguration; } | null;
}
/**
 * 
 * @export
 * @interface FmcsaOptions
 */
export interface FmcsaOptions {
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptions
     */
    'eldId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptions
     */
    'eldRegId'?: string | null;
    /**
     * 
     * @type {FmcsaOptionsSettings}
     * @memberof FmcsaOptions
     */
    'settings'?: FmcsaOptionsSettings | null;
    /**
     * 
     * @type {{ [key: string]: FmcsaOptions; }}
     * @memberof FmcsaOptions
     */
    'clients'?: { [key: string]: FmcsaOptions; } | null;
}
/**
 * 
 * @export
 * @interface FmcsaOptionsSettings
 */
export interface FmcsaOptionsSettings {
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaServerCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaClientCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaOptionsSettings
     */
    'fmcsaTestClientCertificatePassword'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaSettings
 */
export interface FmcsaSettings {
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaServerCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaClientCertificatePassword'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificateFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificateKeyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaSettings
     */
    'fmcsaTestClientCertificatePassword'?: string | null;
}
/**
 * 
 * @export
 * @interface FmcsaTransferInput
 */
export interface FmcsaTransferInput {
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'dateFrom': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'dateTo': string;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'currentLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FmcsaTransferInput
     */
    'currentLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FmcsaTransferInput
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof FmcsaTransferInput
     */
    'mobileApplicationType'?: MobileApplicationType | null;
}
/**
 * 
 * @export
 * @interface FormattedSensorValue
 */
export interface FormattedSensorValue {
    /**
     * 
     * @type {any}
     * @memberof FormattedSensorValue
     */
    'value'?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormattedSensorValue
     */
    'isNormal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormattedSensorValue
     */
    'unit'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueType}
     * @memberof FormattedSensorValue
     */
    'valueType'?: VehicleSensorAttributeValueType;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByActionDto
 */
export interface FuelConsumptionByActionDto {
    /**
     * 
     * @type {Array<FuelEconomyAction>}
     * @memberof FuelConsumptionByActionDto
     */
    'actions'?: Array<FuelEconomyAction> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByPeriodDto
 */
export interface FuelConsumptionByPeriodDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByPeriodDto
     */
    'values'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionByTimeOfDayDto
 */
export interface FuelConsumptionByTimeOfDayDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'morningValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'afternoonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionByTimeOfDayDto
     */
    'nightValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionCardsDto
 */
export interface FuelConsumptionCardsDto {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionCardsDto
     */
    'value'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FuelConsumptionCardsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionCardsDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FuelConsumptionCardsDto
     */
    'isGrowing'?: boolean;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDto
 */
export interface FuelConsumptionEfficiencyDto {
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'speedingConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency | null;
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'normalDriveConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency | null;
    /**
     * 
     * @type {FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency}
     * @memberof FuelConsumptionEfficiencyDto
     */
    'slowPacedConsumptionEfficiency'?: FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency | null;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoNormalDriveConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSlowPacedConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
 */
export interface FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency {
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelConsumptionEfficiencyDtoSpeedingConsumptionEfficiency
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface FuelEconomyAction
 */
export interface FuelEconomyAction {
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyAction
     */
    'action'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FuelEconomyAction
     */
    'currentPeriod'?: number;
    /**
     * 
     * @type {number}
     * @memberof FuelEconomyAction
     */
    'previousPeriod'?: number;
}
/**
 * 
 * @export
 * @interface FuelEconomyInput
 */
export interface FuelEconomyInput {
    /**
     * 
     * @type {PeriodType}
     * @memberof FuelEconomyInput
     */
    'periodType'?: PeriodType;
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyInput
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelEconomyInput
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface FuelProviderDto
 */
export interface FuelProviderDto {
    /**
     * 
     * @type {number}
     * @memberof FuelProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof FuelProviderDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FuelProviderDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof FuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface FuelProviderDtoPagedResultDto
 */
export interface FuelProviderDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof FuelProviderDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<FuelProviderDto>}
     * @memberof FuelProviderDtoPagedResultDto
     */
    'items'?: Array<FuelProviderDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FuelProviders = {
    Compass: 'Compass',
    Efs: 'EFS'
} as const;

export type FuelProviders = typeof FuelProviders[keyof typeof FuelProviders];


/**
 * 
 * @export
 * @enum {string}
 */

export const FuelType = {
    Diesel: 'Diesel',
    Gasoline: 'Gasoline',
    Propane: 'Propane',
    LiquidNaturalGas: 'LiquidNaturalGas',
    CompressedNaturalGas: 'CompressedNaturalGas',
    Ethanol: 'Ethanol',
    Methanol: 'Methanol',
    E85: 'E85',
    M85: 'M85',
    A55: 'A55',
    Biodiesel: 'Biodiesel',
    Other: 'Other'
} as const;

export type FuelType = typeof FuelType[keyof typeof FuelType];


/**
 * 
 * @export
 * @interface GenerateOneTimeCodeInput
 */
export interface GenerateOneTimeCodeInput {
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeInput
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GenerateOneTimeCodeOutput
 */
export interface GenerateOneTimeCodeOutput {
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeOutput
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateOneTimeCodeOutput
     */
    'normalizedPhoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeolocationResultModel
 */
export interface GeolocationResultModel {
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeolocationResultModel
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeolocationResultModel
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GeolocationResultModel
     */
    'bearing'?: number;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceCommandInput
 */
export interface GeometrisDeviceCommandInput {
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandInput
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceCommandOutput
 */
export interface GeometrisDeviceCommandOutput {
    /**
     * 
     * @type {boolean}
     * @memberof GeometrisDeviceCommandOutput
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceCommandOutput
     */
    'deviceCommandToken'?: string | null;
}
/**
 * 
 * @export
 * @interface GeometrisDeviceInput
 */
export interface GeometrisDeviceInput {
    /**
     * 
     * @type {string}
     * @memberof GeometrisDeviceInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GeometrisEngineBusType = {
    Obd: 'Obd',
    J1939: 'J1939',
    Obd2: 'Obd2',
    J1708: 'J1708',
    AutoDetect: 'AutoDetect'
} as const;

export type GeometrisEngineBusType = typeof GeometrisEngineBusType[keyof typeof GeometrisEngineBusType];


/**
 * 
 * @export
 * @interface GeometrisEngineBusTypeInput
 */
export interface GeometrisEngineBusTypeInput {
    /**
     * 
     * @type {GeometrisEngineBusType}
     * @memberof GeometrisEngineBusTypeInput
     */
    'engineBusType'?: GeometrisEngineBusType;
    /**
     * 
     * @type {string}
     * @memberof GeometrisEngineBusTypeInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisOdometerInput
 */
export interface GeometrisOdometerInput {
    /**
     * 
     * @type {number}
     * @memberof GeometrisOdometerInput
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisOdometerInput
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetDriverEventDto
 */
export interface GeometrisWidgetDriverEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverGivenId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetDriverEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetEventDto
 */
export interface GeometrisWidgetEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetEventDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GeometrisWidgetVehicleEventDto
 */
export interface GeometrisWidgetVehicleEventDto {
    /**
     * 
     * @type {number}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeometrisWidgetVehicleEventDto
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface GetFeatureListResultDto
 */
export interface GetFeatureListResultDto {
    /**
     * 
     * @type {Array<FeatureGroupDto>}
     * @memberof GetFeatureListResultDto
     */
    'groups'?: Array<FeatureGroupDto> | null;
}
/**
 * 
 * @export
 * @interface GetPermissionListResultDto
 */
export interface GetPermissionListResultDto {
    /**
     * 
     * @type {string}
     * @memberof GetPermissionListResultDto
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<PermissionGroupDto>}
     * @memberof GetPermissionListResultDto
     */
    'groups'?: Array<PermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface GetSingleDocumentDto
 */
export interface GetSingleDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof GetSingleDocumentDto
     */
    'documentId': number;
    /**
     * 
     * @type {number}
     * @memberof GetSingleDocumentDto
     */
    'entityType': number;
}
/**
 * 
 * @export
 * @interface GetSystemNotificationsDto
 */
export interface GetSystemNotificationsDto {
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'notificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSystemNotificationsDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSystemNotificationsDto
     */
    'notificationType'?: string | null;
}
/**
 * 
 * @export
 * @interface GetSystemNotificationsDtoPagedResultDto
 */
export interface GetSystemNotificationsDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GetSystemNotificationsDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GetSystemNotificationsDto>}
     * @memberof GetSystemNotificationsDtoPagedResultDto
     */
    'items'?: Array<GetSystemNotificationsDto> | null;
}
/**
 * 
 * @export
 * @interface GetVehicleDriversInputDto
 */
export interface GetVehicleDriversInputDto {
    /**
     * 
     * @type {string}
     * @memberof GetVehicleDriversInputDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetVehicleDriversInputDto
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface GlobalSearchInputDto
 */
export interface GlobalSearchInputDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchInputDto
     */
    'searchText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeDrivers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeVehicles'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeTrailers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchInputDto
     */
    'includeEldDevices'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupDto
 */
export interface GroupDto {
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {DriverDtoCompany}
     * @memberof GroupDto
     */
    'company'?: DriverDtoCompany | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DriverDto>}
     * @memberof GroupDto
     */
    'drivers'?: Array<DriverDto> | null;
    /**
     * 
     * @type {Array<VehicleDto>}
     * @memberof GroupDto
     */
    'vehicles'?: Array<VehicleDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupDtoPagedResultDto
 */
export interface GroupDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GroupDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GroupDto>}
     * @memberof GroupDtoPagedResultDto
     */
    'items'?: Array<GroupDto> | null;
}
/**
 * 
 * @export
 * @interface GroupListDto
 */
export interface GroupListDto {
    /**
     * 
     * @type {string}
     * @memberof GroupListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupListDto
     */
    'creatorUserDisplayName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListDto
     */
    'driverNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListDto
     */
    'vehicleNames'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface GroupListDtoPagedResultDto
 */
export interface GroupListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof GroupListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<GroupListDto>}
     * @memberof GroupListDtoPagedResultDto
     */
    'items'?: Array<GroupListDto> | null;
}
/**
 * 
 * @export
 * @interface GuidDropDownAppData
 */
export interface GuidDropDownAppData {
    /**
     * 
     * @type {string}
     * @memberof GuidDropDownAppData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidDropDownAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface GuidUpdateManyInputDto
 */
export interface GuidUpdateManyInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof GuidUpdateManyInputDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GuidUpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface HarshAccelerationEventsDto
 */
export interface HarshAccelerationEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshAccelerationEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshAccelerationEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshAccelerationEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshAccelerationEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshAccelerationEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshAccelerationEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshBreakingEventsDto
 */
export interface HarshBreakingEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshBreakingEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshBreakingEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshBreakingEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshBreakingEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshBreakingEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshBreakingEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshEventDailyLogDto
 */
export interface HarshEventDailyLogDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'morningValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'noonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'afternoonValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshEventDailyLogDto
     */
    'nightValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface HarshEventsBreakdownDto
 */
export interface HarshEventsBreakdownDto {
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshBraking'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshAcceleration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshTurn'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownDto
     */
    'harshStop'?: number;
}
/**
 * 
 * @export
 * @interface HarshEventsBreakdownInfoDto
 */
export interface HarshEventsBreakdownInfoDto {
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'activeDrivers'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshBraking'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshAcceleration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshTurn'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'harshStop'?: number;
    /**
     * 
     * @type {number}
     * @memberof HarshEventsBreakdownInfoDto
     */
    'speeding'?: number;
}
/**
 * 
 * @export
 * @interface HarshSpeedingEventsDto
 */
export interface HarshSpeedingEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshSpeedingEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshSpeedingEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshSpeedingEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshSpeedingEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshSpeedingEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshSpeedingEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshStopEventsDto
 */
export interface HarshStopEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshStopEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshStopEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshStopEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshStopEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshStopEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshStopEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HarshTurnEventsDto
 */
export interface HarshTurnEventsDto {
    /**
     * 
     * @type {string}
     * @memberof HarshTurnEventsDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HarshTurnEventsDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof HarshTurnEventsDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof HarshTurnEventsDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HarshTurnEventsDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HarshTurnEventsDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface HosDetailsDto
 */
export interface HosDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDetailsDto
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDetailsDto
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDetailsDto
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDetailsDto
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface HosDriverDto
 */
export interface HosDriverDto {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'timeZoneOffset'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof HosDriverDto
     */
    'driverStatus'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverPhoneNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'vehicleNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'trailerNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'lastActivity'?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'lastPositionName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'lastPositionLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'lastPositionLong'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'violations'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'eldConnected'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eldDisconnectedSince'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDaysWorked'?: number;
    /**
     * 
     * @type {HosDriverDtoHosTimers}
     * @memberof HosDriverDto
     */
    'hosTimers'?: HosDriverDtoHosTimers | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxDrive': number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxShift': number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'maxCycle': number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleResetTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndRegularShiftBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'regularShiftWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'regularShiftWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndShiftDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleDrivingBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleDriveTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleDriveTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'driverDutyStatusStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'cycleWorkTimeAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'cycleWorkTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eligibleForFirstSplitOffDutyBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'eligibleForFirstSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'completesSplitSleeperBreakAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'firstSplitBreakStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAtFirstSplitBreakAsTimeSpan'?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDto
     */
    'shiftDriveTimeAtFirstSplitBreak'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'isPending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverDto
     */
    'isError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustHaveBreakBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HosDriverDto
     */
    'mustEndCycleWorkBy'?: string | null;
}
/**
 * 
 * @export
 * @interface HosDriverDtoHosTimers
 */
export interface HosDriverDtoHosTimers {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'break'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'shiftDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'shiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'cycleDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'cycleWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'regularShiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoHosTimers
     */
    'regularShiftDrive'?: number;
}
/**
 * 
 * @export
 * @interface HosDriverDtoPagedResultDto
 */
export interface HosDriverDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof HosDriverDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<HosDriverDto>}
     * @memberof HosDriverDtoPagedResultDto
     */
    'items'?: Array<HosDriverDto> | null;
}
/**
 * 
 * @export
 * @interface HosExceptionAppData
 */
export interface HosExceptionAppData {
    /**
     * 
     * @type {number}
     * @memberof HosExceptionAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof HosExceptionAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface HosTimers
 */
export interface HosTimers {
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'break'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'shiftDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'shiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'cycleDrive'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'cycleWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'regularShiftWork'?: number;
    /**
     * 
     * @type {number}
     * @memberof HosTimers
     */
    'regularShiftDrive'?: number;
}
/**
 * 
 * @export
 * @interface IStringValueType
 */
export interface IStringValueType {
    /**
     * 
     * @type {string}
     * @memberof IStringValueType
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IStringValueType
     */
    'properties'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {IStringValueTypeValidator}
     * @memberof IStringValueType
     */
    'validator'?: IStringValueTypeValidator | null;
}
/**
 * 
 * @export
 * @interface IStringValueTypeValidator
 */
export interface IStringValueTypeValidator {
    /**
     * 
     * @type {string}
     * @memberof IStringValueTypeValidator
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IStringValueTypeValidator
     */
    'properties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IValueValidator
 */
export interface IValueValidator {
    /**
     * 
     * @type {string}
     * @memberof IValueValidator
     */
    'name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IValueValidator
     */
    'properties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IanaTimeZone
 */
export interface IanaTimeZone {
    /**
     * 
     * @type {string}
     * @memberof IanaTimeZone
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface IdentityError
 */
export interface IdentityError {
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface IdentityResult
 */
export interface IdentityResult {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityResult
     */
    'succeeded'?: boolean;
    /**
     * 
     * @type {Array<IdentityError>}
     * @memberof IdentityResult
     */
    'errors'?: Array<IdentityError> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleCreateDto
 */
export interface IdentityRoleCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleCreateDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleCreateDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleCreateDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDto
 */
export interface IdentityRoleDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDtoListResultDto
 */
export interface IdentityRoleDtoListResultDto {
    /**
     * 
     * @type {Array<IdentityRoleDto>}
     * @memberof IdentityRoleDtoListResultDto
     */
    'items'?: Array<IdentityRoleDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleDtoPagedResultDto
 */
export interface IdentityRoleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof IdentityRoleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<IdentityRoleDto>}
     * @memberof IdentityRoleDtoPagedResultDto
     */
    'items'?: Array<IdentityRoleDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityRoleUpdateDto
 */
export interface IdentityRoleUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityRoleUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleUpdateDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityRoleUpdateDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityRoleUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserCreateDto
 */
export interface IdentityUserCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserCreateDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserCreateDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserCreateDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserCreateDto
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserDto
 */
export interface IdentityUserDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'phoneNumberConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lockoutEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserDtoPagedResultDto
 */
export interface IdentityUserDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof IdentityUserDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<IdentityUserDto>}
     * @memberof IdentityUserDtoPagedResultDto
     */
    'items'?: Array<IdentityUserDto> | null;
}
/**
 * 
 * @export
 * @interface IdentityUserUpdateDto
 */
export interface IdentityUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityUserUpdateDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserUpdateDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityUserUpdateDto
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserUpdateDto
     */
    'roleNames'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IdentityUserUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface IdentityUserUpdateRolesDto
 */
export interface IdentityUserUpdateRolesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityUserUpdateRolesDto
     */
    'roleNames': Array<string>;
}
/**
 * 
 * @export
 * @interface IdleFuelConsumptionDto
 */
export interface IdleFuelConsumptionDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IdleFuelConsumptionDto
     */
    'currentValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof IdleFuelConsumptionDto
     */
    'previousValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface IdleReportInputDto
 */
export interface IdleReportInputDto {
    /**
     * 
     * @type {string}
     * @memberof IdleReportInputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdleReportInputDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {PeriodType}
     * @memberof IdleReportInputDto
     */
    'periodType'?: PeriodType;
}
/**
 * 
 * @export
 * @interface IftaMileageReportInputDto
 */
export interface IftaMileageReportInputDto {
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof IftaMileageReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {FuelType}
     * @memberof IftaMileageReportInputDto
     */
    'fuelType'?: FuelType;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IftaMileageReportInputDto
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof IftaMileageReportInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof IftaMileageReportInputDto
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @interface InspectionReportViewDto
 */
export interface InspectionReportViewDto {
    /**
     * 
     * @type {number}
     * @memberof InspectionReportViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionReportViewDto
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionReportViewDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InspectionReportViewDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InspectionReportViewDto
     */
    'defects'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionReportViewDto
     */
    'signed'?: boolean;
}
/**
 * 
 * @export
 * @interface Int32CommonDto
 */
export interface Int32CommonDto {
    /**
     * 
     * @type {number}
     * @memberof Int32CommonDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32CommonDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface Int32DropDownAppData
 */
export interface Int32DropDownAppData {
    /**
     * 
     * @type {number}
     * @memberof Int32DropDownAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32DropDownAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface Int32MultipleSelectedIds
 */
export interface Int32MultipleSelectedIds {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32MultipleSelectedIds
     */
    'selectedIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Int32UpdateManyInputDto
 */
export interface Int32UpdateManyInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32UpdateManyInputDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Int32UpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface Int64UpdateManyInputDto
 */
export interface Int64UpdateManyInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof Int64UpdateManyInputDto
     */
    'ids'?: Array<number> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Int64UpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface InvalidateMobileEventsInputDto
 */
export interface InvalidateMobileEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof InvalidateMobileEventsInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvalidateMobileEventsInputDto
     */
    'fromStartTime'?: string;
}
/**
 * 
 * @export
 * @interface LanguageInfo
 */
export interface LanguageInfo {
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'cultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'uiCultureName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LanguageInfo
     */
    'flagIcon'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveTrackTokenDto
 */
export interface LiveTrackTokenDto {
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackTokenDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveTrackTokenDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackTokenDto
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveTrackTokenDtoPagedResultDto
 */
export interface LiveTrackTokenDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackTokenDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<LiveTrackTokenDto>}
     * @memberof LiveTrackTokenDtoPagedResultDto
     */
    'items'?: Array<LiveTrackTokenDto> | null;
}
/**
 * 
 * @export
 * @interface LiveTrackVehicleDto
 */
export interface LiveTrackVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Odometer}
     * @memberof LiveTrackVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {LiveTrackVehicleDtoCurrentLocation}
     * @memberof LiveTrackVehicleDto
     */
    'currentLocation'?: LiveTrackVehicleDtoCurrentLocation | null;
}
/**
 * 
 * @export
 * @interface LiveTrackVehicleDtoCurrentLocation
 */
export interface LiveTrackVehicleDtoCurrentLocation {
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveTrackVehicleDtoCurrentLocation
     */
    'attachedTrailer'?: string | null;
}
/**
 * 
 * @export
 * @interface LocalizableStringDto
 */
export interface LocalizableStringDto {
    /**
     * 
     * @type {string}
     * @memberof LocalizableStringDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocalizableStringDto
     */
    'resource'?: string | null;
}
/**
 * 
 * @export
 * @interface LocationHistoryDto
 */
export interface LocationHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'drivingSpeedUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryDto
     */
    'startOfDay'?: string;
    /**
     * 
     * @type {Array<LocationHistoryEntryDto>}
     * @memberof LocationHistoryDto
     */
    'locations'?: Array<LocationHistoryEntryDto> | null;
}
/**
 * 
 * @export
 * @interface LocationHistoryEntryDto
 */
export interface LocationHistoryEntryDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'lng'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'headingDirection'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'bearing'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'driverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryEntryDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryEntryDto
     */
    'vehicleOdometer'?: number | null;
}
/**
 * 
 * @export
 * @interface LocationHistoryVehicleDto
 */
export interface LocationHistoryVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof LocationHistoryVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationHistoryVehicleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface LocationHistoryVehicleDtoPagedResultDto
 */
export interface LocationHistoryVehicleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof LocationHistoryVehicleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<LocationHistoryVehicleDto>}
     * @memberof LocationHistoryVehicleDtoPagedResultDto
     */
    'items'?: Array<LocationHistoryVehicleDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LoginResultType = {
    Success: 'Success',
    InvalidUserNameOrPassword: 'InvalidUserNameOrPassword',
    NotAllowed: 'NotAllowed',
    LockedOut: 'LockedOut',
    RequiresTwoFactor: 'RequiresTwoFactor'
} as const;

export type LoginResultType = typeof LoginResultType[keyof typeof LoginResultType];


/**
 * 
 * @export
 * @interface MaintenanceDashboardConfigurationDto
 */
export interface MaintenanceDashboardConfigurationDto {
    /**
     * 
     * @type {MaintenanceDashboardSaveType}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'saveType': MaintenanceDashboardSaveType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'maintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'vehicleMaintenanceDashboardLayout'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MaintenanceDashboardConfigurationDto
     */
    'vehicleMaintenanceDashboardWidgetsConfiguration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MaintenanceDashboardSaveType = {
    Dashboard: 'Dashboard',
    VehicleDashboard: 'VehicleDashboard',
    VehicleWidgetsConfiguration: 'VehicleWidgetsConfiguration'
} as const;

export type MaintenanceDashboardSaveType = typeof MaintenanceDashboardSaveType[keyof typeof MaintenanceDashboardSaveType];


/**
 * 
 * @export
 * @interface MaintenanceDashboardVehicleDto
 */
export interface MaintenanceDashboardVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'mileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'eldDeviceSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driverIntId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driver'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceDashboardVehicleDto
     */
    'driverName'?: string | null;
}
/**
 * 
 * @export
 * @interface MarkInspectionUnofficialInputDto
 */
export interface MarkInspectionUnofficialInputDto {
    /**
     * 
     * @type {string}
     * @memberof MarkInspectionUnofficialInputDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MarkInspectionUnofficialInputDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface MasterAppData
 */
export interface MasterAppData {
    /**
     * 
     * @type {Array<CountryAppData>}
     * @memberof MasterAppData
     */
    'countries'?: Array<CountryAppData> | null;
    /**
     * 
     * @type {{ [key: string]: EventTypeCode; }}
     * @memberof MasterAppData
     */
    'eventTypeCodes'?: { [key: string]: EventTypeCode; } | null;
    /**
     * 
     * @type {AppDataCurrentCompanyTimeZone}
     * @memberof MasterAppData
     */
    'currentCompanyTimeZone'?: AppDataCurrentCompanyTimeZone | null;
    /**
     * 
     * @type {AppDataUserPermissions}
     * @memberof MasterAppData
     */
    'userPermissions'?: AppDataUserPermissions | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterAppData
     */
    'masterAdminExclusivePermissions'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceDto
 */
export interface MasterEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof MasterEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof MasterEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceDtoPagedResultDto
 */
export interface MasterEldDeviceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterEldDeviceDto>}
     * @memberof MasterEldDeviceDtoPagedResultDto
     */
    'items'?: Array<MasterEldDeviceDto> | null;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceListDto
 */
export interface MasterEldDeviceListDto {
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'assignedToTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'assignedToTenant'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'debuggingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'dataPlanEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterEldDeviceListDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {DeviceType}
     * @memberof MasterEldDeviceListDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {boolean}
     * @memberof MasterEldDeviceListDto
     */
    'hasNote'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterEldDeviceListDtoPagedResultDto
 */
export interface MasterEldDeviceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterEldDeviceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterEldDeviceListDto>}
     * @memberof MasterEldDeviceListDtoPagedResultDto
     */
    'items'?: Array<MasterEldDeviceListDto> | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResult
 */
export interface MasterFleetManagerCreateResult {
    /**
     * 
     * @type {MasterFleetManagerCreateResultFleetManager}
     * @memberof MasterFleetManagerCreateResult
     */
    'fleetManager'?: MasterFleetManagerCreateResultFleetManager | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResult
     */
    'setPasswordToken'?: string | null;
    /**
     * 
     * @type {MasterFleetManagerCreateResultUser}
     * @memberof MasterFleetManagerCreateResult
     */
    'user'?: MasterFleetManagerCreateResultUser | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResultFleetManager
 */
export interface MasterFleetManagerCreateResultFleetManager {
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'userId'?: string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerCreateResultFleetManager
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerCreateResultUser
 */
export interface MasterFleetManagerCreateResultUser {
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'phoneNumberConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lockoutEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lockoutEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'deleterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'deletionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'lastModifierId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MasterFleetManagerCreateResultUser
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerDto
 */
export interface MasterFleetManagerDto {
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'roleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerDto
     */
    'userId'?: string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerDtoPagedResultDto
 */
export interface MasterFleetManagerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterFleetManagerDto>}
     * @memberof MasterFleetManagerDtoPagedResultDto
     */
    'items'?: Array<MasterFleetManagerDto> | null;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerListDto
 */
export interface MasterFleetManagerListDto {
    /**
     * 
     * @type {RecordStatus}
     * @memberof MasterFleetManagerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof MasterFleetManagerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'roleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MasterFleetManagerListDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MasterFleetManagerListDtoPagedResultDto
 */
export interface MasterFleetManagerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MasterFleetManagerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MasterFleetManagerListDto>}
     * @memberof MasterFleetManagerListDtoPagedResultDto
     */
    'items'?: Array<MasterFleetManagerListDto> | null;
}
/**
 * 
 * @export
 * @interface MasterUploadedFileDto
 */
export interface MasterUploadedFileDto {
    /**
     * 
     * @type {string}
     * @memberof MasterUploadedFileDto
     */
    'processId'?: string;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof MasterUploadedFileDto
     */
    'fileData'?: Array<Array<string>> | null;
}
/**
 * 
 * @export
 * @interface MethodParameterApiDescriptionModel
 */
export interface MethodParameterApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'typeAsString'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodParameterApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MethodParameterApiDescriptionModel
     */
    'isOptional'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof MethodParameterApiDescriptionModel
     */
    'defaultValue'?: any | null;
}
/**
 * 
 * @export
 * @interface MobileAppVersionDto
 */
export interface MobileAppVersionDto {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof MobileAppVersionDto
     */
    'mobileApplicationType'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'timestamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDto
     */
    'buildNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileAppVersionDto
     */
    'downloadUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileAppVersionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MobileAppVersionDtoPagedResultDto
 */
export interface MobileAppVersionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MobileAppVersionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MobileAppVersionDto>}
     * @memberof MobileAppVersionDtoPagedResultDto
     */
    'items'?: Array<MobileAppVersionDto> | null;
}
/**
 * 
 * @export
 * @interface MobileApplicationDto
 */
export interface MobileApplicationDto {
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof MobileApplicationDto
     */
    'os'?: MobileApplicationType;
    /**
     * 
     * @type {string}
     * @memberof MobileApplicationDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileApplicationDto
     */
    'buildNumber'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MobileApplicationType = {
    None: 'None',
    Android: 'Android',
    AppleIos: 'AppleIos'
} as const;

export type MobileApplicationType = typeof MobileApplicationType[keyof typeof MobileApplicationType];


/**
 * 
 * @export
 * @interface MobileCreateTrailerDto
 */
export interface MobileCreateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileCreateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof MobileCreateTrailerDto
     */
    'trailerType'?: TrailerType | null;
    /**
     * 
     * @type {number}
     * @memberof MobileCreateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface MobileDeviceStatusPayload
 */
export interface MobileDeviceStatusPayload {
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'sdkLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'appVersionCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'coarseLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'fineLocationPermission'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'backgroundLocationPermission'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'storageSpace'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileDeviceStatusPayload
     */
    'status'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileDeviceStatusPayload
     */
    'connectedToEld'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceStatusPayload
     */
    'deviceTime'?: string | null;
}
/**
 * 
 * @export
 * @interface MobileEventOutputDto
 */
export interface MobileEventOutputDto {
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'driverUserId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'coDriverUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'creatorUsername'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'dutyStatusId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'cmvPowerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventRecordStatus'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventRecordOrigin'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventType'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'accumulatedVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'elapsedEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'distanceSinceLastValidCoordinates'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'malfunctionDiagnosticCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileEventOutputDto
     */
    'dataDiagnosticEventIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'geoLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventDataCheckValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'direction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MobileEventOutputDto
     */
    'malfunctionIndicatorStatus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'certificationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eldCreationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eldLastModificationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'endingTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'eventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'referenceEventUUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'parentEventUUID'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'trailerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileEventOutputDto
     */
    'lastModificationTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDto
     */
    'totalVehicleMilesSource'?: number | null;
}
/**
 * 
 * @export
 * @interface MobileEventOutputDtoPagedResultDto
 */
export interface MobileEventOutputDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof MobileEventOutputDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<MobileEventOutputDto>}
     * @memberof MobileEventOutputDtoPagedResultDto
     */
    'items'?: Array<MobileEventOutputDto> | null;
}
/**
 * 
 * @export
 * @interface ModuleApiDescriptionModel
 */
export interface ModuleApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ModuleApiDescriptionModel
     */
    'rootPath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModuleApiDescriptionModel
     */
    'remoteServiceName'?: string | null;
    /**
     * 
     * @type {{ [key: string]: ControllerApiDescriptionModel; }}
     * @memberof ModuleApiDescriptionModel
     */
    'controllers'?: { [key: string]: ControllerApiDescriptionModel; } | null;
}
/**
 * 
 * @export
 * @interface ModuleExtensionDto
 */
export interface ModuleExtensionDto {
    /**
     * 
     * @type {{ [key: string]: EntityExtensionDto; }}
     * @memberof ModuleExtensionDto
     */
    'entities'?: { [key: string]: EntityExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ModuleExtensionDto
     */
    'configuration'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MultiTenancyInfoDto
 */
export interface MultiTenancyInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof MultiTenancyInfoDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MultiTenancySides = {
    Tenant: 'Tenant',
    Host: 'Host',
    Both: 'Both'
} as const;

export type MultiTenancySides = typeof MultiTenancySides[keyof typeof MultiTenancySides];


/**
 * 
 * @export
 * @interface NameValue
 */
export interface NameValue {
    /**
     * 
     * @type {string}
     * @memberof NameValue
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameValue
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface NextDutyStatusEventDto
 */
export interface NextDutyStatusEventDto {
    /**
     * 
     * @type {number}
     * @memberof NextDutyStatusEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NextDutyStatusEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof NextDutyStatusEventDto
     */
    'odometer'?: number | null;
}
/**
 * 
 * @export
 * @interface NormalDriveConsumptionEfficiencyDto
 */
export interface NormalDriveConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof NormalDriveConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationSubject = {
    Driver: 'Driver',
    Vehicle: 'Vehicle',
    Trailer: 'Trailer',
    Company: 'Company',
    Other: 'Other'
} as const;

export type NotificationSubject = typeof NotificationSubject[keyof typeof NotificationSubject];


/**
 * 
 * @export
 * @interface NotificationSubscriptionDto
 */
export interface NotificationSubscriptionDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'name': string;
    /**
     * 
     * @type {RecordStatus}
     * @memberof NotificationSubscriptionDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'sendWindowStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionDto
     */
    'sendWindowEndTime'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionDto
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionDto
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: Array<EventPreferenceDto>; }}
     * @memberof NotificationSubscriptionDto
     */
    'eventPreferences'?: { [key: string]: Array<EventPreferenceDto>; } | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationSubscriptionDto
     */
    'selectedDrivers'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationSubscriptionDto
     */
    'selectedVehicles'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'isAllDriversSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionDto
     */
    'isAllVehiclesSelected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionDtoPagedResultDto
 */
export interface NotificationSubscriptionDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<NotificationSubscriptionDto>}
     * @memberof NotificationSubscriptionDtoPagedResultDto
     */
    'items'?: Array<NotificationSubscriptionDto> | null;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionListDto
 */
export interface NotificationSubscriptionListDto {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSubscriptionListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationSubscriptionListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionListDto
     */
    'emailRecipients'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationSubscriptionListDto
     */
    'smsRecipients'?: Array<string> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof NotificationSubscriptionListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface NotificationSubscriptionListDtoPagedResultDto
 */
export interface NotificationSubscriptionListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationSubscriptionListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<NotificationSubscriptionListDto>}
     * @memberof NotificationSubscriptionListDtoPagedResultDto
     */
    'items'?: Array<NotificationSubscriptionListDto> | null;
}
/**
 * 
 * @export
 * @interface NotificationTypeDto
 */
export interface NotificationTypeDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationTypeDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {NotificationSubject}
     * @memberof NotificationTypeDto
     */
    'subject'?: NotificationSubject;
    /**
     * 
     * @type {number}
     * @memberof NotificationTypeDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ObjectExtensionsDto
 */
export interface ObjectExtensionsDto {
    /**
     * 
     * @type {{ [key: string]: ModuleExtensionDto; }}
     * @memberof ObjectExtensionsDto
     */
    'modules'?: { [key: string]: ModuleExtensionDto; } | null;
    /**
     * 
     * @type {{ [key: string]: ExtensionEnumDto; }}
     * @memberof ObjectExtensionsDto
     */
    'enums'?: { [key: string]: ExtensionEnumDto; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Odometer = {
    Kilometers: 'Kilometers',
    Miles: 'Miles'
} as const;

export type Odometer = typeof Odometer[keyof typeof Odometer];


/**
 * 
 * @export
 * @enum {string}
 */

export const OdometerSource = {
    EnteredManually: 'EnteredManually',
    RecordedFromEld: 'RecordedFromELD'
} as const;

export type OdometerSource = typeof OdometerSource[keyof typeof OdometerSource];


/**
 * 
 * @export
 * @interface OnDutyOffDutyIdleTimeSpentDto
 */
export interface OnDutyOffDutyIdleTimeSpentDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof OnDutyOffDutyIdleTimeSpentDto
     */
    'onDutyValues'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof OnDutyOffDutyIdleTimeSpentDto
     */
    'offDutyValues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Ownership = {
    Company: 'Company',
    Contractor: 'Contractor',
    Leased: 'Leased'
} as const;

export type Ownership = typeof Ownership[keyof typeof Ownership];


/**
 * 
 * @export
 * @interface ParameterApiDescriptionModel
 */
export interface ParameterApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'nameOnMethod'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'jsonName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterApiDescriptionModel
     */
    'isOptional'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ParameterApiDescriptionModel
     */
    'defaultValue'?: any | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParameterApiDescriptionModel
     */
    'constraintTypes'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'bindingSourceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterApiDescriptionModel
     */
    'descriptorName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PeriodType = {
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type PeriodType = typeof PeriodType[keyof typeof PeriodType];


/**
 * 
 * @export
 * @interface PermissionGrantInfoDto
 */
export interface PermissionGrantInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGrantInfoDto
     */
    'parentName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionGrantInfoDto
     */
    'isGranted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionGrantInfoDto
     */
    'allowedProviders'?: Array<string> | null;
    /**
     * 
     * @type {Array<ProviderInfoDto>}
     * @memberof PermissionGrantInfoDto
     */
    'grantedProviders'?: Array<ProviderInfoDto> | null;
}
/**
 * 
 * @export
 * @interface PermissionGroupDto
 */
export interface PermissionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {Array<PermissionGrantInfoDto>}
     * @memberof PermissionGroupDto
     */
    'permissions'?: Array<PermissionGrantInfoDto> | null;
}
/**
 * 
 * @export
 * @interface PermissionListResultDto
 */
export interface PermissionListResultDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionListResultDto
     */
    'entityDisplayName'?: string | null;
    /**
     * 
     * @type {Array<ActionPermissionGroupDto>}
     * @memberof PermissionListResultDto
     */
    'actionPermissionGroups'?: Array<ActionPermissionGroupDto> | null;
    /**
     * 
     * @type {Array<FieldPermissionGroupDto>}
     * @memberof PermissionListResultDto
     */
    'fieldPermissionGroups'?: Array<FieldPermissionGroupDto> | null;
}
/**
 * 
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'isExternal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    'hasPassword'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProfileDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PropertyApiDescriptionModel
 */
export interface PropertyApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'jsonName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyApiDescriptionModel
     */
    'typeSimple'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyApiDescriptionModel
     */
    'isRequired'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProtectedFieldLevel = {
    Full: 'Full',
    ReadOnly: 'ReadOnly',
    Hidden: 'Hidden'
} as const;

export type ProtectedFieldLevel = typeof ProtectedFieldLevel[keyof typeof ProtectedFieldLevel];


/**
 * 
 * @export
 * @interface ProviderInfoDto
 */
export interface ProviderInfoDto {
    /**
     * 
     * @type {string}
     * @memberof ProviderInfoDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderInfoDto
     */
    'providerKey'?: string | null;
}
/**
 * 
 * @export
 * @interface PublicLiveTrackTokenDto
 */
export interface PublicLiveTrackTokenDto {
    /**
     * 
     * @type {string}
     * @memberof PublicLiveTrackTokenDto
     */
    'token'?: string | null;
}
/**
 * 
 * @export
 * @interface QuickSearchListDto
 */
export interface QuickSearchListDto {
    /**
     * 
     * @type {Array<DriverQuickSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'drivers'?: Array<DriverQuickSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'vehicles'?: Array<BaseSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'trailers'?: Array<BaseSearchListDto> | null;
    /**
     * 
     * @type {Array<BaseSearchListDto>}
     * @memberof QuickSearchListDto
     */
    'eldSerialNumbers'?: Array<BaseSearchListDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RankStatus = {
    Up: 'Up',
    Down: 'Down',
    Idle: 'Idle'
} as const;

export type RankStatus = typeof RankStatus[keyof typeof RankStatus];


/**
 * 
 * @export
 * @interface RawLiveTrackEvent
 */
export interface RawLiveTrackEvent {
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'deviceTimestamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'lat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'lng'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'bearing'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RawLiveTrackEvent
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'trailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawLiveTrackEvent
     */
    'tenantId'?: string | null;
}
/**
 * 
 * @export
 * @interface ReassignEventsInputDto
 */
export interface ReassignEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'endEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ReassignEventsInputDto
     */
    'driverId': number;
}
/**
 * 
 * @export
 * @interface ReassignTenantInputDto
 */
export interface ReassignTenantInputDto {
    /**
     * 
     * @type {string}
     * @memberof ReassignTenantInputDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReassignTenantInputDto
     */
    'parentTenantRegistrationId'?: string | null;
}
/**
 * 
 * @export
 * @interface RebuildCycleFromEventInputDto
 */
export interface RebuildCycleFromEventInputDto {
    /**
     * 
     * @type {number}
     * @memberof RebuildCycleFromEventInputDto
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface RebuildCycleInputDto
 */
export interface RebuildCycleInputDto {
    /**
     * 
     * @type {string}
     * @memberof RebuildCycleInputDto
     */
    'cycleId': string;
}
/**
 * 
 * @export
 * @interface RecentDriverViolationDto
 */
export interface RecentDriverViolationDto {
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'violationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentDriverViolationDto
     */
    'homeTerminalTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface RecentViolationDto
 */
export interface RecentViolationDto {
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecentViolationDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecentViolationDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDto
     */
    'violationsCount'?: number;
    /**
     * 
     * @type {Array<RecentDriverViolationDto>}
     * @memberof RecentViolationDto
     */
    'violations'?: Array<RecentDriverViolationDto> | null;
}
/**
 * 
 * @export
 * @interface RecentViolationDtoPagedResultDto
 */
export interface RecentViolationDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RecentViolationDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RecentViolationDto>}
     * @memberof RecentViolationDtoPagedResultDto
     */
    'items'?: Array<RecentViolationDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RecordStatus = {
    Inactive: 'Inactive',
    Active: 'Active'
} as const;

export type RecordStatus = typeof RecordStatus[keyof typeof RecordStatus];


/**
 * 
 * @export
 * @interface RegenerateIntermediatesInputDto
 */
export interface RegenerateIntermediatesInputDto {
    /**
     * 
     * @type {number}
     * @memberof RegenerateIntermediatesInputDto
     */
    'eventId': number;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'appName': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RegisterDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorInfo
 */
export interface RemoteServiceErrorInfo {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorInfo
     */
    'details'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RemoteServiceErrorInfo
     */
    'data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<RemoteServiceValidationErrorInfo>}
     * @memberof RemoteServiceErrorInfo
     */
    'validationErrors'?: Array<RemoteServiceValidationErrorInfo> | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorResponse
 */
export interface RemoteServiceErrorResponse {
    /**
     * 
     * @type {RemoteServiceErrorResponseError}
     * @memberof RemoteServiceErrorResponse
     */
    'error'?: RemoteServiceErrorResponseError | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceErrorResponseError
 */
export interface RemoteServiceErrorResponseError {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceErrorResponseError
     */
    'details'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RemoteServiceErrorResponseError
     */
    'data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<RemoteServiceValidationErrorInfo>}
     * @memberof RemoteServiceErrorResponseError
     */
    'validationErrors'?: Array<RemoteServiceValidationErrorInfo> | null;
}
/**
 * 
 * @export
 * @interface RemoteServiceValidationErrorInfo
 */
export interface RemoteServiceValidationErrorInfo {
    /**
     * 
     * @type {string}
     * @memberof RemoteServiceValidationErrorInfo
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoteServiceValidationErrorInfo
     */
    'members'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ReportDailylogreportPostRequest
 */
export interface ReportDailylogreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'graphHtml'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDailylogreportPostRequest
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportDailylogsreportPostRequest
 */
export interface ReportDailylogsreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDailylogsreportPostRequest
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDailylogsreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportDto
 */
export interface ReportDto {
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'requestedTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'requestedByUser'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'fileLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'reportInput'?: string | null;
    /**
     * 
     * @type {ReportStatus}
     * @memberof ReportDto
     */
    'status'?: ReportStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ReportDtoPagedResultDto
 */
export interface ReportDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ReportDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ReportDto>}
     * @memberof ReportDtoPagedResultDto
     */
    'items'?: Array<ReportDto> | null;
}
/**
 * 
 * @export
 * @interface ReportDvirinspectionsreportPostRequest
 */
export interface ReportDvirinspectionsreportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportDvirinspectionsreportPostRequest
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface ReportEldeventsreportPostRequest
 */
export interface ReportEldeventsreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportEldeventsreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportEldeventsreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportEldeventsreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportFormat = {
    Pdf: 'Pdf',
    Csv: 'Csv'
} as const;

export type ReportFormat = typeof ReportFormat[keyof typeof ReportFormat];


/**
 * 
 * @export
 * @interface ReportIftamileagereportPostRequest
 */
export interface ReportIftamileagereportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportIftamileagereportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {FuelType}
     * @memberof ReportIftamileagereportPostRequest
     */
    'fuelType'?: FuelType;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportIftamileagereportPostRequest
     */
    'clientTimeZone'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportIftamileagereportPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportIftamileagereportPostRequest
     */
    'reportFormat'?: ReportFormat;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportStatus = {
    Pending: 'Pending',
    Successful: 'Successful',
    Failed: 'Failed'
} as const;

export type ReportStatus = typeof ReportStatus[keyof typeof ReportStatus];


/**
 * 
 * @export
 * @interface ReportVehicledistancereportPostRequest
 */
export interface ReportVehicledistancereportPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicledistancereportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportVehicleinactivityreportPostRequest
 */
export interface ReportVehicleinactivityreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehicleinactivityreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ReportVehiclemileagesummaryreportPostRequest
 */
export interface ReportVehiclemileagesummaryreportPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportVehiclemileagesummaryreportPostRequest
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface ResetPasswordByEmailDto
 */
export interface ResetPasswordByEmailDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordByEmailDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'resetToken': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ResetTwoFactorAuthenticationSettingsInputDto
 */
export interface ResetTwoFactorAuthenticationSettingsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ResetTwoFactorAuthenticationSettingsInputDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ResizeEventInputDto
 */
export interface ResizeEventInputDto {
    /**
     * 
     * @type {number}
     * @memberof ResizeEventInputDto
     */
    'eventId': number;
    /**
     * 
     * @type {string}
     * @memberof ResizeEventInputDto
     */
    'duration': string;
    /**
     * 
     * @type {string}
     * @memberof ResizeEventInputDto
     */
    'durationAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface ResolveDvirDefectDto
 */
export interface ResolveDvirDefectDto {
    /**
     * 
     * @type {number}
     * @memberof ResolveDvirDefectDto
     */
    'defectId'?: number;
    /**
     * 
     * @type {DefectCorrectedStatus}
     * @memberof ResolveDvirDefectDto
     */
    'isCorrected'?: DefectCorrectedStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveDvirDefectDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ResolvedObd2Code
 */
export interface ResolvedObd2Code {
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'partCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'partName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'systemCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'systemName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolvedObd2Code
     */
    'number'?: string | null;
}
/**
 * 
 * @export
 * @interface ReturnValueApiDescriptionModel
 */
export interface ReturnValueApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof ReturnValueApiDescriptionModel
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReturnValueApiDescriptionModel
     */
    'typeSimple'?: string | null;
}
/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'actionPermissions'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'fieldPermissions'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isAssigned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface RoleDtoPagedResultDto
 */
export interface RoleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RoleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof RoleDtoPagedResultDto
     */
    'items'?: Array<RoleDto> | null;
}
/**
 * 
 * @export
 * @interface RoleListDto
 */
export interface RoleListDto {
    /**
     * 
     * @type {string}
     * @memberof RoleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isStatic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleListDto
     */
    'isAssigned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface RoleListDtoPagedResultDto
 */
export interface RoleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof RoleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<RoleListDto>}
     * @memberof RoleListDtoPagedResultDto
     */
    'items'?: Array<RoleListDto> | null;
}
/**
 * 
 * @export
 * @interface RolloverInputDto
 */
export interface RolloverInputDto {
    /**
     * 
     * @type {number}
     * @memberof RolloverInputDto
     */
    'fromDriverId': number;
    /**
     * 
     * @type {number}
     * @memberof RolloverInputDto
     */
    'toCoDriverId': number;
}
/**
 * 
 * @export
 * @interface RootActionPermissionGroup
 */
export interface RootActionPermissionGroup {
    /**
     * 
     * @type {RootActionPermissionGroupGroup}
     * @memberof RootActionPermissionGroup
     */
    'group'?: RootActionPermissionGroupGroup | null;
    /**
     * 
     * @type {Array<ActionPermissionGroup>}
     * @memberof RootActionPermissionGroup
     */
    'permissionGroups'?: Array<ActionPermissionGroup> | null;
}
/**
 * 
 * @export
 * @interface RootActionPermissionGroupGroup
 */
export interface RootActionPermissionGroupGroup {
    /**
     * 
     * @type {string}
     * @memberof RootActionPermissionGroupGroup
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RootActionPermissionGroupGroup
     */
    'displayName'?: string | null;
}
/**
 * 
 * @export
 * @interface SafetyAlertListDto
 */
export interface SafetyAlertListDto {
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof SafetyAlertListDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'messageReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAlertListDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface SafetyAlertListDtoListResultDto
 */
export interface SafetyAlertListDtoListResultDto {
    /**
     * 
     * @type {Array<SafetyAlertListDto>}
     * @memberof SafetyAlertListDtoListResultDto
     */
    'items'?: Array<SafetyAlertListDto> | null;
}
/**
 * 
 * @export
 * @interface SafetyDashboardDriverDto
 */
export interface SafetyDashboardDriverDto {
    /**
     * 
     * @type {number}
     * @memberof SafetyDashboardDriverDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {MobileApplicationType}
     * @memberof SafetyDashboardDriverDto
     */
    'mobileAppType'?: MobileApplicationType | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'mobileAppVersion'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SafetyDashboardDriverDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyDashboardDriverDto
     */
    'vehicle'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveNotificationPreferenceDto
 */
export interface SaveNotificationPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SaveNotificationPreferenceDto
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveNotificationPreferenceDto
     */
    'notificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'driverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SaveNotificationPreferenceDto
     */
    'trailerIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface SaveSingleUserNotificationPreferenceDto
 */
export interface SaveSingleUserNotificationPreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveSingleUserNotificationPreferenceDto
     */
    'trailerId'?: number | null;
}
/**
 * 
 * @export
 * @interface SaveUserLastReadNotificationDto
 */
export interface SaveUserLastReadNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof SaveUserLastReadNotificationDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SaveUserLastReadNotificationDto
     */
    'lastReadNotificationTime': string;
}
/**
 * 
 * @export
 * @interface SearchRule
 */
export interface SearchRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRule
     */
    'columns'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRule
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface SendPasswordResetCodeDto
 */
export interface SendPasswordResetCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'appName': string;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'returnUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendPasswordResetCodeDto
     */
    'returnUrlHash'?: string | null;
}
/**
 * 
 * @export
 * @interface ServiceAccountCreationInputDto
 */
export interface ServiceAccountCreationInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceAccountCreationInputDto
     */
    'tenantIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountCreationInputDto
     */
    'companyName'?: string | null;
}
/**
 * 
 * @export
 * @interface ServiceRemindersDto
 */
export interface ServiceRemindersDto {
    /**
     * 
     * @type {number}
     * @memberof ServiceRemindersDto
     */
    'overdue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceRemindersDto
     */
    'soon'?: number;
}
/**
 * 
 * @export
 * @interface SetDrivingNoteInputDto
 */
export interface SetDrivingNoteInputDto {
    /**
     * 
     * @type {number}
     * @memberof SetDrivingNoteInputDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetDrivingNoteInputDto
     */
    'logDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetDrivingNoteInputDto
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ShiftEventsDirection = {
    Past: 'Past',
    Future: 'Future'
} as const;

export type ShiftEventsDirection = typeof ShiftEventsDirection[keyof typeof ShiftEventsDirection];


/**
 * 
 * @export
 * @interface ShiftEventsInputDto
 */
export interface ShiftEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof ShiftEventsInputDto
     */
    'startEvent': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftEventsInputDto
     */
    'endEvent': number;
    /**
     * 
     * @type {ShiftEventsDirection}
     * @memberof ShiftEventsInputDto
     */
    'direction': ShiftEventsDirection;
    /**
     * 
     * @type {string}
     * @memberof ShiftEventsInputDto
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftEventsInputDto
     */
    'timeAsTimeSpan'?: string;
}
/**
 * 
 * @export
 * @interface SignatureDto
 */
export interface SignatureDto {
    /**
     * 
     * @type {number}
     * @memberof SignatureDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SignatureDto
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignatureDto
     */
    'signatureBase64'?: string | null;
}
/**
 * 
 * @export
 * @interface SingleDeviceUsageDetail
 */
export interface SingleDeviceUsageDetail {
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'startTime'?: string;
    /**
     * 
     * @type {EldDeviceUsageType}
     * @memberof SingleDeviceUsageDetail
     */
    'usageType'?: EldDeviceUsageType;
    /**
     * 
     * @type {string}
     * @memberof SingleDeviceUsageDetail
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface SlowPacedConsumptionEfficiencyDto
 */
export interface SlowPacedConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlowPacedConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface SmartFixEventsInputDto
 */
export interface SmartFixEventsInputDto {
    /**
     * 
     * @type {number}
     * @memberof SmartFixEventsInputDto
     */
    'driverId': number;
    /**
     * 
     * @type {string}
     * @memberof SmartFixEventsInputDto
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof SmartFixEventsInputDto
     */
    'to': string;
    /**
     * 
     * @type {FixEventsDirection}
     * @memberof SmartFixEventsInputDto
     */
    'fixEventsDirection': FixEventsDirection;
}
/**
 * 
 * @export
 * @interface SmtpConfiguration
 */
export interface SmtpConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'server'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SmtpConfiguration
     */
    'port'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'senderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmtpConfiguration
     */
    'defaultSenderAddress'?: string | null;
}
/**
 * 
 * @export
 * @interface SpeedingConsumptionEfficiencyDto
 */
export interface SpeedingConsumptionEfficiencyDto {
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'morningValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'noonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'afterNoonValues'?: number;
    /**
     * 
     * @type {number}
     * @memberof SpeedingConsumptionEfficiencyDto
     */
    'nightValues'?: number;
}
/**
 * 
 * @export
 * @interface SpeedingDto
 */
export interface SpeedingDto {
    /**
     * 
     * @type {string}
     * @memberof SpeedingDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SpeedingDto
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof SpeedingDto
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpeedingDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SpeedingDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SpeedingDto
     */
    'growth'?: number;
}
/**
 * 
 * @export
 * @interface StateAppData
 */
export interface StateAppData {
    /**
     * 
     * @type {string}
     * @memberof StateAppData
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StateAppData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StateAppData
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    'icon'?: string | null;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof StateDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof StateDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface StateDtoCountry
 */
export interface StateDtoCountry {
    /**
     * 
     * @type {string}
     * @memberof StateDtoCountry
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateDtoCountry
     */
    'icon'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StateDtoCountry
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface StateGeolocationResultModel
 */
export interface StateGeolocationResultModel {
    /**
     * 
     * @type {string}
     * @memberof StateGeolocationResultModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateGeolocationResultModel
     */
    'abbreviation'?: string | null;
}
/**
 * 
 * @export
 * @interface StringUpdateManyInputDto
 */
export interface StringUpdateManyInputDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringUpdateManyInputDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof StringUpdateManyInputDto
     */
    'data'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Suspension = {
    Air: 'Air',
    Spring: 'Spring'
} as const;

export type Suspension = typeof Suspension[keyof typeof Suspension];


/**
 * 
 * @export
 * @interface SystemNotificationDto
 */
export interface SystemNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'notificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemNotificationDto
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'entityType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'entityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemNotificationDto
     */
    'notificationType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemNotificationDto
     */
    'isRead'?: boolean;
}
/**
 * 
 * @export
 * @interface SystemNotificationResultDto
 */
export interface SystemNotificationResultDto {
    /**
     * 
     * @type {Array<SystemNotificationDto>}
     * @memberof SystemNotificationResultDto
     */
    'items'?: Array<SystemNotificationDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemNotificationResultDto
     */
    'hasMore'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantAppData
 */
export interface TenantAppData {
    /**
     * 
     * @type {string}
     * @memberof TenantAppData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantAppData
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantAppData
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantCreateDto
 */
export interface TenantCreateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'adminPassword': string;
    /**
     * 
     * @type {string}
     * @memberof TenantCreateDto
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantCreateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TenantDto
 */
export interface TenantDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TenantDtoPagedResultDto
 */
export interface TenantDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantDto>}
     * @memberof TenantDtoPagedResultDto
     */
    'items'?: Array<TenantDto> | null;
}
/**
 * 
 * @export
 * @interface TenantEldDeviceViewDto
 */
export interface TenantEldDeviceViewDto {
    /**
     * 
     * @type {string}
     * @memberof TenantEldDeviceViewDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEldDeviceViewDto
     */
    'tenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEldDeviceViewDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantEldDeviceViewDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TenantEldDeviceViewDtoPagedResultDto
 */
export interface TenantEldDeviceViewDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantEldDeviceViewDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantEldDeviceViewDto>}
     * @memberof TenantEldDeviceViewDtoPagedResultDto
     */
    'items'?: Array<TenantEldDeviceViewDto> | null;
}
/**
 * 
 * @export
 * @interface TenantOutputDto
 */
export interface TenantOutputDto {
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'appUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'webApiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantOutputDto
     */
    'hasOwnElds'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'parentTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantOutputDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantOutputDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface TenantOutputDtoPagedResultDto
 */
export interface TenantOutputDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantOutputDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantOutputDto>}
     * @memberof TenantOutputDtoPagedResultDto
     */
    'items'?: Array<TenantOutputDto> | null;
}
/**
 * 
 * @export
 * @interface TenantRegistrationBasicInfoDto
 */
export interface TenantRegistrationBasicInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationBasicInfoDto
     */
    'tenantRegistrationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationBasicInfoDto
     */
    'tenantName'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantRegistrationDto
 */
export interface TenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorTenantId'?: string | null;
    /**
     * 
     * @type {TenantRegistrationStatus}
     * @memberof TenantRegistrationDto
     */
    'tenantRegistrationStatus'?: TenantRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'statusTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'createdTenantId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'hasMasterAccount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'creatorTenantName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'masterAccessSuspended'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof TenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantRegistrationDtoPagedResultDto
 */
export interface TenantRegistrationDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TenantRegistrationDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TenantRegistrationDto>}
     * @memberof TenantRegistrationDtoPagedResultDto
     */
    'items'?: Array<TenantRegistrationDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TenantRegistrationStatus = {
    RegistrationPending: 'RegistrationPending',
    Active: 'Active',
    RegistrationRejected: 'RegistrationRejected',
    DeletePending: 'DeletePending',
    Deleted: 'Deleted',
    DeleteRejected: 'DeleteRejected',
    Registering: 'Registering',
    RegistrationFailed: 'RegistrationFailed',
    Deleting: 'Deleting',
    DeletionFailed: 'DeletionFailed',
    DeactivationPending: 'DeactivationPending',
    Deactivated: 'Deactivated',
    DeactivationRejected: 'DeactivationRejected',
    Deactivating: 'Deactivating',
    DeactivationFailed: 'DeactivationFailed',
    Reactivating: 'Reactivating',
    ReactivationFailed: 'ReactivationFailed'
} as const;

export type TenantRegistrationStatus = typeof TenantRegistrationStatus[keyof typeof TenantRegistrationStatus];


/**
 * 
 * @export
 * @interface TenantServiceAccountCreationResult
 */
export interface TenantServiceAccountCreationResult {
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'passwordResetToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'contactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantServiceAccountCreationResult
     */
    'createdUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface TenantUpdateDto
 */
export interface TenantUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TenantUpdateDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface TerminalTimeZoneAppData
 */
export interface TerminalTimeZoneAppData {
    /**
     * 
     * @type {string}
     * @memberof TerminalTimeZoneAppData
     */
    'timeZoneId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalTimeZoneAppData
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface TimeZone
 */
export interface TimeZone {
    /**
     * 
     * @type {TimeZoneIana}
     * @memberof TimeZone
     */
    'iana'?: TimeZoneIana | null;
    /**
     * 
     * @type {TimeZoneWindows}
     * @memberof TimeZone
     */
    'windows'?: TimeZoneWindows | null;
}
/**
 * 
 * @export
 * @interface TimeZoneIana
 */
export interface TimeZoneIana {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneIana
     */
    'timeZoneName'?: string | null;
}
/**
 * 
 * @export
 * @interface TimeZoneWindows
 */
export interface TimeZoneWindows {
    /**
     * 
     * @type {string}
     * @memberof TimeZoneWindows
     */
    'timeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface TimingDto
 */
export interface TimingDto {
    /**
     * 
     * @type {TimingDtoTimeZone}
     * @memberof TimingDto
     */
    'timeZone'?: TimingDtoTimeZone | null;
}
/**
 * 
 * @export
 * @interface TimingDtoTimeZone
 */
export interface TimingDtoTimeZone {
    /**
     * 
     * @type {TimeZoneIana}
     * @memberof TimingDtoTimeZone
     */
    'iana'?: TimeZoneIana | null;
    /**
     * 
     * @type {TimeZoneWindows}
     * @memberof TimingDtoTimeZone
     */
    'windows'?: TimeZoneWindows | null;
}
/**
 * 
 * @export
 * @interface TireStatusDto
 */
export interface TireStatusDto {
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'axle'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'tire'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'psi'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TireStatusDto
     */
    'airLeakageRate'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TireStatusDto
     */
    'faults'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface TotalDriversWidgetDto
 */
export interface TotalDriversWidgetDto {
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'activeDrivers'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithPhysicalEldDisconnections'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithHarshGeometrisEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithSpeedingEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithUnresolvedDvirDefects'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithPhysicalEldDisconnectionsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithHarshGeometrisEventsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithSpeedingEventsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalDriversWidgetDto
     */
    'driversWithUnresolvedDvirDefectsPercentage'?: number | null;
}
/**
 * 
 * @export
 * @interface TotalFuelConsumptionDto
 */
export interface TotalFuelConsumptionDto {
    /**
     * 
     * @type {number}
     * @memberof TotalFuelConsumptionDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TotalFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof TotalFuelConsumptionDto
     */
    'stops'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TotalFuelPercentageInIdleStateDto
 */
export interface TotalFuelPercentageInIdleStateDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof TotalFuelPercentageInIdleStateDto
     */
    'values'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface TotalVehiclesWidgetDto
 */
export interface TotalVehiclesWidgetDto {
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'activeVehicles'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithDiagnosticErrors'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithUnresolvedDvirDefects'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithTpmsAlerts'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithCriticalGeometrisEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithDiagnosticErrorsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithUnresolvedDvirDefectsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithTpmsAlertsPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TotalVehiclesWidgetDto
     */
    'vehiclesWithCriticalGeometrisEventsPercentage'?: number | null;
}
/**
 * 
 * @export
 * @interface TrailerAdvancedSearchListDto
 */
export interface TrailerAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerAdvancedSearchListDto
     */
    'inMotion'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAdvancedSearchListDto
     */
    'lastMotionStatusChange'?: string | null;
}
/**
 * 
 * @export
 * @interface TrailerDto
 */
export interface TrailerDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof TrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof TrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {DriverDtoCompany}
     * @memberof TrailerDto
     */
    'company'?: DriverDtoCompany | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof TrailerDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerDtoPagedResultDto
 */
export interface TrailerDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerDto>}
     * @memberof TrailerDtoPagedResultDto
     */
    'items'?: Array<TrailerDto> | null;
}
/**
 * 
 * @export
 * @interface TrailerGpsLocationDto
 */
export interface TrailerGpsLocationDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'lng'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'lat'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrailerGpsLocationDto
     */
    'lastMotionStatusChange'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerGpsLocationDto
     */
    'inMotion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerGpsLocationDto
     */
    'odometer'?: number | null;
}
/**
 * 
 * @export
 * @interface TrailerHistoryStatusInfoDto
 */
export interface TrailerHistoryStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'inMotion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrailerHistoryStatusInfoDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerListDto
 */
export interface TrailerListDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof TrailerListDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof TrailerListDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof TrailerListDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerListDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrailerListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrailerListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerListDtoPagedResultDto
 */
export interface TrailerListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerListDto>}
     * @memberof TrailerListDtoPagedResultDto
     */
    'items'?: Array<TrailerListDto> | null;
}
/**
 * 
 * @export
 * @interface TrailerSyncDto
 */
export interface TrailerSyncDto {
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerSyncDto
     */
    'lastModificationTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrailerSyncDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TrailerTrackingProviderDto
 */
export interface TrailerTrackingProviderDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerTrackingProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof TrailerTrackingProviderDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerTrackingProviderDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {TrailerTrackingProviders}
     * @memberof TrailerTrackingProviderDto
     */
    'provider': TrailerTrackingProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TrailerTrackingProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface TrailerTrackingProviderDtoPagedResultDto
 */
export interface TrailerTrackingProviderDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TrailerTrackingProviderDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TrailerTrackingProviderDto>}
     * @memberof TrailerTrackingProviderDtoPagedResultDto
     */
    'items'?: Array<TrailerTrackingProviderDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrailerTrackingProviders = {
    Spireon: 'Spireon',
    MachineLink: 'MachineLink'
} as const;

export type TrailerTrackingProviders = typeof TrailerTrackingProviders[keyof typeof TrailerTrackingProviders];


/**
 * 
 * @export
 * @enum {string}
 */

export const TrailerType = {
    DryVan: 'DryVan',
    Flatbed: 'Flatbed',
    Po: 'Po',
    Reefer: 'Reefer'
} as const;

export type TrailerType = typeof TrailerType[keyof typeof TrailerType];


/**
 * 
 * @export
 * @interface TrailersUsageHistoryListDto
 */
export interface TrailersUsageHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof TrailersUsageHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailersUsageHistoryListDto
     */
    'startTime'?: string;
}
/**
 * 
 * @export
 * @interface TripDetailData
 */
export interface TripDetailData {
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'reportDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripDetailData
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripDetailData
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<VehicleTripDetailData>}
     * @memberof TripDetailData
     */
    'vehicles'?: Array<VehicleTripDetailData> | null;
}
/**
 * 
 * @export
 * @interface TripReportDetailData
 */
export interface TripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'reportDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripReportDetailData
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripReportDetailData
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<VehicleTripReportDetailData>}
     * @memberof TripReportDetailData
     */
    'vehicles'?: Array<VehicleTripReportDetailData> | null;
    /**
     * 
     * @type {number}
     * @memberof TripReportDetailData
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByStateListDto
 */
export interface TripsViewByStateListDto {
    /**
     * 
     * @type {string}
     * @memberof TripsViewByStateListDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewByStateListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByStateListDtoPagedResultDto
 */
export interface TripsViewByStateListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewByStateListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewByStateListDto>}
     * @memberof TripsViewByStateListDtoPagedResultDto
     */
    'items'?: Array<TripsViewByStateListDto> | null;
}
/**
 * 
 * @export
 * @interface TripsViewByVehicleListDto
 */
export interface TripsViewByVehicleListDto {
    /**
     * 
     * @type {string}
     * @memberof TripsViewByVehicleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewByVehicleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface TripsViewByVehicleListDtoPagedResultDto
 */
export interface TripsViewByVehicleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewByVehicleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewByVehicleListDto>}
     * @memberof TripsViewByVehicleListDtoPagedResultDto
     */
    'items'?: Array<TripsViewByVehicleListDto> | null;
}
/**
 * 
 * @export
 * @interface TripsViewListDto
 */
export interface TripsViewListDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'startOdometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'endOdometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDto
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'ianaTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TripsViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TripsViewListDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface TripsViewListDtoPagedResultDto
 */
export interface TripsViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof TripsViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<TripsViewListDto>}
     * @memberof TripsViewListDtoPagedResultDto
     */
    'items'?: Array<TripsViewListDto> | null;
}
/**
 * 
 * @export
 * @interface TwoFactorAuthenticationSettingsDto
 */
export interface TwoFactorAuthenticationSettingsDto {
    /**
     * 
     * @type {TwoFactorAuthenticationType}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'selectedAuthenticationType'?: TwoFactorAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'authenticatorSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthenticationSettingsDto
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TwoFactorAuthenticationType = {
    None: 'None',
    Phone: 'Phone',
    Authenticator: 'Authenticator'
} as const;

export type TwoFactorAuthenticationType = typeof TwoFactorAuthenticationType[keyof typeof TwoFactorAuthenticationType];


/**
 * 
 * @export
 * @interface TypeApiDescriptionModel
 */
export interface TypeApiDescriptionModel {
    /**
     * 
     * @type {string}
     * @memberof TypeApiDescriptionModel
     */
    'baseType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TypeApiDescriptionModel
     */
    'isEnum'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeApiDescriptionModel
     */
    'enumNames'?: Array<string> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof TypeApiDescriptionModel
     */
    'enumValues'?: Array<any> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeApiDescriptionModel
     */
    'genericArguments'?: Array<string> | null;
    /**
     * 
     * @type {Array<PropertyApiDescriptionModel>}
     * @memberof TypeApiDescriptionModel
     */
    'properties'?: Array<PropertyApiDescriptionModel> | null;
}
/**
 * 
 * @export
 * @interface UnidentifiedEventsListDto
 */
export interface UnidentifiedEventsListDto {
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'startLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'endLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnidentifiedEventsListDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDto
     */
    'distance'?: number;
}
/**
 * 
 * @export
 * @interface UnidentifiedEventsListDtoPagedResultDto
 */
export interface UnidentifiedEventsListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof UnidentifiedEventsListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<UnidentifiedEventsListDto>}
     * @memberof UnidentifiedEventsListDtoPagedResultDto
     */
    'items'?: Array<UnidentifiedEventsListDto> | null;
}
/**
 * 
 * @export
 * @interface UnresolvedDvirDefectsDto
 */
export interface UnresolvedDvirDefectsDto {
    /**
     * 
     * @type {number}
     * @memberof UnresolvedDvirDefectsDto
     */
    'major'?: number;
    /**
     * 
     * @type {number}
     * @memberof UnresolvedDvirDefectsDto
     */
    'minor'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCompanyDto
 */
export interface UpdateCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'dot'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {CargoType}
     * @memberof UpdateCompanyDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'thirtyMinuteBreakException'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'twentyFourHrCycleReset'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCompanyDto
     */
    'dvirWarnings'?: boolean;
    /**
     * 
     * @type {Odometer}
     * @memberof UpdateCompanyDto
     */
    'odometer'?: Odometer | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'fleetOverSpeedingThreshold'?: number | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof UpdateCompanyDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateCompanyDto
     */
    'dutyCycleId'?: Array<number> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateCompanyDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateCompanyDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateCompanyDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDemoAccountDto
 */
export interface UpdateDemoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDemoAccountDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDemoAccountDto
     */
    'tenantId': string;
}
/**
 * 
 * @export
 * @interface UpdateDriverDto
 */
export interface UpdateDriverDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {DriverType}
     * @memberof UpdateDriverDto
     */
    'driverType'?: DriverType;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateDriverDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'licenceCountryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'licenceStateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'licenceNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'exemptFromEld'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowYardMove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowPersonalConveyance'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowManualDriveTime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'allowLogEditing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {CargoType}
     * @memberof UpdateDriverDto
     */
    'cargoType'?: CargoType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'brakeException30Minutes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'cycleReset24Hours'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'fullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverDto
     */
    'address'?: string | null;
    /**
     * 
     * @type {Array<CycleRuleDto>}
     * @memberof UpdateDriverDto
     */
    'cycleRules'?: Array<CycleRuleDto> | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateDriverDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverDto
     */
    'hideUnidentifiedEvents'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateDvirFormDto
 */
export interface UpdateDvirFormDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDvirFormDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDvirFormDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {Array<DvirFormAreaDto>}
     * @memberof UpdateDvirFormDto
     */
    'areas'?: Array<DvirFormAreaDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateDvirFormDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateDvirFormDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateEldDeviceDto
 */
export interface UpdateEldDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateEldDeviceDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {Vendor}
     * @memberof UpdateEldDeviceDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {DeviceType}
     * @memberof UpdateEldDeviceDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'macAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEldDeviceDto
     */
    'deviceName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEldDeviceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFeatureDto
 */
export interface UpdateFeatureDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFeatureDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeatureDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFeaturesDto
 */
export interface UpdateFeaturesDto {
    /**
     * 
     * @type {Array<UpdateFeatureDto>}
     * @memberof UpdateFeaturesDto
     */
    'features'?: Array<UpdateFeatureDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateFleetManagerDto
 */
export interface UpdateFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFleetManagerDto
     */
    'companyIds'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFleetManagerDto
     */
    'canEditLogs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFleetManagerDto
     */
    'canResolveDefects'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFleetManagerDto
     */
    'groupIds'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFleetManagerDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFuelProviderDto
 */
export interface UpdateFuelProviderDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateFuelProviderDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFuelProviderDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {FuelProviders}
     * @memberof UpdateFuelProviderDto
     */
    'provider': FuelProviders;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFuelProviderDto
     */
    'configuration': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UpdateMasterEventInput
 */
export interface UpdateMasterEventInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventTypeCode': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'startTime': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'vehicleId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'driverId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'shippingDocumentNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'eventSequenceIdNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'accumulatedVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'totalVehicleMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'elapsedEngineHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'totalEngineHours'?: number;
    /**
     * 
     * @type {EventLocationSource}
     * @memberof UpdateMasterEventInput
     */
    'locationSource'?: EventLocationSource;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'driversLocationDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'countryId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMasterEventInput
     */
    'stateId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterEventInput
     */
    'certificationDate'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMasterFleetManagerDto
 */
export interface UpdateMasterFleetManagerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'roleName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMasterFleetManagerDto
     */
    'fullName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePermissionDto
 */
export interface UpdatePermissionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePermissionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePermissionDto
     */
    'isGranted'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatePermissionsDto
 */
export interface UpdatePermissionsDto {
    /**
     * 
     * @type {Array<UpdatePermissionDto>}
     * @memberof UpdatePermissionsDto
     */
    'permissions'?: Array<UpdatePermissionDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateProfileDto
 */
export interface UpdateProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateProfileDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface UpdateRoleDto
 */
export interface UpdateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'defaultDashboard'?: string | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof UpdateRoleDto
     */
    'actionPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof UpdateRoleDto
     */
    'fieldPermissions'?: { [key: string]: { [key: string]: any; }; } | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'concurrencyStamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoleDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateRoleDto
     */
    'extraProperties'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface UpdateTenantDto
 */
export interface UpdateTenantDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactEmail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'customerContactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantDto
     */
    'domainName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTenantRegistrationDto
 */
export interface UpdateTenantRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'customerContactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'adminName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantRegistrationDto
     */
    'adminEmailAddress': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantRegistrationDto
     */
    'hasOwnElds'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateTrailerDto
 */
export interface UpdateTrailerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {TrailerType}
     * @memberof UpdateTrailerDto
     */
    'trailerType'?: TrailerType;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'year'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Ownership}
     * @memberof UpdateTrailerDto
     */
    'ownership'?: Ownership | null;
    /**
     * 
     * @type {Suspension}
     * @memberof UpdateTrailerDto
     */
    'suspension'?: Suspension | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerDto
     */
    'gpsSerial'?: string | null;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateTrailerDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateTrailerDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UpdateVehicleDto
 */
export interface UpdateVehicleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof UpdateVehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Odometer}
     * @memberof UpdateVehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof UpdateVehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {Array<DocumentCreateOrUpdateDto>}
     * @memberof UpdateVehicleDto
     */
    'documents'?: Array<DocumentCreateOrUpdateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface UploadSignaturesInputDto
 */
export interface UploadSignaturesInputDto {
    /**
     * 
     * @type {Array<SignatureDto>}
     * @memberof UploadSignaturesInputDto
     */
    'signatures'?: Array<SignatureDto> | null;
}
/**
 * 
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'surname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    'emailConfirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    'phoneNumberConfirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDataListResultDto
 */
export interface UserDataListResultDto {
    /**
     * 
     * @type {Array<UserData>}
     * @memberof UserDataListResultDto
     */
    'items'?: Array<UserData> | null;
}
/**
 * 
 * @export
 * @interface UserLoginInfo
 */
export interface UserLoginInfo {
    /**
     * 
     * @type {string}
     * @memberof UserLoginInfo
     */
    'userNameOrEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UserLoginInfo
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserLoginInfo
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface UserNotificationPreferenceDto
 */
export interface UserNotificationPreferenceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredNotificationTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredVehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredDriverIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredTrailerIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserNotificationPreferenceDto
     */
    'ignoredCompanyIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UserOverrideInput
 */
export interface UserOverrideInput {
    /**
     * 
     * @type {string}
     * @memberof UserOverrideInput
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserOverrideInput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserOverrideOutput
 */
export interface UserOverrideOutput {
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'accessToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOverrideOutput
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserOverrideOutput
     */
    'requestedScopes'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserPreferenceGetDto
 */
export interface UserPreferenceGetDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceGetDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface UserPreferenceSaveDto
 */
export interface UserPreferenceSaveDto {
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceSaveDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserPreferenceSaveDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'detail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'end'?: number;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ValidationError
     */
    'errorType'?: ValidationStatus;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'line'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationError
     */
    'start'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ValidationStatus = {
    Valid: 'Valid',
    Error: 'Error',
    Warning: 'Warning',
    Information: 'Information',
    NotValidated: 'NotValidated'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];


/**
 * 
 * @export
 * @interface VehicleAdvancedSearchListDto
 */
export interface VehicleAdvancedSearchListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleAdvancedSearchListDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleAdvancedSearchListDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleAdvancedSearchListDto
     */
    'coDriverName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDiagnosticRecord
 */
export interface VehicleDiagnosticRecord {
    /**
     * 
     * @type {number}
     * @memberof VehicleDiagnosticRecord
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDiagnosticRecord
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'description'?: string | null;
    /**
     * 
     * @type {DiagnosticCodeType}
     * @memberof VehicleDiagnosticRecord
     */
    'type'?: DiagnosticCodeType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDiagnosticRecord
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface VehicleDistanceReportDto
 */
export interface VehicleDistanceReportDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleDistanceReportDto
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDistanceReportDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDistanceReportDto
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDriversAndDrivingPeriodListDto
 */
export interface VehicleDriversAndDrivingPeriodListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDriversAndDrivingPeriodListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDto
 */
export interface VehicleDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'color'?: string | null;
    /**
     * 
     * @type {FuelType}
     * @memberof VehicleDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'countryId'?: number;
    /**
     * 
     * @type {StateDtoCountry}
     * @memberof VehicleDto
     */
    'country'?: StateDtoCountry | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {CompanyDtoState}
     * @memberof VehicleDto
     */
    'state'?: CompanyDtoState | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {DriverDtoCompany}
     * @memberof VehicleDto
     */
    'company'?: DriverDtoCompany | null;
    /**
     * 
     * @type {Odometer}
     * @memberof VehicleDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'companyOwned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof VehicleDto
     */
    'documents'?: Array<DocumentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDtoPagedResultDto
 */
export interface VehicleDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleDto>}
     * @memberof VehicleDtoPagedResultDto
     */
    'items'?: Array<VehicleDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirDefectDto
 */
export interface VehicleDvirDefectDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'dvirReportId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'area'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'defectDescription'?: string | null;
    /**
     * 
     * @type {DvirFormAreaPointSeverity}
     * @memberof VehicleDvirDefectDto
     */
    'severity'?: DvirFormAreaPointSeverity;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirDefectDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirDefectDto
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryEntryDto
 */
export interface VehicleDvirHistoryEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'minorDefectsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'majorDefectsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'hasUnresolvedDefects'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryEntryDto
     */
    'companyId'?: number;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryListDto
 */
export interface VehicleDvirHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'driverId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'date'?: string;
    /**
     * 
     * @type {DvirInspectionType}
     * @memberof VehicleDvirHistoryListDto
     */
    'type'?: DvirInspectionType;
    /**
     * 
     * @type {string}
     * @memberof VehicleDvirHistoryListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'minorDefectsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDto
     */
    'majorDefectsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDvirHistoryListDto
     */
    'hasUnresolvedDefects'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VehicleDvirHistoryListDtoPagedResultDto
 */
export interface VehicleDvirHistoryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleDvirHistoryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleDvirHistoryListDto>}
     * @memberof VehicleDvirHistoryListDtoPagedResultDto
     */
    'items'?: Array<VehicleDvirHistoryListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleEldDevicesUsageHistoryListDto
 */
export interface VehicleEldDevicesUsageHistoryListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleEldDevicesUsageHistoryListDto
     */
    'endTime'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleIgnitionStatus = {
    IgnitionOff: 'IgnitionOff',
    IgnitionOnDriving: 'IgnitionOnDriving',
    IgnitionOnIdle: 'IgnitionOnIdle'
} as const;

export type VehicleIgnitionStatus = typeof VehicleIgnitionStatus[keyof typeof VehicleIgnitionStatus];


/**
 * 
 * @export
 * @interface VehicleInactivityReportInput
 */
export interface VehicleInactivityReportInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleInactivityReportInput
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleInactivityReportInput
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleInactivityReportInput
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleListDto
 */
export interface VehicleListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleListDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleListDto
     */
    'documentNames'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleListDto
     */
    'groups'?: Array<string> | null;
    /**
     * 
     * @type {FuelType}
     * @memberof VehicleListDto
     */
    'fuelType'?: FuelType | null;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleListDtoPagedResultDto
 */
export interface VehicleListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleListDto>}
     * @memberof VehicleListDtoPagedResultDto
     */
    'items'?: Array<VehicleListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleLocationHistoryReportEntryDto
 */
export interface VehicleLocationHistoryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'geolocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'drivingSpeed'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'mileageFromEcu'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryDto
     */
    'driverFullName'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleLocationHistoryReportEntryListResultDto
 */
export interface VehicleLocationHistoryReportEntryListResultDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'homeTerminalTimeZone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleLocationHistoryReportEntryDto>}
     * @memberof VehicleLocationHistoryReportEntryListResultDto
     */
    'items'?: Array<VehicleLocationHistoryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceDto
 */
export interface VehicleMaintenanceDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'previousOilChangeId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceDtoPagedResultDto
 */
export interface VehicleMaintenanceDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceDto>}
     * @memberof VehicleMaintenanceDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceListDto
 */
export interface VehicleMaintenanceListDto {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'isRegularMaintenance'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'vehicleOdometerUnits'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceOdometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceListDto
     */
    'nextMaintenanceDone'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceListDtoPagedResultDto
 */
export interface VehicleMaintenanceListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceListDto>}
     * @memberof VehicleMaintenanceListDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryDto
 */
export interface VehicleMaintenanceSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'vehicleOdometerUnit'?: string | null;
    /**
     * 
     * @type {Array<TireStatusDto>}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'tireStatuses'?: Array<TireStatusDto> | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryListDto
 */
export interface VehicleMaintenanceSummaryListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleMake'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'vehicleOdometerUnit'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'tireFaults'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'tiresFaulty'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'lastMaintenanceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMaintenanceSummaryListDtoPagedResultDto
 */
export interface VehicleMaintenanceSummaryListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMaintenanceSummaryListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMaintenanceSummaryListDto>}
     * @memberof VehicleMaintenanceSummaryListDtoPagedResultDto
     */
    'items'?: Array<VehicleMaintenanceSummaryListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportEntryDto
 */
export interface VehicleMileageByStateSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportEntryListResultDto
 */
export interface VehicleMileageByStateSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageByStateSummaryReportEntryDto>}
     * @memberof VehicleMileageByStateSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleMileageByStateSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageByStateSummaryReportViewInputDto
 */
export interface VehicleMileageByStateSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageByStateSummaryReportViewInputDto
     */
    'stateIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageReportInputDto
 */
export interface VehicleMileageReportInputDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageReportInputDto
     */
    'vehicles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageReportInputDto
     */
    'stateIds'?: Array<number> | null;
    /**
     * 
     * @type {ReportFormat}
     * @memberof VehicleMileageReportInputDto
     */
    'reportFormat'?: ReportFormat;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageReportInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'reportName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageReportInputDto
     */
    'clientTimeZone'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryByVehicleDto
 */
export interface VehicleMileageSummaryReportEntryByVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryByVehicleDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryDto
 */
export interface VehicleMileageSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'stateName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'stateCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryListByVehicleResultDto
 */
export interface VehicleMileageSummaryReportEntryListByVehicleResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageSummaryReportEntryByVehicleDto>}
     * @memberof VehicleMileageSummaryReportEntryListByVehicleResultDto
     */
    'items'?: Array<VehicleMileageSummaryReportEntryByVehicleDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportEntryListResultDto
 */
export interface VehicleMileageSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleMileageSummaryReportEntryDto>}
     * @memberof VehicleMileageSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleMileageSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageSummaryReportViewInputDto
 */
export interface VehicleMileageSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleMileageSummaryReportViewInputDto
     */
    'stateIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageTripDetailData
 */
export interface VehicleMileageTripDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'startOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'endOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripDetailData
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'destination'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'eventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripDetailData
     */
    'duration'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleMileageTripReportDetailData
 */
export interface VehicleMileageTripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleMileageTripReportDetailData
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startLatitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'startLongitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endLatitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'endLongitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleMileageTripReportDetailData
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValueDto
 */
export interface VehicleSensorAttributeValueDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'units'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueDtoFormattedValue}
     * @memberof VehicleSensorAttributeValueDto
     */
    'formattedValue'?: VehicleSensorAttributeValueDtoFormattedValue | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDto
     */
    'valueTimestamp'?: string;
}
/**
 * 
 * @export
 * @interface VehicleSensorAttributeValueDtoFormattedValue
 */
export interface VehicleSensorAttributeValueDtoFormattedValue {
    /**
     * 
     * @type {any}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'value'?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'isNormal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'unit'?: string | null;
    /**
     * 
     * @type {VehicleSensorAttributeValueType}
     * @memberof VehicleSensorAttributeValueDtoFormattedValue
     */
    'valueType'?: VehicleSensorAttributeValueType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleSensorAttributeValueType = {
    Unformatted: 'Unformatted',
    Integer: 'Integer',
    Decimal: 'Decimal',
    Boolean: 'Boolean'
} as const;

export type VehicleSensorAttributeValueType = typeof VehicleSensorAttributeValueType[keyof typeof VehicleSensorAttributeValueType];


/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportEntryDto
 */
export interface VehicleStateMileageSummaryReportEntryDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryDto
     */
    'totalMileage'?: number;
}
/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportEntryListResultDto
 */
export interface VehicleStateMileageSummaryReportEntryListResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportEntryListResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleStateMileageSummaryReportEntryDto>}
     * @memberof VehicleStateMileageSummaryReportEntryListResultDto
     */
    'items'?: Array<VehicleStateMileageSummaryReportEntryDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleStateMileageSummaryReportViewInputDto
 */
export interface VehicleStateMileageSummaryReportViewInputDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'stateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'dateTo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof VehicleStateMileageSummaryReportViewInputDto
     */
    'vehicleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface VehicleSyncDto
 */
export interface VehicleSyncDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {Odometer}
     * @memberof VehicleSyncDto
     */
    'odometer'?: Odometer;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'lastModificationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleSyncDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSyncDto
     */
    'hasSleeperBerth'?: boolean;
    /**
     * 
     * @type {DeviceType}
     * @memberof VehicleSyncDto
     */
    'deviceType'?: DeviceType;
    /**
     * 
     * @type {Vendor}
     * @memberof VehicleSyncDto
     */
    'vendorType'?: Vendor;
    /**
     * 
     * @type {number}
     * @memberof VehicleSyncDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleTrailersUsageHistoryListDto
 */
export interface VehicleTrailersUsageHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'trailerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'eventName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleTrailersUsageHistoryListDto
     */
    'startTime'?: string;
}
/**
 * 
 * @export
 * @interface VehicleTripDetailData
 */
export interface VehicleTripDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleTripDetailData
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<VehicleMileageTripDetailData>}
     * @memberof VehicleTripDetailData
     */
    'vehicleMileages'?: Array<VehicleMileageTripDetailData> | null;
}
/**
 * 
 * @export
 * @interface VehicleTripReportDetailData
 */
export interface VehicleTripReportDetailData {
    /**
     * 
     * @type {string}
     * @memberof VehicleTripReportDetailData
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleTripReportDetailData
     */
    'totalMileage'?: number;
    /**
     * 
     * @type {Array<VehicleMileageTripReportDetailData>}
     * @memberof VehicleTripReportDetailData
     */
    'vehicleMileages'?: Array<VehicleMileageTripReportDetailData> | null;
}
/**
 * 
 * @export
 * @interface VehicleUsageStatusInfoDto
 */
export interface VehicleUsageStatusInfoDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'currentLocation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'vehicleOdometer'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleUsageStatusInfoDto
     */
    'isConnected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'currentDutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'driverId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'coDriverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'eldSerialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'eldDeviceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleUsageStatusInfoDto
     */
    'trailerNumbers'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleUsageStatusInfoDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleViewDto
 */
export interface VehicleViewDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface VehicleViewListDto
 */
export interface VehicleViewListDto {
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleViewListDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDto
     */
    'companyId'?: number;
    /**
     * 
     * @type {RecordStatus}
     * @memberof VehicleViewListDto
     */
    'status'?: RecordStatus;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleViewListDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface VehicleViewListDtoPagedResultDto
 */
export interface VehicleViewListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VehicleViewListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VehicleViewListDto>}
     * @memberof VehicleViewListDtoPagedResultDto
     */
    'items'?: Array<VehicleViewListDto> | null;
}
/**
 * 
 * @export
 * @interface VehicleWithDiagnosticRecords
 */
export interface VehicleWithDiagnosticRecords {
    /**
     * 
     * @type {number}
     * @memberof VehicleWithDiagnosticRecords
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleWithDiagnosticRecords
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleWithDiagnosticRecords
     */
    'activeRecordsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleWithDiagnosticRecords
     */
    'lastDtcTime'?: string;
}
/**
 * 
 * @export
 * @interface VehiclesConditionOutput
 */
export interface VehiclesConditionOutput {
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'good'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'goodPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'satisfactory'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'satisfactoryPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'critical'?: number;
    /**
     * 
     * @type {number}
     * @memberof VehiclesConditionOutput
     */
    'criticalPercentage'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Vendor = {
    Invalid: 'Invalid',
    Geometris: 'Geometris',
    PacificTrack: 'PacificTrack'
} as const;

export type Vendor = typeof Vendor[keyof typeof Vendor];


/**
 * 
 * @export
 * @interface VerifyOneTimeCodeInput
 */
export interface VerifyOneTimeCodeInput {
    /**
     * 
     * @type {string}
     * @memberof VerifyOneTimeCodeInput
     */
    'verificationCode': string;
}
/**
 * 
 * @export
 * @interface VerifyOneTimeCodeOutput
 */
export interface VerifyOneTimeCodeOutput {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyOneTimeCodeOutput
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyOneTimeCodeOutput
     */
    'phoneNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewEventDto
 */
export interface ViewEventDto {
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'editable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'dutyStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'realStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'durationInSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'realDurationInSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'locationDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'engineMinutes'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'origin'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isBasic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'vehicleVin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'vehicleId'?: number | null;
    /**
     * 
     * @type {EventType}
     * @memberof ViewEventDto
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'eventCode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isFirstEvent'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'coDriverId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'coDriverDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'attachedTrailers'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'shippingDocuments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'realEndTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'averageSpeed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewEventDto
     */
    'eventSequenceNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'nextDayFirstEventOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'elapsedEngineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewEventDto
     */
    'accumulatedVehicleMiles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ViewEventDto
     */
    'isEventMissingPowerUp'?: boolean;
}
/**
 * 
 * @export
 * @interface ViewEventDtoPagedResultDto
 */
export interface ViewEventDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof ViewEventDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<ViewEventDto>}
     * @memberof ViewEventDtoPagedResultDto
     */
    'items'?: Array<ViewEventDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ViolationType = {
    EightHoursViolation: 'EightHoursViolation',
    ElevenHoursViolation: 'ElevenHoursViolation',
    FourteenHoursViolation: 'FourteenHoursViolation',
    ThirtyFourHoursResetViolation: 'ThirtyFourHoursResetViolation',
    DutyCycleViolation: 'DutyCycleViolation',
    ThirtyMinutesBreakViolation: 'ThirtyMinutesBreakViolation',
    TenHoursBreakRequiredViolation: 'TenHoursBreakRequiredViolation',
    UncertifiedLogsViolation: 'UncertifiedLogsViolation'
} as const;

export type ViolationType = typeof ViolationType[keyof typeof ViolationType];


/**
 * 
 * @export
 * @interface ViolationViewDto
 */
export interface ViolationViewDto {
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'id'?: number;
    /**
     * 
     * @type {ViolationType}
     * @memberof ViolationViewDto
     */
    'violationType'?: ViolationType;
    /**
     * 
     * @type {boolean}
     * @memberof ViolationViewDto
     */
    'isHosViolation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'violationError'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'startDateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'startTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof ViolationViewDto
     */
    'endDateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ViolationViewDto
     */
    'endTime'?: number;
}
/**
 * 
 * @export
 * @interface VirtualTenantDto
 */
export interface VirtualTenantDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<VirtualTenantUserDto>}
     * @memberof VirtualTenantDto
     */
    'users'?: Array<VirtualTenantUserDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualTenantDto
     */
    'vehicleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof VirtualTenantDto
     */
    'driverIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantListDto
 */
export interface VirtualTenantListDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantListDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDto
     */
    'vehiclesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDto
     */
    'driversCount'?: number;
}
/**
 * 
 * @export
 * @interface VirtualTenantListDtoPagedResultDto
 */
export interface VirtualTenantListDtoPagedResultDto {
    /**
     * 
     * @type {number}
     * @memberof VirtualTenantListDtoPagedResultDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<VirtualTenantListDto>}
     * @memberof VirtualTenantListDtoPagedResultDto
     */
    'items'?: Array<VirtualTenantListDto> | null;
}
/**
 * 
 * @export
 * @interface VirtualTenantUserDto
 */
export interface VirtualTenantUserDto {
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualTenantUserDto
     */
    'role'?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsTimeZone
 */
export interface WindowsTimeZone {
    /**
     * 
     * @type {string}
     * @memberof WindowsTimeZone
     */
    'timeZoneId'?: string | null;
}
/**
 * 
 * @export
 * @interface WorstPerformersDto
 */
export interface WorstPerformersDto {
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'idleTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorstPerformersDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorstPerformersDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersDto
     */
    'driverRank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof WorstPerformersDto
     */
    'rankStatus'?: RankStatus;
}
/**
 * 
 * @export
 * @interface WorstPerformersFuelConsumptionDto
 */
export interface WorstPerformersFuelConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'vehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'driverFullName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'fuelConsumption'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'growth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'isGrowing'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'stops'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'driverRank'?: number;
    /**
     * 
     * @type {RankStatus}
     * @memberof WorstPerformersFuelConsumptionDto
     */
    'rankStatus'?: RankStatus;
}

/**
 * AbpApiDefinitionApi - axios parameter creator
 * @export
 */
export const AbpApiDefinitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApiDefinitionGet: async (includeTypes?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abp/api-definition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeTypes !== undefined) {
                localVarQueryParameter['IncludeTypes'] = includeTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpApiDefinitionApi - functional programming interface
 * @export
 */
export const AbpApiDefinitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpApiDefinitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpApiDefinitionGet(includeTypes?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationApiDescriptionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpApiDefinitionGet(includeTypes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpApiDefinitionApi - factory interface
 * @export
 */
export const AbpApiDefinitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpApiDefinitionApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [includeTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApiDefinitionGet(includeTypes?: boolean, options?: any): AxiosPromise<ApplicationApiDescriptionModel> {
            return localVarFp.apiAbpApiDefinitionGet(includeTypes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpApiDefinitionApi - object-oriented interface
 * @export
 * @class AbpApiDefinitionApi
 * @extends {BaseAPI}
 */
export class AbpApiDefinitionApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [includeTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpApiDefinitionApi
     */
    public apiAbpApiDefinitionGet(includeTypes?: boolean, options?: AxiosRequestConfig) {
        return AbpApiDefinitionApiFp(this.configuration).apiAbpApiDefinitionGet(includeTypes, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AbpApplicationConfigurationApi - axios parameter creator
 * @export
 */
export const AbpApplicationConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/abp/application-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpApplicationConfigurationApi - functional programming interface
 * @export
 */
export const AbpApplicationConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpApplicationConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpApplicationConfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpApplicationConfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpApplicationConfigurationApi - factory interface
 * @export
 */
export const AbpApplicationConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpApplicationConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpApplicationConfigurationGet(options?: any): AxiosPromise<ApplicationConfigurationDto> {
            return localVarFp.apiAbpApplicationConfigurationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpApplicationConfigurationApi - object-oriented interface
 * @export
 * @class AbpApplicationConfigurationApi
 * @extends {BaseAPI}
 */
export class AbpApplicationConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpApplicationConfigurationApi
     */
    public apiAbpApplicationConfigurationGet(options?: AxiosRequestConfig) {
        return AbpApplicationConfigurationApiFp(this.configuration).apiAbpApplicationConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AbpTenantApi - axios parameter creator
 * @export
 */
export const AbpTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByIdIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAbpMultiTenancyTenantsByIdIdGet', 'id', id)
            const localVarPath = `/api/abp/multi-tenancy/tenants/by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByNameNameGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiAbpMultiTenancyTenantsByNameNameGet', 'name', name)
            const localVarPath = `/api/abp/multi-tenancy/tenants/by-name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbpTenantApi - functional programming interface
 * @export
 */
export const AbpTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbpTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindTenantResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpMultiTenancyTenantsByIdIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindTenantResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAbpMultiTenancyTenantsByNameNameGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbpTenantApi - factory interface
 * @export
 */
export const AbpTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbpTenantApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: any): AxiosPromise<FindTenantResultDto> {
            return localVarFp.apiAbpMultiTenancyTenantsByIdIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: any): AxiosPromise<FindTenantResultDto> {
            return localVarFp.apiAbpMultiTenancyTenantsByNameNameGet(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbpTenantApi - object-oriented interface
 * @export
 * @class AbpTenantApi
 * @extends {BaseAPI}
 */
export class AbpTenantApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpTenantApi
     */
    public apiAbpMultiTenancyTenantsByIdIdGet(id: string, options?: AxiosRequestConfig) {
        return AbpTenantApiFp(this.configuration).apiAbpMultiTenancyTenantsByIdIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbpTenantApi
     */
    public apiAbpMultiTenancyTenantsByNameNameGet(name: string, options?: AxiosRequestConfig) {
        return AbpTenantApiFp(this.configuration).apiAbpMultiTenancyTenantsByNameNameGet(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost: async (apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountRegisterPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost: async (apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountResetPasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountSendPasswordResetCodePost: async (apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/send-password-reset-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountSendPasswordResetCodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountRegisterPost(apiAccountRegisterPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiAccountRegisterPost(apiAccountRegisterPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountRegisterPostRequest} [apiAccountRegisterPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountRegisterPost(apiAccountRegisterPostRequest?: ApiAccountRegisterPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountRegisterPost(apiAccountRegisterPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountResetPasswordPostRequest} [apiAccountResetPasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest?: ApiAccountResetPasswordPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountResetPasswordPost(apiAccountResetPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountSendPasswordResetCodePostRequest} [apiAccountSendPasswordResetCodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest?: ApiAccountSendPasswordResetCodePostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).apiAccountSendPasswordResetCodePost(apiAccountSendPasswordResetCodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AppDataApi - axios parameter creator
 * @export
 */
export const AppDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataAppdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/appdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataMasterappdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/masterappdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataUserpermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/appdata/userpermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppDataApi - functional programming interface
 * @export
 */
export const AppDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataAppdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataAppdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataMasterappdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterAppData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataMasterappdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppAppdataUserpermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppAppdataUserpermissionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppDataApi - factory interface
 * @export
 */
export const AppDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppDataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataAppdataGet(options?: any): AxiosPromise<AppData> {
            return localVarFp.apiAppAppdataAppdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataMasterappdataGet(options?: any): AxiosPromise<MasterAppData> {
            return localVarFp.apiAppAppdataMasterappdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppAppdataUserpermissionsGet(options?: any): AxiosPromise<PermissionListResultDto> {
            return localVarFp.apiAppAppdataUserpermissionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppDataApi - object-oriented interface
 * @export
 * @class AppDataApi
 * @extends {BaseAPI}
 */
export class AppDataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataAppdataGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataAppdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataMasterappdataGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataMasterappdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppDataApi
     */
    public apiAppAppdataUserpermissionsGet(options?: AxiosRequestConfig) {
        return AppDataApiFp(this.configuration).apiAppAppdataUserpermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdDelete', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdGet', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdPut: async (id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCompanyIdPut', 'id', id)
            const localVarPath = `/api/app/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyPost: async (apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/company/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyPost(apiAppCompanyGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppCompanyDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<CompanyDtoPagedResultDto> {
            return localVarFp.apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<CompanyListDtoPagedResultDto> {
            return localVarFp.apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<CompanyListDto>> {
            return localVarFp.apiAppCompanyGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<CompanyListDto>> {
            return localVarFp.apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCompanyIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdGet(id: number, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: any): AxiosPromise<CompanyDto> {
            return localVarFp.apiAppCompanyPost(apiAppCompanyGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdDelete(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdGet(id: number, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppCompanyIdDeleteRequest} [apiAppCompanyIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyIdPut(id: number, apiAppCompanyIdDeleteRequest?: ApiAppCompanyIdDeleteRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyIdPut(id, apiAppCompanyIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetRequest} [apiAppCompanyGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyPost(apiAppCompanyGetRequest?: ApiAppCompanyGetRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyPost(apiAppCompanyGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).apiAppCompanyUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerServiceAccountApi - axios parameter creator
 * @export
 */
export const CustomerServiceAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/customerserviceaccount/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRestoreserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdRestoreserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/restoreserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRevokeserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdRevokeserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/revokeserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdSuspendserviceaccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountIdSuspendserviceaccountPost', 'id', id)
            const localVarPath = `/api/app/customerserviceaccount/{id}/suspendserviceaccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/resendwelcomeemail/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost', 'userId', userId)
            const localVarPath = `/api/app/customerserviceaccount/resendwelcomeemailforserviceaccount/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost', 'tenantId', tenantId)
            const localVarPath = `/api/app/customerserviceaccount/resettwofactorauthentication/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost', 'userId', userId)
            const localVarPath = `/api/app/customerserviceaccount/resettwofactorauthenticationforserviceaccount/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountServiceaccountPost: async (apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customerserviceaccount/serviceaccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCustomerserviceaccountServiceaccountPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerServiceAccountApi - functional programming interface
 * @export
 */
export const CustomerServiceAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerServiceAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantServiceAccountCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerServiceAccountApi - factory interface
 * @export
 */
export const CustomerServiceAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerServiceAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: any): AxiosPromise<TenantServiceAccountCreationResult> {
            return localVarFp.apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerServiceAccountApi - object-oriented interface
 * @export
 * @class CustomerServiceAccountApi
 * @extends {BaseAPI}
 */
export class CustomerServiceAccountApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountCustomerserviceaccountTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdRestoreserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdRevokeserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountIdSuspendserviceaccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResendwelcomeemailTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResendwelcomeemailforserviceaccountUserIdPost(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResettwofactorauthenticationTenantIdPost(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId: string, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountResettwofactorauthenticationforserviceaccountUserIdPost(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCustomerserviceaccountServiceaccountPostRequest} [apiAppCustomerserviceaccountServiceaccountPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerServiceAccountApi
     */
    public apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest?: ApiAppCustomerserviceaccountServiceaccountPostRequest, options?: AxiosRequestConfig) {
        return CustomerServiceAccountApiFp(this.configuration).apiAppCustomerserviceaccountServiceaccountPost(apiAppCustomerserviceaccountServiceaccountPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomersEldDevicesApi - axios parameter creator
 * @export
 */
export const CustomersEldDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerselddevicesGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/customerselddevices/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersEldDevicesApi - functional programming interface
 * @export
 */
export const CustomersEldDevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersEldDevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerEldDevicesViewListPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersEldDevicesApi - factory interface
 * @export
 */
export const CustomersEldDevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersEldDevicesApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<CustomerEldDevicesViewListPagedResultDto> {
            return localVarFp.apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersEldDevicesApi - object-oriented interface
 * @export
 * @class CustomersEldDevicesApi
 * @extends {BaseAPI}
 */
export class CustomersEldDevicesApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersEldDevicesApi
     */
    public apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return CustomersEldDevicesApiFp(this.configuration).apiAppCustomerselddevicesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriverhoseventsGet: async (vehicleId?: number, logDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboarddriverhosevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (logDate !== undefined) {
                localVarQueryParameter['LogDate'] = (logDate as any instanceof Date) ?
                    (logDate as any).toISOString() :
                    logDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriversdataGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboarddriversdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboardlocationsdataGet: async (selectedCompanies?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dashboard/dashboardlocationsdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedCompanies) {
                localVarQueryParameter['SelectedCompanies'] = selectedCompanies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardDriverHosEventsOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboarddriversdataGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardDriverDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboarddriversdataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: any): AxiosPromise<Array<DashboardDriverHosEventsOutput>> {
            return localVarFp.apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboarddriversdataGet(options?: any): AxiosPromise<Array<DashboardDriverDto>> {
            return localVarFp.apiAppDashboardDashboarddriversdataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: any): AxiosPromise<Array<CurrentLocationDto>> {
            return localVarFp.apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [logDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboarddriverhoseventsGet(vehicleId?: number, logDate?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboarddriverhoseventsGet(vehicleId, logDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboarddriversdataGet(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboarddriversdataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [selectedCompanies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public apiAppDashboardDashboardlocationsdataGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).apiAppDashboardDashboardlocationsdataGet(selectedCompanies, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DemoAccountApi - axios parameter creator
 * @export
 */
export const DemoAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangePasswordPost: async (apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountChangePasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdDelete', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdGet', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdPut: async (id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDemoaccountIdPut', 'id', id)
            const localVarPath = `/api/app/demoaccount/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountPost: async (apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/demoaccount/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemoAccountApi - functional programming interface
 * @export
 */
export const DemoAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemoAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemoAccountListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DemoAccountListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemoAccountApi - factory interface
 * @export
 */
export const DemoAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemoAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDemoaccountDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DemoAccountListDtoPagedResultDto> {
            return localVarFp.apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<DemoAccountListDto>> {
            return localVarFp.apiAppDemoaccountGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DemoAccountListDto>> {
            return localVarFp.apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDemoaccountIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdGet(id: string, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: any): AxiosPromise<DemoAccountDto> {
            return localVarFp.apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemoAccountApi - object-oriented interface
 * @export
 * @class DemoAccountApi
 * @extends {BaseAPI}
 */
export class DemoAccountApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppDemoaccountChangePasswordPostRequest} [apiAppDemoaccountChangePasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest?: ApiAppDemoaccountChangePasswordPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountChangePasswordPost(apiAppDemoaccountChangePasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdDelete(id: string, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdGet(id: string, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppDemoaccountIdDeleteRequest} [apiAppDemoaccountIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountIdPut(id: string, apiAppDemoaccountIdDeleteRequest?: ApiAppDemoaccountIdDeleteRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountIdPut(id, apiAppDemoaccountIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountPostRequest} [apiAppDemoaccountPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountPost(apiAppDemoaccountPostRequest?: ApiAppDemoaccountPostRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountPost(apiAppDemoaccountPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccountApi
     */
    public apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DemoAccountApiFp(this.configuration).apiAppDemoaccountUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DiagnosticsApi - axios parameter creator
 * @export
 */
export const DiagnosticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsAcknowledgeIdPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDiagnosticsAcknowledgeIdPost', 'id', id)
            const localVarPath = `/api/app/diagnostics/acknowledge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/diagnostics/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsResolveObd2CodeGet: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiAppDiagnosticsResolveObd2CodeGet', 'code', code)
            const localVarPath = `/api/app/diagnostics/resolve-obd2/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiagnosticsApi - functional programming interface
 * @export
 */
export const DiagnosticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiagnosticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticRecordListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsAcknowledgeIdPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticRecordListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolvedObd2Code>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDiagnosticsResolveObd2CodeGet(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DiagnosticsApi - factory interface
 * @export
 */
export const DiagnosticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiagnosticsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: any): AxiosPromise<DiagnosticRecordListDto> {
            return localVarFp.apiAppDiagnosticsAcknowledgeIdPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DiagnosticRecordListDtoPagedResultDto> {
            return localVarFp.apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: any): AxiosPromise<ResolvedObd2Code> {
            return localVarFp.apiAppDiagnosticsResolveObd2CodeGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiagnosticsApi - object-oriented interface
 * @export
 * @class DiagnosticsApi
 * @extends {BaseAPI}
 */
export class DiagnosticsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsAcknowledgeIdPost(id: number, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsAcknowledgeIdPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagnosticsApi
     */
    public apiAppDiagnosticsResolveObd2CodeGet(code: string, options?: AxiosRequestConfig) {
        return DiagnosticsApiFp(this.configuration).apiAppDiagnosticsResolveObd2CodeGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDelete: async (url?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDownloadBlobNameGet: async (blobName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blobName' is not null or undefined
            assertParamExists('apiAppDocumentDownloadBlobNameGet', 'blobName', blobName)
            const localVarPath = `/api/app/document/download/{blobName}`
                .replace(`{${"blobName"}}`, encodeURIComponent(String(blobName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentUploadPost: async (input?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (input !== undefined) { 
                localVarFormParams.append('input', input as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentDelete(url?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentDelete(url, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentDownloadBlobNameGet(blobName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentDownloadBlobNameGet(blobName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentUploadPost(input?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentUploadPost(input, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDelete(url?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentDelete(url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} blobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentDownloadBlobNameGet(blobName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentDownloadBlobNameGet(blobName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentUploadPost(input?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppDocumentUploadPost(input, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentDelete(url?: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentDelete(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} blobName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentDownloadBlobNameGet(blobName: string, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentDownloadBlobNameGet(blobName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public apiAppDocumentUploadPost(input?: any, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiAppDocumentUploadPost(input, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentCenterApi - axios parameter creator
 * @export
 */
export const DocumentCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityDelete: async (documentId: number, entityType: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiAppDocumentcenterDocumentforentityDelete', 'documentId', documentId)
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('apiAppDocumentcenterDocumentforentityDelete', 'entityType', entityType)
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (documentId !== undefined) {
                localVarQueryParameter['DocumentId'] = documentId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPost: async (apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterDocumentforentityDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPut: async (apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/documentforentity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterDocumentforentityDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentbyidPost: async (apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/getdocumentbyid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDocumentcenterGetdocumentbyidPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentsbyentitytypePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/documentcenter/getdocumentsbyentitytype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentCenterApi - functional programming interface
 * @export
 */
export const DocumentCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentCenterApi - factory interface
 * @export
 */
export const DocumentCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {number} documentId 
         * @param {number} entityType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: any): AxiosPromise<DocumentDto> {
            return localVarFp.apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DocumentListDtoPagedResultDto> {
            return localVarFp.apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentCenterApi - object-oriented interface
 * @export
 * @class DocumentCenterApi
 * @extends {BaseAPI}
 */
export class DocumentCenterApi extends BaseAPI {
    /**
     * 
     * @param {number} documentId 
     * @param {number} entityType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityDelete(documentId: number, entityType: number, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityDelete(documentId, entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityPost(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterDocumentforentityDeleteRequest} [apiAppDocumentcenterDocumentforentityDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest?: ApiAppDocumentcenterDocumentforentityDeleteRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterDocumentforentityPut(apiAppDocumentcenterDocumentforentityDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDocumentcenterGetdocumentbyidPostRequest} [apiAppDocumentcenterGetdocumentbyidPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest?: ApiAppDocumentcenterGetdocumentbyidPostRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterGetdocumentbyidPost(apiAppDocumentcenterGetdocumentbyidPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiAppDocumentcenterGetdocumentsbyentitytypePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverApi - axios parameter creator
 * @export
 */
export const DriverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangepasswordPost: async (apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/changepassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverChangepasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetpasswordDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverGetpasswordDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driver/getpassword/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdDelete', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdGet', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdPut: async (id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdPut', 'id', id)
            const localVarPath = `/api/app/driver/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdTogglepersonalconveyancePut: async (id: number, togglePc?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdTogglepersonalconveyancePut', 'id', id)
            const localVarPath = `/api/app/driver/{id}/togglepersonalconveyance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (togglePc !== undefined) {
                localVarQueryParameter['togglePc'] = togglePc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdToggleyardmovePut: async (id: number, yardMove?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverIdToggleyardmovePut', 'id', id)
            const localVarPath = `/api/app/driver/{id}/toggleyardmove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (yardMove !== undefined) {
                localVarQueryParameter['yardMove'] = yardMove;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverLogoutDriverIdPost: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverLogoutDriverIdPost', 'driverId', driverId)
            const localVarPath = `/api/app/driver/logout/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverPost: async (apiAppDriverGetRequest?: ApiAppDriverGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverProfileIdGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/profile/{id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverRolloverPost: async (apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/rollover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverRolloverPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignatureDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverSignatureDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driver/signature/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignaturePost: async (apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverSignaturePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driver/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverApi - functional programming interface
 * @export
 */
export const DriverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPasswordOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverGetpasswordDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverIdToggleyardmovePut(id, yardMove, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverLogoutDriverIdPost(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverLogoutDriverIdPost(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverPost(apiAppDriverGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverProfileIdGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverProfileIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverSignatureDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverSignatureDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverApi - factory interface
 * @export
 */
export const DriverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDriverDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DriverDtoPagedResultDto> {
            return localVarFp.apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverListDtoPagedResultDto> {
            return localVarFp.apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DriverListDto>> {
            return localVarFp.apiAppDriverGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DriverListDto>> {
            return localVarFp.apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: any): AxiosPromise<DriverPasswordOutput> {
            return localVarFp.apiAppDriverGetpasswordDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdGet(id: number, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [togglePc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [yardMove] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverIdToggleyardmovePut(id, yardMove, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverLogoutDriverIdPost(driverId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverLogoutDriverIdPost(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverPost(apiAppDriverGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverProfileIdGet(id?: number, options?: any): AxiosPromise<DriverProfileDto> {
            return localVarFp.apiAppDriverProfileIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignatureDriverIdGet(driverId: number, options?: any): AxiosPromise<SignatureDto> {
            return localVarFp.apiAppDriverSignatureDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverApi - object-oriented interface
 * @export
 * @class DriverApi
 * @extends {BaseAPI}
 */
export class DriverApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverChangepasswordPostRequest} [apiAppDriverChangepasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest?: ApiAppDriverChangepasswordPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverChangepasswordPost(apiAppDriverChangepasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverGetpasswordDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverGetpasswordDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdDelete(id: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdGet(id: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppDriverIdDeleteRequest} [apiAppDriverIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdPut(id: number, apiAppDriverIdDeleteRequest?: ApiAppDriverIdDeleteRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdPut(id, apiAppDriverIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [togglePc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdTogglepersonalconveyancePut(id: number, togglePc?: boolean, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdTogglepersonalconveyancePut(id, togglePc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [yardMove] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverIdToggleyardmovePut(id: number, yardMove?: boolean, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverIdToggleyardmovePut(id, yardMove, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverLogoutDriverIdPost(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverLogoutDriverIdPost(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverGetRequest} [apiAppDriverGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverPost(apiAppDriverGetRequest?: ApiAppDriverGetRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverPost(apiAppDriverGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverProfileIdGet(id?: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverProfileIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverRolloverPostRequest} [apiAppDriverRolloverPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest?: ApiAppDriverRolloverPostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverRolloverPost(apiAppDriverRolloverPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverSignatureDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverSignatureDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverSignaturePostRequest} [apiAppDriverSignaturePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest?: ApiAppDriverSignaturePostRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverSignaturePost(apiAppDriverSignaturePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverApi
     */
    public apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DriverApiFp(this.configuration).apiAppDriverUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverDailyLogApi - axios parameter creator
 * @export
 */
export const DriverDailyLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverdailylogGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverdailylog/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverDailyLogApi - functional programming interface
 * @export
 */
export const DriverDailyLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverDailyLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogGridViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverDailyLogApi - factory interface
 * @export
 */
export const DriverDailyLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverDailyLogApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverLogGridViewDtoPagedResultDto> {
            return localVarFp.apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverDailyLogApi - object-oriented interface
 * @export
 * @class DriverDailyLogApi
 * @extends {BaseAPI}
 */
export class DriverDailyLogApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverDailyLogApi
     */
    public apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverDailyLogApiFp(this.configuration).apiAppDriverdailylogGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverHistoryApi - axios parameter creator
 * @export
 */
export const DriverHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriverstatusinfoDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverhistoryDriverstatusinfoDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driverhistory/driverstatusinfo/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriversvehicleusageDriverIdGet: async (driverId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppDriverhistoryDriversvehicleusageDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/driverhistory/driversvehicleusage/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverHistoryApi - functional programming interface
 * @export
 */
export const DriverHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHistoryStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriversVehicleUsageListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverHistoryApi - factory interface
 * @export
 */
export const DriverHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: any): AxiosPromise<DriverHistoryStatusInfoDto> {
            return localVarFp.apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: any): AxiosPromise<Array<DriversVehicleUsageListDto>> {
            return localVarFp.apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverHistoryApi - object-oriented interface
 * @export
 * @class DriverHistoryApi
 * @extends {BaseAPI}
 */
export class DriverHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverHistoryApi
     */
    public apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverHistoryApiFp(this.configuration).apiAppDriverhistoryDriverstatusinfoDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverHistoryApi
     */
    public apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId: number, options?: AxiosRequestConfig) {
        return DriverHistoryApiFp(this.configuration).apiAppDriverhistoryDriversvehicleusageDriverIdGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverLoginApi - axios parameter creator
 * @export
 */
export const DriverLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDriverloginPost: async (id?: string, time?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/driverlogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverLoginApi - functional programming interface
 * @export
 */
export const DriverLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDriverloginPost(id?: string, time?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDriverloginPost(id, time, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverLoginApi - factory interface
 * @export
 */
export const DriverLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverLoginApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDriverloginPost(id?: string, time?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDriverloginPost(id, time, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverLoginApi - object-oriented interface
 * @export
 * @class DriverLoginApi
 * @extends {BaseAPI}
 */
export class DriverLoginApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {string} [time] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverLoginApi
     */
    public apiDriverloginPost(id?: string, time?: string, options?: AxiosRequestConfig) {
        return DriverLoginApiFp(this.configuration).apiDriverloginPost(id, time, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DriverViewApi - axios parameter creator
 * @export
 */
export const DriverViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet: async (driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-drivers-vehicle-and-mobile-app-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDriverviewIdGet', 'id', id)
            const localVarPath = `/api/app/driverview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverViewApi - functional programming interface
 * @export
 */
export const DriverViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverVehicleIdAndMobileAppTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DriverViewApi - factory interface
 * @export
 */
export const DriverViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DriverDtoPagedResultDto> {
            return localVarFp.apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: any): AxiosPromise<DriverVehicleIdAndMobileAppTypeDto> {
            return localVarFp.apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverViewListDtoPagedResultDto> {
            return localVarFp.apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppDriverviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverviewIdGet(id: number, options?: any): AxiosPromise<DriverDto> {
            return localVarFp.apiAppDriverviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverViewApi - object-oriented interface
 * @export
 * @class DriverViewApi
 * @extends {BaseAPI}
 */
export class DriverViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId?: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetDriversVehicleAndMobileAppTypeGet(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverViewApi
     */
    public apiAppDriverviewIdGet(id: number, options?: AxiosRequestConfig) {
        return DriverViewApiFp(this.configuration).apiAppDriverviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirApi - axios parameter creator
 * @export
 */
export const DvirApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDvirreportPost: async (apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvir/dvirreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirDvirreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirApi - functional programming interface
 * @export
 */
export const DvirApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirApi - factory interface
 * @export
 */
export const DvirApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirApi - object-oriented interface
 * @export
 * @class DvirApi
 * @extends {BaseAPI}
 */
export class DvirApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppDvirDvirreportPostRequest} [apiAppDvirDvirreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirApi
     */
    public apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest?: ApiAppDvirDvirreportPostRequest, options?: AxiosRequestConfig) {
        return DvirApiFp(this.configuration).apiAppDvirDvirreportPost(apiAppDvirDvirreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirFormApi - axios parameter creator
 * @export
 */
export const DvirFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDefaultdvirformGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/defaultdvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdDelete', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdGet', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdPut: async (id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirformIdPut', 'id', id)
            const localVarPath = `/api/app/dvirform/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirformIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformPost: async (apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirformGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirform/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirFormApi - functional programming interface
 * @export
 */
export const DvirFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirFormApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformDefaultdvirformGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformDefaultdvirformGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DvirFormListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DvirFormListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirFormDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformPost(apiAppDvirformGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirFormApi - factory interface
 * @export
 */
export const DvirFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirFormApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDefaultdvirformGet(options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformDefaultdvirformGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDvirformDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<DvirFormDtoPagedResultDto> {
            return localVarFp.apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirFormListDtoPagedResultDto> {
            return localVarFp.apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<DvirFormListDto>> {
            return localVarFp.apiAppDvirformGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<DvirFormListDto>> {
            return localVarFp.apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirformIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdGet(id: number, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: any): AxiosPromise<DvirFormDto> {
            return localVarFp.apiAppDvirformPost(apiAppDvirformGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirFormApi - object-oriented interface
 * @export
 * @class DvirFormApi
 * @extends {BaseAPI}
 */
export class DvirFormApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformDefaultdvirformGet(options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformDefaultdvirformGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdDelete(id: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppDvirformIdDeleteRequest} [apiAppDvirformIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformIdPut(id: number, apiAppDvirformIdDeleteRequest?: ApiAppDvirformIdDeleteRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformIdPut(id, apiAppDvirformIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDvirformGetRequest} [apiAppDvirformGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformPost(apiAppDvirformGetRequest?: ApiAppDvirformGetRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformPost(apiAppDvirformGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirFormApi
     */
    public apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return DvirFormApiFp(this.configuration).apiAppDvirformUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DvirHistoryApi - axios parameter creator
 * @export
 */
export const DvirHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirhistory/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirhistoryIdGet', 'id', id)
            const localVarPath = `/api/app/dvirhistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetPhotosPost: async (defectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/get-photos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defectId !== undefined) {
                localVarQueryParameter['defectId'] = defectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsReopenPost: async (defectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/reopen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defectId !== undefined) {
                localVarQueryParameter['defectId'] = defectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsResolvePost: async (apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehicledefects/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDvirvehicledefectsResolvePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/dvirvehiclehistory/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppDvirvehiclehistoryIdGet', 'id', id)
            const localVarPath = `/api/app/dvirvehiclehistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DvirHistoryApi - functional programming interface
 * @export
 */
export const DvirHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DvirHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirhistoryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirhistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DvirHistoryDefectDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsGetPhotosPost(defectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsReopenPost(defectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDvirHistoryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDvirvehiclehistoryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDvirHistoryEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDvirvehiclehistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DvirHistoryApi - factory interface
 * @export
 */
export const DvirHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DvirHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirHistoryListDtoPagedResultDto> {
            return localVarFp.apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirhistoryIdGet(id: number, options?: any): AxiosPromise<DvirHistoryListDto> {
            return localVarFp.apiAppDvirhistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DvirHistoryDefectDtoPagedResultDto> {
            return localVarFp.apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiAppDvirvehicledefectsGetPhotosPost(defectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [defectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirvehicledefectsReopenPost(defectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleDvirHistoryListDtoPagedResultDto> {
            return localVarFp.apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDvirvehiclehistoryIdGet(id: number, options?: any): AxiosPromise<VehicleDvirHistoryEntryDto> {
            return localVarFp.apiAppDvirvehiclehistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DvirHistoryApi - object-oriented interface
 * @export
 * @class DvirHistoryApi
 * @extends {BaseAPI}
 */
export class DvirHistoryApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirhistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirhistoryIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirhistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [defectId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsGetPhotosPost(defectId?: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsGetPhotosPost(defectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [defectId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsReopenPost(defectId?: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsReopenPost(defectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDvirvehicledefectsResolvePostRequest} [apiAppDvirvehicledefectsResolvePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest?: ApiAppDvirvehicledefectsResolvePostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehicledefectsResolvePost(apiAppDvirvehicledefectsResolvePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehiclehistoryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DvirHistoryApi
     */
    public apiAppDvirvehiclehistoryIdGet(id: number, options?: AxiosRequestConfig) {
        return DvirHistoryApiFp(this.configuration).apiAppDvirvehiclehistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceApi - axios parameter creator
 * @export
 */
export const EldDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdDelete', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdGet', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdPut: async (id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddeviceIdPut', 'id', id)
            const localVarPath = `/api/app/elddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicePost: async (apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevice/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceApi - functional programming interface
 * @export
 */
export const EldDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicePost(apiAppElddeviceGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceApi - factory interface
 * @export
 */
export const EldDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppElddeviceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<EldDeviceDtoPagedResultDto> {
            return localVarFp.apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceListDtoPagedResultDto> {
            return localVarFp.apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<EldDeviceListDto>> {
            return localVarFp.apiAppElddeviceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<EldDeviceListDto>> {
            return localVarFp.apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppElddeviceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdGet(id: number, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: any): AxiosPromise<EldDeviceDto> {
            return localVarFp.apiAppElddevicePost(apiAppElddeviceGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceApi - object-oriented interface
 * @export
 * @class EldDeviceApi
 * @extends {BaseAPI}
 */
export class EldDeviceApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdDelete(id: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdGet(id: number, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppElddeviceIdDeleteRequest} [apiAppElddeviceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceIdPut(id: number, apiAppElddeviceIdDeleteRequest?: ApiAppElddeviceIdDeleteRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceIdPut(id, apiAppElddeviceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppElddeviceGetRequest} [apiAppElddeviceGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddevicePost(apiAppElddeviceGetRequest?: ApiAppElddeviceGetRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddevicePost(apiAppElddeviceGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceApi
     */
    public apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return EldDeviceApiFp(this.configuration).apiAppElddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceMessageApi - axios parameter creator
 * @export
 */
export const EldDeviceMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddevicemessage/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppElddevicemessageIdGet', 'id', id)
            const localVarPath = `/api/app/elddevicemessage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceMessageApi - functional programming interface
 * @export
 */
export const EldDeviceMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceMessageDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddevicemessageIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceParsedMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddevicemessageIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceMessageApi - factory interface
 * @export
 */
export const EldDeviceMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceMessageApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDeviceMessageDtoPagedResultDto> {
            return localVarFp.apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddevicemessageIdGet(id: string, options?: any): AxiosPromise<EldDeviceParsedMessageDto> {
            return localVarFp.apiAppElddevicemessageIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceMessageApi - object-oriented interface
 * @export
 * @class EldDeviceMessageApi
 * @extends {BaseAPI}
 */
export class EldDeviceMessageApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceMessageApi
     */
    public apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceMessageApiFp(this.configuration).apiAppElddevicemessageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceMessageApi
     */
    public apiAppElddevicemessageIdGet(id: string, options?: AxiosRequestConfig) {
        return EldDeviceMessageApiFp(this.configuration).apiAppElddevicemessageIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDeviceUsageHistoryApi - axios parameter creator
 * @export
 */
export const EldDeviceUsageHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost: async (apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddeviceusagehistory/getelddeviceusagehistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDeviceUsageHistoryApi - functional programming interface
 * @export
 */
export const EldDeviceUsageHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDeviceUsageHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EldDeviceUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDeviceUsageHistoryApi - factory interface
 * @export
 */
export const EldDeviceUsageHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDeviceUsageHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: any): AxiosPromise<Array<EldDeviceUsageHistoryListDto>> {
            return localVarFp.apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDeviceUsageHistoryApi - object-oriented interface
 * @export
 * @class EldDeviceUsageHistoryApi
 * @extends {BaseAPI}
 */
export class EldDeviceUsageHistoryApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest} [apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDeviceUsageHistoryApi
     */
    public apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest?: ApiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options?: AxiosRequestConfig) {
        return EldDeviceUsageHistoryApiFp(this.configuration).apiAppElddeviceusagehistoryGetelddeviceusagehistoryPost(apiAppElddeviceusagehistoryGetelddeviceusagehistoryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldDisconnectionApi - axios parameter creator
 * @export
 */
export const EldDisconnectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddisconnection/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionReporteldconnectionPost: async (apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/elddisconnection/reporteldconnection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppElddisconnectionReporteldconnectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldDisconnectionApi - functional programming interface
 * @export
 */
export const EldDisconnectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldDisconnectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDisconnectionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEldDisconnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldDisconnectionApi - factory interface
 * @export
 */
export const EldDisconnectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldDisconnectionApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldDisconnectionListDtoPagedResultDto> {
            return localVarFp.apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: any): AxiosPromise<CreateEldDisconnectionDto> {
            return localVarFp.apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldDisconnectionApi - object-oriented interface
 * @export
 * @class EldDisconnectionApi
 * @extends {BaseAPI}
 */
export class EldDisconnectionApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDisconnectionApi
     */
    public apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldDisconnectionApiFp(this.configuration).apiAppElddisconnectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppElddisconnectionReporteldconnectionPostRequest} [apiAppElddisconnectionReporteldconnectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldDisconnectionApi
     */
    public apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest?: ApiAppElddisconnectionReporteldconnectionPostRequest, options?: AxiosRequestConfig) {
        return EldDisconnectionApiFp(this.configuration).apiAppElddisconnectionReporteldconnectionPost(apiAppElddisconnectionReporteldconnectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EldMalfunctionsApi - axios parameter creator
 * @export
 */
export const EldMalfunctionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldmalfunctionsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eldmalfunctions/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EldMalfunctionsApi - functional programming interface
 * @export
 */
export const EldMalfunctionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EldMalfunctionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldMalfunctionOrDataDiagnosticPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EldMalfunctionsApi - factory interface
 * @export
 */
export const EldMalfunctionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EldMalfunctionsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<EldMalfunctionOrDataDiagnosticPagedResultDto> {
            return localVarFp.apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EldMalfunctionsApi - object-oriented interface
 * @export
 * @class EldMalfunctionsApi
 * @extends {BaseAPI}
 */
export class EldMalfunctionsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EldMalfunctionsApi
     */
    public apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EldMalfunctionsApiFp(this.configuration).apiAppEldmalfunctionsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddremarkPost: async (apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/addremark`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAddremarkPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddstatusPost: async (apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/addstatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAddstatusPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAssignPut: async (apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventAssignPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBatchPost: async (apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBatchPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetcodriverPost: async (apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetcodriver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetcodriverPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetshippingdocsPost: async (apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetshippingdocs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetshippingdocsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksettrailersPost: async (apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksettrailers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksettrailersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetvehiclePost: async (apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/bulksetvehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventBulksetvehiclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventCertifylogdatePost: async (apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/certifylogdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventCertifylogdatePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDeleteManyDelete: async (apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventDeleteManyDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDriversevendayhistoryGet: async (lastUpdated?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/driversevendayhistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastUpdated !== undefined) {
                localVarQueryParameter['lastUpdated'] = (lastUpdated as any instanceof Date) ?
                    (lastUpdated as any).toISOString() :
                    lastUpdated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventFixeventsPost: async (apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/fixevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventFixeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGet: async (uuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGetallowedeventtimerangeGet: async (driverId?: number, logDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/getallowedeventtimerange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['DriverId'] = driverId;
            }

            if (logDate !== undefined) {
                localVarQueryParameter['LogDate'] = (logDate as any instanceof Date) ?
                    (logDate as any).toISOString() :
                    logDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdDelete', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdGet', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdPut: async (id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventIdPut', 'id', id)
            const localVarPath = `/api/app/event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventInvalidatemobileeventsPost: async (apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/invalidatemobileevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventInvalidatemobileeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventNextdriverdutystatuseventEventIdGet: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiAppEventNextdriverdutystatuseventEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/app/event/nextdriverdutystatusevent/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventReassigneventsPost: async (apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/reassignevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventReassigneventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclePost: async (apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/rebuildcycle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRebuildcyclePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclefromeventPost: async (apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/rebuildcyclefromevent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRebuildcyclefromeventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRegenerateintermediatesPost: async (apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/regenerateintermediates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventRegenerateintermediatesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventResizeeventsPost: async (apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/resizeevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventResizeeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSetdrivingnotePost: async (apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/setdrivingnote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventSetdrivingnotePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShifteventsPost: async (apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/shiftevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventShifteventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShipmentnumberPost: async (apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/shipmentnumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventShipmentnumberPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSmartfixeventsPost: async (apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/smartfixevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppEventSmartfixeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSynceventmanipulationGet: async (lastUpdated?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/event/synceventmanipulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastUpdated !== undefined) {
                localVarQueryParameter['lastUpdated'] = (lastUpdated as any instanceof Date) ?
                    (lastUpdated as any).toISOString() :
                    lastUpdated;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventAssignPut(apiAppEventAssignPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateEventOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBatchPost(apiAppEventBatchPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileEventOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventDriversevendayhistoryGet(lastUpdated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventGet(uuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventGet(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogEventTimeRange>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChangeRequestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextDutyStatusEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventErrorInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventManipulationSyncOutputItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventSynceventmanipulationGet(lastUpdated, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: any): AxiosPromise<EventViewDto> {
            return localVarFp.apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: any): AxiosPromise<EventViewDto> {
            return localVarFp.apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventAssignPut(apiAppEventAssignPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: any): AxiosPromise<Array<CreateEventOutputDto>> {
            return localVarFp.apiAppEventBatchPost(apiAppEventBatchPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: any): AxiosPromise<MobileEventOutputDtoPagedResultDto> {
            return localVarFp.apiAppEventDriversevendayhistoryGet(lastUpdated, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [uuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGet(uuid?: string, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [logDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: any): AxiosPromise<DriverLogEventTimeRange> {
            return localVarFp.apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdGet(id: number, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: any): AxiosPromise<CreateChangeRequestEvent> {
            return localVarFp.apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: any): AxiosPromise<NextDutyStatusEventDto> {
            return localVarFp.apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: any): AxiosPromise<Array<EventErrorInfo>> {
            return localVarFp.apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastUpdated] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: any): AxiosPromise<Array<EventManipulationSyncOutputItemDto>> {
            return localVarFp.apiAppEventSynceventmanipulationGet(lastUpdated, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppEventAddremarkPostRequest} [apiAppEventAddremarkPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest?: ApiAppEventAddremarkPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAddremarkPost(apiAppEventAddremarkPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventAddstatusPostRequest} [apiAppEventAddstatusPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest?: ApiAppEventAddstatusPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAddstatusPost(apiAppEventAddstatusPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventAssignPutRequest} [apiAppEventAssignPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventAssignPut(apiAppEventAssignPutRequest?: ApiAppEventAssignPutRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventAssignPut(apiAppEventAssignPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBatchPostRequest} [apiAppEventBatchPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBatchPost(apiAppEventBatchPostRequest?: ApiAppEventBatchPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBatchPost(apiAppEventBatchPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetcodriverPostRequest} [apiAppEventBulksetcodriverPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest?: ApiAppEventBulksetcodriverPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetcodriverPost(apiAppEventBulksetcodriverPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetshippingdocsPostRequest} [apiAppEventBulksetshippingdocsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest?: ApiAppEventBulksetshippingdocsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetshippingdocsPost(apiAppEventBulksetshippingdocsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksettrailersPostRequest} [apiAppEventBulksettrailersPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest?: ApiAppEventBulksettrailersPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksettrailersPost(apiAppEventBulksettrailersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventBulksetvehiclePostRequest} [apiAppEventBulksetvehiclePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest?: ApiAppEventBulksetvehiclePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventBulksetvehiclePost(apiAppEventBulksetvehiclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventCertifylogdatePostRequest} [apiAppEventCertifylogdatePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest?: ApiAppEventCertifylogdatePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventCertifylogdatePost(apiAppEventCertifylogdatePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventDeleteManyDeleteRequest} [apiAppEventDeleteManyDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest?: ApiAppEventDeleteManyDeleteRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventDeleteManyDelete(apiAppEventDeleteManyDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastUpdated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventDriversevendayhistoryGet(lastUpdated?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventDriversevendayhistoryGet(lastUpdated, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventFixeventsPostRequest} [apiAppEventFixeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest?: ApiAppEventFixeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventFixeventsPost(apiAppEventFixeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [uuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventGet(uuid?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {string} [logDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventGetallowedeventtimerangeGet(driverId?: number, logDate?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventGetallowedeventtimerangeGet(driverId, logDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdDelete(id: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdGet(id: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppEventIdDeleteRequest} [apiAppEventIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventIdPut(id: number, apiAppEventIdDeleteRequest?: ApiAppEventIdDeleteRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventIdPut(id, apiAppEventIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventInvalidatemobileeventsPostRequest} [apiAppEventInvalidatemobileeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest?: ApiAppEventInvalidatemobileeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventInvalidatemobileeventsPost(apiAppEventInvalidatemobileeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventNextdriverdutystatuseventEventIdGet(eventId: number, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventNextdriverdutystatuseventEventIdGet(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventReassigneventsPostRequest} [apiAppEventReassigneventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest?: ApiAppEventReassigneventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventReassigneventsPost(apiAppEventReassigneventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRebuildcyclePostRequest} [apiAppEventRebuildcyclePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest?: ApiAppEventRebuildcyclePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRebuildcyclePost(apiAppEventRebuildcyclePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRebuildcyclefromeventPostRequest} [apiAppEventRebuildcyclefromeventPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest?: ApiAppEventRebuildcyclefromeventPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRebuildcyclefromeventPost(apiAppEventRebuildcyclefromeventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventRegenerateintermediatesPostRequest} [apiAppEventRegenerateintermediatesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest?: ApiAppEventRegenerateintermediatesPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventRegenerateintermediatesPost(apiAppEventRegenerateintermediatesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventResizeeventsPostRequest} [apiAppEventResizeeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest?: ApiAppEventResizeeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventResizeeventsPost(apiAppEventResizeeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventSetdrivingnotePostRequest} [apiAppEventSetdrivingnotePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest?: ApiAppEventSetdrivingnotePostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSetdrivingnotePost(apiAppEventSetdrivingnotePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventShifteventsPostRequest} [apiAppEventShifteventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest?: ApiAppEventShifteventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventShifteventsPost(apiAppEventShifteventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventShipmentnumberPostRequest} [apiAppEventShipmentnumberPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest?: ApiAppEventShipmentnumberPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventShipmentnumberPost(apiAppEventShipmentnumberPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppEventSmartfixeventsPostRequest} [apiAppEventSmartfixeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest?: ApiAppEventSmartfixeventsPostRequest, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSmartfixeventsPost(apiAppEventSmartfixeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastUpdated] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public apiAppEventSynceventmanipulationGet(lastUpdated?: string, options?: AxiosRequestConfig) {
        return EventApiFp(this.configuration).apiAppEventSynceventmanipulationGet(lastUpdated, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventViewApi - axios parameter creator
 * @export
 */
export const EventViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/app/eventview/eventeldcreationtimeandodometersource/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/eventview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppEventviewIdGet', 'id', id)
            const localVarPath = `/api/app/eventview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventViewApi - functional programming interface
 * @export
 */
export const EventViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldCreationTimeOdometerSourceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppEventviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppEventviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventViewApi - factory interface
 * @export
 */
export const EventViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventViewApiFp(configuration)
    return {
        /**
         * 
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: any): AxiosPromise<EldCreationTimeOdometerSourceDto> {
            return localVarFp.apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ViewEventDtoPagedResultDto> {
            return localVarFp.apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ViewEventDtoPagedResultDto> {
            return localVarFp.apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<ViewEventDto>> {
            return localVarFp.apiAppEventviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ViewEventDto>> {
            return localVarFp.apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppEventviewIdGet(id: number, options?: any): AxiosPromise<ViewEventDto> {
            return localVarFp.apiAppEventviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventViewApi - object-oriented interface
 * @export
 * @class EventViewApi
 * @extends {BaseAPI}
 */
export class EventViewApi extends BaseAPI {
    /**
     * 
     * @param {number} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewEventeldcreationtimeandodometersourceEventIdGet(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventViewApi
     */
    public apiAppEventviewIdGet(id: number, options?: AxiosRequestConfig) {
        return EventViewApiFp(this.configuration).apiAppEventviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesGet: async (providerName?: string, providerKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feature-management/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesPut: async (providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feature-management/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiFeatureManagementFeaturesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeatureListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeatureManagementFeaturesGet(providerName, providerKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: any): AxiosPromise<GetFeatureListResultDto> {
            return localVarFp.apiFeatureManagementFeaturesGet(providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public apiFeatureManagementFeaturesGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).apiFeatureManagementFeaturesGet(providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {ApiFeatureManagementFeaturesGetRequest} [apiFeatureManagementFeaturesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public apiFeatureManagementFeaturesPut(providerName?: string, providerKey?: string, apiFeatureManagementFeaturesGetRequest?: ApiFeatureManagementFeaturesGetRequest, options?: AxiosRequestConfig) {
        return FeaturesApiFp(this.configuration).apiFeatureManagementFeaturesPut(providerName, providerKey, apiFeatureManagementFeaturesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FleetManagerApi - axios parameter creator
 * @export
 */
export const FleetManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdDelete', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdGet', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdPut: async (id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdPut', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFleetmanagerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost', 'id', id)
            const localVarPath = `/api/app/fleetmanager/{id}/requestresetpasswordlinkforfleetmanager`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerPost: async (apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fleetmanager/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetManagerApi - functional programming interface
 * @export
 */
export const FleetManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FleetManagerApi - factory interface
 * @export
 */
export const FleetManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetManagerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFleetmanagerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FleetManagerDtoPagedResultDto> {
            return localVarFp.apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FleetManagerListDtoPagedResultDto> {
            return localVarFp.apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<FleetManagerListDto>> {
            return localVarFp.apiAppFleetmanagerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FleetManagerListDto>> {
            return localVarFp.apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdGet(id: number, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: any): AxiosPromise<FleetManagerDto> {
            return localVarFp.apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetManagerApi - object-oriented interface
 * @export
 * @class FleetManagerApi
 * @extends {BaseAPI}
 */
export class FleetManagerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdDelete(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdGet(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppFleetmanagerIdDeleteRequest} [apiAppFleetmanagerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdPut(id: number, apiAppFleetmanagerIdDeleteRequest?: ApiAppFleetmanagerIdDeleteRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdPut(id, apiAppFleetmanagerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id: number, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFleetmanagerGetRequest} [apiAppFleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest?: ApiAppFleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerPost(apiAppFleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerApi
     */
    public apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FleetManagerApiFp(this.configuration).apiAppFleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FleetManagerLoginApi - axios parameter creator
 * @export
 */
export const FleetManagerLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLoginPost: async (id?: string, sessionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLogoutPost: async (id?: string, sessionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginPasswordChangedPost: async (id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fleetmanagerlogin/password-changed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetManagerLoginApi - functional programming interface
 * @export
 */
export const FleetManagerLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetManagerLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginLoginPost(id, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginLogoutPost(id, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFleetmanagerloginPasswordChangedPost(id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFleetmanagerloginPasswordChangedPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FleetManagerLoginApi - factory interface
 * @export
 */
export const FleetManagerLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetManagerLoginApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginLoginPost(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginLogoutPost(id, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFleetmanagerloginPasswordChangedPost(id?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiFleetmanagerloginPasswordChangedPost(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetManagerLoginApi - object-oriented interface
 * @export
 * @class FleetManagerLoginApi
 * @extends {BaseAPI}
 */
export class FleetManagerLoginApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginGet(options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginLoginPost(id?: string, sessionId?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginLoginPost(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginLogoutPost(id?: string, sessionId?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginLogoutPost(id, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetManagerLoginApi
     */
    public apiFleetmanagerloginPasswordChangedPost(id?: string, options?: AxiosRequestConfig) {
        return FleetManagerLoginApiFp(this.configuration).apiFleetmanagerloginPasswordChangedPost(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FmcsaInspectionApi - axios parameter creator
 * @export
 */
export const FmcsaInspectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdDelete', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdGet', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdPut: async (id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFmcsainspectionIdPut', 'id', id)
            const localVarPath = `/api/app/fmcsainspection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionManualcreatefmcsainspectionPost: async (base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/manualcreatefmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (base64EncodedEldFileContents !== undefined) {
                localVarQueryParameter['base64EncodedEldFileContents'] = base64EncodedEldFileContents;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionMarkunofficialPost: async (apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/markunofficial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionMarkunofficialPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionPost: async (apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsainspection/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FmcsaInspectionApi - functional programming interface
 * @export
 */
export const FmcsaInspectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FmcsaInspectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FmcsaInspectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FmcsaInspectionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaInspectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FmcsaInspectionApi - factory interface
 * @export
 */
export const FmcsaInspectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FmcsaInspectionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFmcsainspectionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FmcsaInspectionDtoPagedResultDto> {
            return localVarFp.apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FmcsaInspectionListDtoPagedResultDto> {
            return localVarFp.apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<FmcsaInspectionListDto>> {
            return localVarFp.apiAppFmcsainspectionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FmcsaInspectionListDto>> {
            return localVarFp.apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdGet(id: string, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [base64EncodedEldFileContents] 
         * @param {string} [fileName] 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: any): AxiosPromise<FmcsaInspectionDto> {
            return localVarFp.apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FmcsaInspectionApi - object-oriented interface
 * @export
 * @class FmcsaInspectionApi
 * @extends {BaseAPI}
 */
export class FmcsaInspectionApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdDelete(id: string, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdGet(id: string, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppFmcsainspectionIdDeleteRequest} [apiAppFmcsainspectionIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionIdPut(id: string, apiAppFmcsainspectionIdDeleteRequest?: ApiAppFmcsainspectionIdDeleteRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionIdPut(id, apiAppFmcsainspectionIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [base64EncodedEldFileContents] 
     * @param {string} [fileName] 
     * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents?: string, fileName?: string, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionManualcreatefmcsainspectionPost(base64EncodedEldFileContents, fileName, apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionMarkunofficialPostRequest} [apiAppFmcsainspectionMarkunofficialPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest?: ApiAppFmcsainspectionMarkunofficialPostRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionMarkunofficialPost(apiAppFmcsainspectionMarkunofficialPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionGetRequest} [apiAppFmcsainspectionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest?: ApiAppFmcsainspectionGetRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionPost(apiAppFmcsainspectionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaInspectionApi
     */
    public apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FmcsaInspectionApiFp(this.configuration).apiAppFmcsainspectionUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FmcsaTransferApi - axios parameter creator
 * @export
 */
export const FmcsaTransferApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferFmcsaoptionsGet: async (mobileApplicationType?: MobileApplicationType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/fmcsaoptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mobileApplicationType !== undefined) {
                localVarQueryParameter['mobileApplicationType'] = mobileApplicationType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferGenerateeldfilePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/generateeldfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferManualcreatefmcsainspectionPost: async (apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/manualcreatefmcsainspection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferPingwebserviceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/pingwebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttoemailPost: async (apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittesttoemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittoemailPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttowebservicePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittesttowebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittoemailPost: async (apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittoemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittoemailPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittowebservicePost: async (apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fmcsatransfer/submittowebservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFmcsatransferSubmittowebservicePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FmcsaTransferApi - functional programming interface
 * @export
 */
export const FmcsaTransferApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FmcsaTransferApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaEldFileOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferPingwebserviceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiagnosticResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferPingwebserviceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELDSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELDSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FmcsaTransferApi - factory interface
 * @export
 */
export const FmcsaTransferApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FmcsaTransferApiFp(configuration)
    return {
        /**
         * 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: any): AxiosPromise<FmcsaOptions> {
            return localVarFp.apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<FmcsaEldFileOutputDto> {
            return localVarFp.apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferPingwebserviceGet(options?: any): AxiosPromise<DiagnosticResponse> {
            return localVarFp.apiAppFmcsatransferPingwebserviceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<ELDSubmissionResponse> {
            return localVarFp.apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: any): AxiosPromise<ELDSubmissionResponse> {
            return localVarFp.apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FmcsaTransferApi - object-oriented interface
 * @export
 * @class FmcsaTransferApi
 * @extends {BaseAPI}
 */
export class FmcsaTransferApi extends BaseAPI {
    /**
     * 
     * @param {MobileApplicationType} [mobileApplicationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType?: MobileApplicationType, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferFmcsaoptionsGet(mobileApplicationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferGenerateeldfilePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest} [apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest?: ApiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferManualcreatefmcsainspectionPost(apiAppFmcsainspectionManualcreatefmcsainspectionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferPingwebserviceGet(options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferPingwebserviceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittesttoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittesttowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittoemailPostRequest} [apiAppFmcsatransferSubmittoemailPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest?: ApiAppFmcsatransferSubmittoemailPostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittoemailPost(apiAppFmcsatransferSubmittoemailPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFmcsatransferSubmittowebservicePostRequest} [apiAppFmcsatransferSubmittowebservicePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FmcsaTransferApi
     */
    public apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest?: ApiAppFmcsatransferSubmittowebservicePostRequest, options?: AxiosRequestConfig) {
        return FmcsaTransferApiFp(this.configuration).apiAppFmcsatransferSubmittowebservicePost(apiAppFmcsatransferSubmittowebservicePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FuelEconomyReportApi - axios parameter creator
 * @export
 */
export const FuelEconomyReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetacceleratefuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getacceleratefuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetaveragefuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getaveragefuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetdriverfuelconsumptionPost: async (apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getdriverfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyactionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbyaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyperiodPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbyperiod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionbytimeofday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionefficiencyPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getfuelconsumptionefficiency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetmaxfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getmaxfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetminfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getminfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetspeedingfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getspeedingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetworstperformersfuelconsumptionPost: async (apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fueleconomyreport/getworstperformersfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelEconomyReportApi - functional programming interface
 * @export
 */
export const FuelEconomyReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FuelEconomyReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriversFuelConsumptionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByPeriodDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionByTimeOfDayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionEfficiencyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelConsumptionCardsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorstPerformersFuelConsumptionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FuelEconomyReportApi - factory interface
 * @export
 */
export const FuelEconomyReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FuelEconomyReportApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: any): AxiosPromise<DriversFuelConsumptionDtoPagedResultDto> {
            return localVarFp.apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByActionDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByPeriodDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionByTimeOfDayDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionEfficiencyDto> {
            return localVarFp.apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<FuelConsumptionCardsDto> {
            return localVarFp.apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: any): AxiosPromise<Array<WorstPerformersFuelConsumptionDto>> {
            return localVarFp.apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelEconomyReportApi - object-oriented interface
 * @export
 * @class FuelEconomyReportApi
 * @extends {BaseAPI}
 */
export class FuelEconomyReportApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetacceleratefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetaveragefuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest} [apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest?: ApiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetdriverfuelconsumptionPost(apiAppFueleconomyreportGetdriverfuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbyactionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbyperiodPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionbytimeofdayPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetfuelconsumptionefficiencyPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetmaxfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetminfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetspeedingfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest} [apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelEconomyReportApi
     */
    public apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest?: ApiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options?: AxiosRequestConfig) {
        return FuelEconomyReportApiFp(this.configuration).apiAppFueleconomyreportGetworstperformersfuelconsumptionPost(apiAppFueleconomyreportGetaveragefuelconsumptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FuelProviderApi - axios parameter creator
 * @export
 */
export const FuelProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdDelete', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdGet', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdPut: async (id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppFuelproviderIdPut', 'id', id)
            const localVarPath = `/api/app/fuelprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFuelproviderIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderPost: async (apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppFuelproviderGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/fuelprovider/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelProviderApi - functional programming interface
 * @export
 */
export const FuelProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FuelProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FuelProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FuelProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuelProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FuelProviderApi - factory interface
 * @export
 */
export const FuelProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FuelProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFuelproviderDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<FuelProviderDtoPagedResultDto> {
            return localVarFp.apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<FuelProviderDtoPagedResultDto> {
            return localVarFp.apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<FuelProviderDto>> {
            return localVarFp.apiAppFuelproviderGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<FuelProviderDto>> {
            return localVarFp.apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppFuelproviderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdGet(id: number, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: any): AxiosPromise<FuelProviderDto> {
            return localVarFp.apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelProviderApi - object-oriented interface
 * @export
 * @class FuelProviderApi
 * @extends {BaseAPI}
 */
export class FuelProviderApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdDelete(id: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdGet(id: number, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppFuelproviderIdDeleteRequest} [apiAppFuelproviderIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderIdPut(id: number, apiAppFuelproviderIdDeleteRequest?: ApiAppFuelproviderIdDeleteRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderIdPut(id, apiAppFuelproviderIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppFuelproviderGetRequest} [apiAppFuelproviderGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderPost(apiAppFuelproviderGetRequest?: ApiAppFuelproviderGetRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderPost(apiAppFuelproviderGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelProviderApi
     */
    public apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return FuelProviderApiFp(this.configuration).apiAppFuelproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeolocationApi - axios parameter creator
 * @export
 */
export const GeolocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationGet: async (lat?: number, lng?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/geolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationwithradiusGet: async (lat?: number, lng?: number, radius?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/geolocationwithradius`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationStategeolocationGet: async (lat?: number, lng?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geolocation/stategeolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeolocationApi - functional programming interface
 * @export
 */
export const GeolocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeolocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationGeolocationGet(lat, lng, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateGeolocationResultModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeolocationStategeolocationGet(lat, lng, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeolocationApi - factory interface
 * @export
 */
export const GeolocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeolocationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: any): AxiosPromise<GeolocationResultModel> {
            return localVarFp.apiAppGeolocationGeolocationGet(lat, lng, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: any): AxiosPromise<GeolocationResultModel> {
            return localVarFp.apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [lat] 
         * @param {number} [lng] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: any): AxiosPromise<StateGeolocationResultModel> {
            return localVarFp.apiAppGeolocationStategeolocationGet(lat, lng, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeolocationApi - object-oriented interface
 * @export
 * @class GeolocationApi
 * @extends {BaseAPI}
 */
export class GeolocationApi extends BaseAPI {
    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationGeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationGeolocationGet(lat, lng, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {number} [radius] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationGeolocationwithradiusGet(lat?: number, lng?: number, radius?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationGeolocationwithradiusGet(lat, lng, radius, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [lat] 
     * @param {number} [lng] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public apiAppGeolocationStategeolocationGet(lat?: number, lng?: number, options?: AxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).apiAppGeolocationStategeolocationGet(lat, lng, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeometrisApiApi - axios parameter creator
 * @export
 */
export const GeometrisApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSenddevicecommandPost: async (apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/senddevicecommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSenddevicecommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendresetcommandPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/sendresetcommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendshipmodecommandPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/sendshipmodecommand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetdeviceconfigurationPost: async (apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setdeviceconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSendresetcommandPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetenginebustypePost: async (apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setenginebustype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSetenginebustypePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetodometervaluePost: async (apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/geometrisapi/setodometervalue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGeometrisapiSetodometervaluePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeometrisApiApi - functional programming interface
 * @export
 */
export const GeometrisApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeometrisApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeometrisDeviceCommandOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeometrisApiApi - factory interface
 * @export
 */
export const GeometrisApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeometrisApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: any): AxiosPromise<GeometrisDeviceCommandOutput> {
            return localVarFp.apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeometrisApiApi - object-oriented interface
 * @export
 * @class GeometrisApiApi
 * @extends {BaseAPI}
 */
export class GeometrisApiApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppGeometrisapiSenddevicecommandPostRequest} [apiAppGeometrisapiSenddevicecommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest?: ApiAppGeometrisapiSenddevicecommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSenddevicecommandPost(apiAppGeometrisapiSenddevicecommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSendresetcommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSendshipmodecommandPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSendresetcommandPostRequest} [apiAppGeometrisapiSendresetcommandPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest?: ApiAppGeometrisapiSendresetcommandPostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetdeviceconfigurationPost(apiAppGeometrisapiSendresetcommandPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSetenginebustypePostRequest} [apiAppGeometrisapiSetenginebustypePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest?: ApiAppGeometrisapiSetenginebustypePostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetenginebustypePost(apiAppGeometrisapiSetenginebustypePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGeometrisapiSetodometervaluePostRequest} [apiAppGeometrisapiSetodometervaluePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometrisApiApi
     */
    public apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest?: ApiAppGeometrisapiSetodometervaluePostRequest, options?: AxiosRequestConfig) {
        return GeometrisApiApiFp(this.configuration).apiAppGeometrisapiSetodometervaluePost(apiAppGeometrisapiSetodometervaluePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GlobalSearchApi - axios parameter creator
 * @export
 */
export const GlobalSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchAdvancedsearchPost: async (apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/globalsearch/advancedsearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGlobalsearchAdvancedsearchPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchQuicksearchGet: async (searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/globalsearch/quicksearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['SearchText'] = searchText;
            }

            if (includeDrivers !== undefined) {
                localVarQueryParameter['IncludeDrivers'] = includeDrivers;
            }

            if (includeVehicles !== undefined) {
                localVarQueryParameter['IncludeVehicles'] = includeVehicles;
            }

            if (includeTrailers !== undefined) {
                localVarQueryParameter['IncludeTrailers'] = includeTrailers;
            }

            if (includeEldDevices !== undefined) {
                localVarQueryParameter['IncludeEldDevices'] = includeEldDevices;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalSearchApi - functional programming interface
 * @export
 */
export const GlobalSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvancedSearchListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuickSearchListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GlobalSearchApi - factory interface
 * @export
 */
export const GlobalSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalSearchApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: any): AxiosPromise<AdvancedSearchListDto> {
            return localVarFp.apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchText] 
         * @param {boolean} [includeDrivers] 
         * @param {boolean} [includeVehicles] 
         * @param {boolean} [includeTrailers] 
         * @param {boolean} [includeEldDevices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: any): AxiosPromise<QuickSearchListDto> {
            return localVarFp.apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalSearchApi - object-oriented interface
 * @export
 * @class GlobalSearchApi
 * @extends {BaseAPI}
 */
export class GlobalSearchApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppGlobalsearchAdvancedsearchPostRequest} [apiAppGlobalsearchAdvancedsearchPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchApi
     */
    public apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest?: ApiAppGlobalsearchAdvancedsearchPostRequest, options?: AxiosRequestConfig) {
        return GlobalSearchApiFp(this.configuration).apiAppGlobalsearchAdvancedsearchPost(apiAppGlobalsearchAdvancedsearchPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchText] 
     * @param {boolean} [includeDrivers] 
     * @param {boolean} [includeVehicles] 
     * @param {boolean} [includeTrailers] 
     * @param {boolean} [includeEldDevices] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchApi
     */
    public apiAppGlobalsearchQuicksearchGet(searchText?: string, includeDrivers?: boolean, includeVehicles?: boolean, includeTrailers?: boolean, includeEldDevices?: boolean, options?: AxiosRequestConfig) {
        return GlobalSearchApiFp(this.configuration).apiAppGlobalsearchQuicksearchGet(searchText, includeDrivers, includeVehicles, includeTrailers, includeEldDevices, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdDelete', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdGet', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdPut: async (id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppGroupIdPut', 'id', id)
            const localVarPath = `/api/app/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGroupGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupPost: async (apiAppGroupGetRequest?: ApiAppGroupGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppGroupGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/group/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupIdPut(id, apiAppGroupGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupPost(apiAppGroupGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppGroupDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppGroupExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<GroupDtoPagedResultDto> {
            return localVarFp.apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<GroupListDtoPagedResultDto> {
            return localVarFp.apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<GroupListDto>> {
            return localVarFp.apiAppGroupGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<GroupListDto>> {
            return localVarFp.apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppGroupIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdGet(id: number, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupIdPut(id, apiAppGroupGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: any): AxiosPromise<GroupDto> {
            return localVarFp.apiAppGroupPost(apiAppGroupGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdDelete(id: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdGet(id: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupIdPut(id: number, apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupIdPut(id, apiAppGroupGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppGroupGetRequest} [apiAppGroupGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupPost(apiAppGroupGetRequest?: ApiAppGroupGetRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupPost(apiAppGroupGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).apiAppGroupUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HarshEventReportApi - axios parameter creator
 * @export
 */
export const HarshEventReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetavgspeedingPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getavgspeeding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverharsheventssummaryPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverharsheventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverscoresPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverscores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithbestperformancePost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverswithbestperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithworstperformancePost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getdriverswithworstperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost: async (apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getfiltereddriverharsheventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshaccelerationeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshaccelerationevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshbreakingeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshbreakingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventdailylogsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharsheventdailylogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventsbreakdowninformationPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharsheventsbreakdowninformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshspeedingeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshspeedingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshstopeventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshstopevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshturneventsPost: async (apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/harsheventreport/getharshturnevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HarshEventReportApi - functional programming interface
 * @export
 */
export const HarshEventReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HarshEventReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpeedingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverHarshEventsSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverScoresOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPerformaceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverPerformaceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHarshEventsTotalDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshAccelerationEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshBreakingEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventDailyLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventsBreakdownInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshSpeedingEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshStopEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshTurnEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HarshEventReportApi - factory interface
 * @export
 */
export const HarshEventReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HarshEventReportApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<SpeedingDto> {
            return localVarFp.apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<Array<DriverHarshEventsSummaryDto>> {
            return localVarFp.apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverScoresOutput> {
            return localVarFp.apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverPerformaceDto> {
            return localVarFp.apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<DriverPerformaceDto> {
            return localVarFp.apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: any): AxiosPromise<DriverHarshEventsTotalDtoPagedResultDto> {
            return localVarFp.apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshAccelerationEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshBreakingEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshEventDailyLogDto> {
            return localVarFp.apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshEventsBreakdownInfoDto> {
            return localVarFp.apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshSpeedingEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshStopEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: any): AxiosPromise<HarshTurnEventsDto> {
            return localVarFp.apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HarshEventReportApi - object-oriented interface
 * @export
 * @class HarshEventReportApi
 * @extends {BaseAPI}
 */
export class HarshEventReportApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetavgspeedingPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverharsheventssummaryPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverscoresPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverswithbestperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetdriverswithworstperformancePost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest} [apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest?: ApiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetfiltereddriverharsheventssummaryPost(apiAppHarsheventreportGetfiltereddriverharsheventssummaryPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshaccelerationeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshbreakingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharsheventdailylogsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharsheventsbreakdowninformationPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshspeedingeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshstopeventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHarsheventreportGetharshaccelerationeventsPostRequest} [apiAppHarsheventreportGetharshaccelerationeventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HarshEventReportApi
     */
    public apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest?: ApiAppHarsheventreportGetharshaccelerationeventsPostRequest, options?: AxiosRequestConfig) {
        return HarshEventReportApiFp(this.configuration).apiAppHarsheventreportGetharshturneventsPost(apiAppHarsheventreportGetharshaccelerationeventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HosLogsApi - axios parameter creator
 * @export
 */
export const HosLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriveractivityGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driveractivity/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdailylogPost: async (apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/getdriverdailylog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdutystatuseventsPost: async (apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/driverlogs/getdriverdutystatusevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHosDriversGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hos-drivers/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsAddexceptionPost: async (apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/addexception`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppHoslogsAddexceptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsDriverdailylogrecapGet: async (driverId?: number, currentLogDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/driverdailylogrecap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['DriverId'] = driverId;
            }

            if (currentLogDate !== undefined) {
                localVarQueryParameter['CurrentLogDate'] = (currentLogDate as any instanceof Date) ?
                    (currentLogDate as any).toISOString() :
                    currentLogDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRebuildHosInfoPost: async (driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/hoslogs/rebuild-hos-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRemoveexceptionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppHoslogsRemoveexceptionIdDelete', 'id', id)
            const localVarPath = `/api/app/hoslogs/removeexception/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HosLogsApi - functional programming interface
 * @export
 */
export const HosLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HosLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverActivityDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogGridViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverLogDetailedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HosDriverDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverDailyLogRecapResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsRebuildHosInfoPost(driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppHoslogsRemoveexceptionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HosLogsApi - factory interface
 * @export
 */
export const HosLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HosLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverActivityDtoPagedResultDto> {
            return localVarFp.apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DriverLogGridViewDtoPagedResultDto> {
            return localVarFp.apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: any): AxiosPromise<DriverLogDetailedView> {
            return localVarFp.apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: any): AxiosPromise<Array<EventViewDto>> {
            return localVarFp.apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<HosDriverDtoPagedResultDto> {
            return localVarFp.apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {string} [currentLogDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: any): AxiosPromise<DriverDailyLogRecapResult> {
            return localVarFp.apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsRebuildHosInfoPost(driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppHoslogsRemoveexceptionIdDelete(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HosLogsApi - object-oriented interface
 * @export
 * @class HosLogsApi
 * @extends {BaseAPI}
 */
export class HosLogsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriveractivityGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetdriverdailylogPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDriverlogsGetdriverdutystatuseventsPostRequest} [apiAppDriverlogsGetdriverdutystatuseventsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest?: ApiAppDriverlogsGetdriverdutystatuseventsPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppDriverlogsGetdriverdutystatuseventsPost(apiAppDriverlogsGetdriverdutystatuseventsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHosDriversGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppHoslogsAddexceptionPostRequest} [apiAppHoslogsAddexceptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest?: ApiAppHoslogsAddexceptionPostRequest, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsAddexceptionPost(apiAppHoslogsAddexceptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {string} [currentLogDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsDriverdailylogrecapGet(driverId?: number, currentLogDate?: string, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsDriverdailylogrecapGet(driverId, currentLogDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsRebuildHosInfoPost(driverId?: number, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsRebuildHosInfoPost(driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosLogsApi
     */
    public apiAppHoslogsRemoveexceptionIdDelete(id: number, options?: AxiosRequestConfig) {
        return HosLogsApiFp(this.configuration).apiAppHoslogsRemoveexceptionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IdlingReportsApi - axios parameter creator
 * @export
 */
export const IdlingReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getaverageidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getaverageidlingtimefortimeofday`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetfuelpercentageforidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getfuelpercentageforidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingdatafordriversPost: async (apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingdatafordrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingdatafordriversPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingfuelconsumptionPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingoffdutyaveragePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingoffdutyaverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingondutyaveragePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingondutyaverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingtimebydutyPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getidlingtimebyduty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetmaxidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getmaxidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetminidlingtimePost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getminidlingtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGettotalidlingfuelconsumptionPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/gettotalidlingfuelconsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetworstperformersPost: async (apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/idlingreports/getworstperformers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdlingReportsApi - functional programming interface
 * @export
 */
export const IdlingReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdlingReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AverageIdleTimeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalFuelPercentageInIdleStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllDriversDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdleFuelConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnDutyOffDutyIdleTimeSpentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DutyIdleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalFuelConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorstPerformersDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IdlingReportsApi - factory interface
 * @export
 */
export const IdlingReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdlingReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<AverageIdleTimeDto> {
            return localVarFp.apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<TotalFuelPercentageInIdleStateDto> {
            return localVarFp.apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: any): AxiosPromise<AllDriversDtoPagedResultDto> {
            return localVarFp.apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<IdleFuelConsumptionDto> {
            return localVarFp.apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<OnDutyOffDutyIdleTimeSpentDto> {
            return localVarFp.apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<DutyIdleSummaryDto> {
            return localVarFp.apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<TotalFuelConsumptionDto> {
            return localVarFp.apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: any): AxiosPromise<Array<WorstPerformersDto>> {
            return localVarFp.apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IdlingReportsApi - object-oriented interface
 * @export
 * @class IdlingReportsApi
 * @extends {BaseAPI}
 */
export class IdlingReportsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetaverageidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetaverageidlingtimefortimeofdayPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetfuelpercentageforidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingdatafordriversPostRequest} [apiAppIdlingreportsGetidlingdatafordriversPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest?: ApiAppIdlingreportsGetidlingdatafordriversPostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingdatafordriversPost(apiAppIdlingreportsGetidlingdatafordriversPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingoffdutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingondutyaveragePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetidlingtimebydutyPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetmaxidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetminidlingtimePost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGettotalidlingfuelconsumptionPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest} [apiAppIdlingreportsGetidlingoffdutyaveragePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdlingReportsApi
     */
    public apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest?: ApiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options?: AxiosRequestConfig) {
        return IdlingReportsApiFp(this.configuration).apiAppIdlingreportsGetworstperformersPost(apiAppIdlingreportsGetidlingoffdutyaveragePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LiveTrackTokenApi - axios parameter creator
 * @export
 */
export const LiveTrackTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdDelete', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdGet', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdPut: async (id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdPut', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdVehicleforlivetrackGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLivetracktokenIdVehicleforlivetrackGet', 'id', id)
            const localVarPath = `/api/app/livetracktoken/{id}/vehicleforlivetrack`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenPost: async (apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenUpdateManyPut: async (apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/livetracktoken/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLivetracktokenUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantIdIdGet: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiTenantIdIdGet', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTenantIdIdGet', 'id', id)
            const localVarPath = `/api/{tenantId}/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiveTrackTokenApi - functional programming interface
 * @export
 */
export const LiveTrackTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiveTrackTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveTrackTokenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveTrackTokenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenIdVehicleforlivetrackGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTenantIdIdGet(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicLiveTrackTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTenantIdIdGet(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LiveTrackTokenApi - factory interface
 * @export
 */
export const LiveTrackTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiveTrackTokenApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLivetracktokenDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<LiveTrackTokenDtoPagedResultDto> {
            return localVarFp.apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<LiveTrackTokenDtoPagedResultDto> {
            return localVarFp.apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<LiveTrackTokenDto>> {
            return localVarFp.apiAppLivetracktokenGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<LiveTrackTokenDto>> {
            return localVarFp.apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLivetracktokenIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdGet(id: string, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: any): AxiosPromise<LiveTrackVehicleDto> {
            return localVarFp.apiAppLivetracktokenIdVehicleforlivetrackGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: any): AxiosPromise<LiveTrackTokenDto> {
            return localVarFp.apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantIdIdGet(tenantId: string, id: string, options?: any): AxiosPromise<PublicLiveTrackTokenDto> {
            return localVarFp.apiTenantIdIdGet(tenantId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LiveTrackTokenApi - object-oriented interface
 * @export
 * @class LiveTrackTokenApi
 * @extends {BaseAPI}
 */
export class LiveTrackTokenApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdDelete(id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdGet(id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppLivetracktokenIdDeleteRequest} [apiAppLivetracktokenIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdPut(id: string, apiAppLivetracktokenIdDeleteRequest?: ApiAppLivetracktokenIdDeleteRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdPut(id, apiAppLivetracktokenIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenIdVehicleforlivetrackGet(id: number, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenIdVehicleforlivetrackGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLivetracktokenGetRequest} [apiAppLivetracktokenGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest?: ApiAppLivetracktokenGetRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenPost(apiAppLivetracktokenGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLivetracktokenUpdateManyPutRequest} [apiAppLivetracktokenUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest?: ApiAppLivetracktokenUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiAppLivetracktokenUpdateManyPut(apiAppLivetracktokenUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveTrackTokenApi
     */
    public apiTenantIdIdGet(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return LiveTrackTokenApiFp(this.configuration).apiTenantIdIdGet(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentLocationsGet: async (selectedCompanies?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/current-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedCompanies) {
                localVarQueryParameter['SelectedCompanies'] = selectedCompanies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationLiveTrackPost: async (apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/live-track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationLiveTrackPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationTrailerLocationHistoryGet: async (name?: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/trailer-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleLocationHistoryGet: async (vehicleId?: number, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/location/vehicle-location-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerLocationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationCurrentLocationsGet(selectedCompanies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationTrailerLocationHistoryGet(name, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerLocationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerGpsLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerLocationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedCompanies] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: any): AxiosPromise<Array<CurrentLocationDto>> {
            return localVarFp.apiAppLocationCurrentLocationsGet(selectedCompanies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: any): AxiosPromise<LocationHistoryDto> {
            return localVarFp.apiAppLocationTrailerLocationHistoryGet(name, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: any): AxiosPromise<LocationHistoryDto> {
            return localVarFp.apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerLocationsGet(options?: any): AxiosPromise<Array<TrailerGpsLocationDto>> {
            return localVarFp.apiAppTrailerLocationsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} [selectedCompanies] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationCurrentLocationsGet(selectedCompanies?: Array<number>, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationCurrentLocationsGet(selectedCompanies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLocationLiveTrackPostRequest} [apiAppLocationLiveTrackPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest?: ApiAppLocationLiveTrackPostRequest, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationLiveTrackPost(apiAppLocationLiveTrackPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationTrailerLocationHistoryGet(name?: string, date?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationTrailerLocationHistoryGet(name, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppLocationVehicleLocationHistoryGet(vehicleId?: number, date?: string, options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppLocationVehicleLocationHistoryGet(vehicleId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public apiAppTrailerLocationsGet(options?: AxiosRequestConfig) {
        return LocationApiFp(this.configuration).apiAppTrailerLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationHistoryVehiclesApi - axios parameter creator
 * @export
 */
export const LocationHistoryVehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdDelete', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdGet', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdPut: async (id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppLocationhistoryvehiclesIdPut', 'id', id)
            const localVarPath = `/api/app/locationhistoryvehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationhistoryvehiclesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesPost: async (apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppLocationhistoryvehiclesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/locationhistoryvehicles/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationHistoryVehiclesApi - functional programming interface
 * @export
 */
export const LocationHistoryVehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationHistoryVehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationHistoryVehicleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationHistoryVehicleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationHistoryVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationHistoryVehiclesApi - factory interface
 * @export
 */
export const LocationHistoryVehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationHistoryVehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<LocationHistoryVehicleDtoPagedResultDto> {
            return localVarFp.apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<LocationHistoryVehicleDtoPagedResultDto> {
            return localVarFp.apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<LocationHistoryVehicleDto>> {
            return localVarFp.apiAppLocationhistoryvehiclesGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<LocationHistoryVehicleDto>> {
            return localVarFp.apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppLocationhistoryvehiclesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdGet(id: number, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: any): AxiosPromise<LocationHistoryVehicleDto> {
            return localVarFp.apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationHistoryVehiclesApi - object-oriented interface
 * @export
 * @class LocationHistoryVehiclesApi
 * @extends {BaseAPI}
 */
export class LocationHistoryVehiclesApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdDelete(id: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdGet(id: number, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesIdPut(id: number, apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesIdPut(id, apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppLocationhistoryvehiclesGetRequest} [apiAppLocationhistoryvehiclesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest?: ApiAppLocationhistoryvehiclesGetRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesPost(apiAppLocationhistoryvehiclesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationHistoryVehiclesApi
     */
    public apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return LocationHistoryVehiclesApiFp(this.configuration).apiAppLocationhistoryvehiclesUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountCheckPasswordPost: async (apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/check-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: async (apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbpLoginResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbpLoginResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLoginPost(apiAccountLoginPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountLogoutGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountLogoutGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: any): AxiosPromise<AbpLoginResult> {
            return localVarFp.apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: any): AxiosPromise<AbpLoginResult> {
            return localVarFp.apiAccountLoginPost(apiAccountLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLogoutGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountLogoutGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountCheckPasswordPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountCheckPasswordPost(apiAccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountLoginPostRequest} [apiAccountLoginPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountLoginPost(apiAccountLoginPostRequest?: ApiAccountLoginPostRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountLoginPost(apiAccountLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public apiAccountLogoutGet(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).apiAccountLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaintenanceDashboardApi - axios parameter creator
 * @export
 */
export const MaintenanceDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivediagnosticerrorsGet: async (take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/activediagnosticerrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/activevehiclediagnosticerrors/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/dvirdefectsforvehicle/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardGeometriseventsGet: async (take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/geometrisevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardIdVehicleGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardIdVehicleGet', 'id', id)
            const localVarPath = `/api/app/maintenancedashboard/{id}/vehicle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardMaintenancedashboardconfigurationGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/maintenancedashboardconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost: async (apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/savemaintenancedashboardconfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardServiceremindersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/servicereminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTirestatusesVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardTirestatusesVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/maintenancedashboard/tirestatuses/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTotalactivevehiclesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/totalactivevehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardUnresolveddvirdefectsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/unresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet: async (eldDeviceId: number, take?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eldDeviceId' is not null or undefined
            assertParamExists('apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet', 'eldDeviceId', eldDeviceId)
            const localVarPath = `/api/app/maintenancedashboard/vehiclegeometrisevents/{eldDeviceId}`
                .replace(`{${"eldDeviceId"}}`, encodeURIComponent(String(eldDeviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesconditionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehiclescondition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesensorattributevaluesGet: async (id?: number, sensorAttributes?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehiclesensorattributevalues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (sensorAttributes) {
                localVarQueryParameter['SensorAttributes'] = sensorAttributes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithdiagnosticerrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithgeometrisalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithgeometrisalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithoverdueservicesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithoverdueservices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithtpmsalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithtpmsalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet: async (severity?: DvirFormAreaPointSeverity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithunresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithupcomingservicesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/maintenancedashboard/vehicleswithupcomingservices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceDashboardApi - functional programming interface
 * @export
 */
export const MaintenanceDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleWithDiagnosticRecords>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDiagnosticRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDvirDefectDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardGeometriseventsGet(take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardIdVehicleGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardIdVehicleGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceDashboardConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardServiceremindersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRemindersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardServiceremindersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AxleStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardTotalactivevehiclesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalVehiclesWidgetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardTotalactivevehiclesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnresolvedDvirDefectsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardUnresolveddvirdefectsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetVehicleEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclesconditionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehiclesConditionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclesconditionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: VehicleSensorAttributeValueDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaintenanceDashboardApi - factory interface
 * @export
 */
export const MaintenanceDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: any): AxiosPromise<Array<VehicleWithDiagnosticRecords>> {
            return localVarFp.apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDiagnosticRecord>> {
            return localVarFp.apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDvirDefectDto>> {
            return localVarFp.apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: any): AxiosPromise<Array<GeometrisWidgetEventDto>> {
            return localVarFp.apiAppMaintenancedashboardGeometriseventsGet(take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardIdVehicleGet(id: number, options?: any): AxiosPromise<MaintenanceDashboardVehicleDto> {
            return localVarFp.apiAppMaintenancedashboardIdVehicleGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: any): AxiosPromise<MaintenanceDashboardConfigurationDto> {
            return localVarFp.apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: any): AxiosPromise<MaintenanceDashboardConfigurationDto> {
            return localVarFp.apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardServiceremindersGet(options?: any): AxiosPromise<ServiceRemindersDto> {
            return localVarFp.apiAppMaintenancedashboardServiceremindersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<AxleStatusDto>> {
            return localVarFp.apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardTotalactivevehiclesGet(options?: any): AxiosPromise<TotalVehiclesWidgetDto> {
            return localVarFp.apiAppMaintenancedashboardTotalactivevehiclesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: any): AxiosPromise<UnresolvedDvirDefectsDto> {
            return localVarFp.apiAppMaintenancedashboardUnresolveddvirdefectsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} eldDeviceId 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: any): AxiosPromise<Array<GeometrisWidgetVehicleEventDto>> {
            return localVarFp.apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesconditionGet(options?: any): AxiosPromise<VehiclesConditionOutput> {
            return localVarFp.apiAppMaintenancedashboardVehiclesconditionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {Array<string>} [sensorAttributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: any): AxiosPromise<{ [key: string]: VehicleSensorAttributeValueDto; }> {
            return localVarFp.apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceDashboardApi - object-oriented interface
 * @export
 * @class MaintenanceDashboardApi
 * @extends {BaseAPI}
 */
export class MaintenanceDashboardApi extends BaseAPI {
    /**
     * 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardActivediagnosticerrorsGet(take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardActivediagnosticerrorsGet(take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardDvirdefectsforvehicleVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardGeometriseventsGet(take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardGeometriseventsGet(take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardIdVehicleGet(id: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardIdVehicleGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardMaintenancedashboardconfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest} [apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest?: ApiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPost(apiAppMaintenancedashboardSavemaintenancedashboardconfigurationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardServiceremindersGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardServiceremindersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardTirestatusesVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardTotalactivevehiclesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardTotalactivevehiclesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardUnresolveddvirdefectsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} eldDeviceId 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId: number, take?: number, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclegeometriseventsEldDeviceIdGet(eldDeviceId, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclesconditionGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclesconditionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {Array<string>} [sensorAttributes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id?: number, sensorAttributes?: Array<string>, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehiclesensorattributevaluesGet(id, sensorAttributes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithdiagnosticerrorsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithgeometrisalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithoverdueservicesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithtpmsalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DvirFormAreaPointSeverity} [severity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithunresolveddvirdefectsGet(severity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceDashboardApi
     */
    public apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options?: AxiosRequestConfig) {
        return MaintenanceDashboardApiFp(this.configuration).apiAppMaintenancedashboardVehicleswithupcomingservicesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEldDeviceApi - axios parameter creator
 * @export
 */
export const MasterEldDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceAssigntotenantPost: async (apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/assigntotenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceAssigntotenantPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdDelete', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdGet', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdPut: async (id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterelddeviceIdPut', 'id', id)
            const localVarPath = `/api/app/masterelddevice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceMultipleelddevicesPost: async (apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/multipleelddevices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceMultipleelddevicesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddevicePost: async (apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUnassignfromtenantsPost: async (apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/unassignfromtenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterelddeviceUnassignfromtenantsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUploadfilePost: async (file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddevice/uploadfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEldDeviceApi - functional programming interface
 * @export
 */
export const MasterEldDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEldDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterEldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterEldDeviceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterEldDeviceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceUploadfilePost(file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterUploadedFileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceUploadfilePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEldDeviceApi - factory interface
 * @export
 */
export const MasterEldDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEldDeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterelddeviceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MasterEldDeviceDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MasterEldDeviceListDtoPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MasterEldDeviceListDto>> {
            return localVarFp.apiAppMasterelddeviceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MasterEldDeviceListDto>> {
            return localVarFp.apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdGet(id: number, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: any): AxiosPromise<MasterEldDeviceDto> {
            return localVarFp.apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceUploadfilePost(file?: any, options?: any): AxiosPromise<MasterUploadedFileDto> {
            return localVarFp.apiAppMasterelddeviceUploadfilePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEldDeviceApi - object-oriented interface
 * @export
 * @class MasterEldDeviceApi
 * @extends {BaseAPI}
 */
export class MasterEldDeviceApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppMasterelddeviceAssigntotenantPostRequest} [apiAppMasterelddeviceAssigntotenantPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest?: ApiAppMasterelddeviceAssigntotenantPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceAssigntotenantPost(apiAppMasterelddeviceAssigntotenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdDelete(id: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMasterelddeviceIdDeleteRequest} [apiAppMasterelddeviceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceIdPut(id: number, apiAppMasterelddeviceIdDeleteRequest?: ApiAppMasterelddeviceIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceIdPut(id, apiAppMasterelddeviceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceMultipleelddevicesPostRequest} [apiAppMasterelddeviceMultipleelddevicesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest?: ApiAppMasterelddeviceMultipleelddevicesPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceMultipleelddevicesPost(apiAppMasterelddeviceMultipleelddevicesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceGetRequest} [apiAppMasterelddeviceGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest?: ApiAppMasterelddeviceGetRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddevicePost(apiAppMasterelddeviceGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterelddeviceUnassignfromtenantsPostRequest} [apiAppMasterelddeviceUnassignfromtenantsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest?: ApiAppMasterelddeviceUnassignfromtenantsPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUnassignfromtenantsPost(apiAppMasterelddeviceUnassignfromtenantsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceApi
     */
    public apiAppMasterelddeviceUploadfilePost(file?: any, options?: AxiosRequestConfig) {
        return MasterEldDeviceApiFp(this.configuration).apiAppMasterelddeviceUploadfilePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEldDeviceUsageApi - axios parameter creator
 * @export
 */
export const MasterEldDeviceUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageElddeviceusageTenantIdGet: async (tenantId: string, dateFrom?: string, dateTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppMasterelddeviceusageElddeviceusageTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/masterelddeviceusage/elddeviceusage/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageSingleelddeviceusageGet: async (serialNumber?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterelddeviceusage/singleelddeviceusage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEldDeviceUsageApi - functional programming interface
 * @export
 */
export const MasterEldDeviceUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEldDeviceUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceUsageSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceUsageOutputPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SingleDeviceUsageDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEldDeviceUsageApi - factory interface
 * @export
 */
export const MasterEldDeviceUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEldDeviceUsageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<DeviceUsageSummary> {
            return localVarFp.apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<DeviceUsageOutputPagedResultDto> {
            return localVarFp.apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: any): AxiosPromise<Array<SingleDeviceUsageDetail>> {
            return localVarFp.apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEldDeviceUsageApi - object-oriented interface
 * @export
 * @class MasterEldDeviceUsageApi
 * @extends {BaseAPI}
 */
export class MasterEldDeviceUsageApi extends BaseAPI {
    /**
     * 
     * @param {string} tenantId 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId: string, dateFrom?: string, dateTo?: string, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageElddeviceusageTenantIdGet(tenantId, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEldDeviceUsageApi
     */
    public apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber?: string, options?: AxiosRequestConfig) {
        return MasterEldDeviceUsageApiFp(this.configuration).apiAppMasterelddeviceusageSingleelddeviceusageGet(serialNumber, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterEventApi - axios parameter creator
 * @export
 */
export const MasterEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventBestcoordinatesbygeolocationGet: async (geolocation?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterevent/bestcoordinatesbygeolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (geolocation !== undefined) {
                localVarQueryParameter['geolocation'] = geolocation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMastereventIdGet', 'id', id)
            const localVarPath = `/api/app/masterevent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdPut: async (id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMastereventIdPut', 'id', id)
            const localVarPath = `/api/app/masterevent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMastereventIdGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastengineonDriverIdGet: async (driverId: number, time?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppMastereventLastengineonDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/masterevent/lastengineon/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPost: async (apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterevent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMastereventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPreviouseventDriverIdGet: async (driverId: number, startTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('apiAppMastereventPreviouseventDriverIdGet', 'driverId', driverId)
            const localVarPath = `/api/app/masterevent/previousevent/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterEventApi - functional programming interface
 * @export
 */
export const MasterEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BestGeolocationCoordinatesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventLastengineonDriverIdGet(driverId, time, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventPost(apiAppMastereventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMasterEventInput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterEventApi - factory interface
 * @export
 */
export const MasterEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterEventApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [geolocation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: any): AxiosPromise<BestGeolocationCoordinatesOutput> {
            return localVarFp.apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdGet(id: number, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventLastengineonDriverIdGet(driverId, time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventPost(apiAppMastereventPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} driverId 
         * @param {string} [startTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: any): AxiosPromise<UpdateMasterEventInput> {
            return localVarFp.apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterEventApi - object-oriented interface
 * @export
 * @class MasterEventApi
 * @extends {BaseAPI}
 */
export class MasterEventApi extends BaseAPI {
    /**
     * 
     * @param {string} [geolocation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventBestcoordinatesbygeolocationGet(geolocation?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventBestcoordinatesbygeolocationGet(geolocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMastereventIdGetRequest} [apiAppMastereventIdGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventIdPut(id: number, apiAppMastereventIdGetRequest?: ApiAppMastereventIdGetRequest, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventIdPut(id, apiAppMastereventIdGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {string} [time] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventLastengineonDriverIdGet(driverId: number, time?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventLastengineonDriverIdGet(driverId, time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMastereventPostRequest} [apiAppMastereventPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventPost(apiAppMastereventPostRequest?: ApiAppMastereventPostRequest, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventPost(apiAppMastereventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} driverId 
     * @param {string} [startTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterEventApi
     */
    public apiAppMastereventPreviouseventDriverIdGet(driverId: number, startTime?: string, options?: AxiosRequestConfig) {
        return MasterEventApiFp(this.configuration).apiAppMastereventPreviouseventDriverIdGet(driverId, startTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterFleetManagerApi - axios parameter creator
 * @export
 */
export const MasterFleetManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdDelete', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdGet', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdPut: async (id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdPut', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdRequestpasswordresetPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMasterfleetmanagerIdRequestpasswordresetPost', 'id', id)
            const localVarPath = `/api/app/masterfleetmanager/{id}/requestpasswordreset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerPost: async (apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerRequestpasswordresetbyemailPost: async (email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/requestpasswordresetbyemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResetpasswordPost: async (apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/resetpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerResetpasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResettwofactorauthenticationPost: async (apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/resettwofactorauthentication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerWithtokenPost: async (apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/masterfleetmanager/withtoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMasterfleetmanagerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterFleetManagerApi - functional programming interface
 * @export
 */
export const MasterFleetManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterFleetManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterFleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterFleetManagerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterFleetManagerCreateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterFleetManagerApi - factory interface
 * @export
 */
export const MasterFleetManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterFleetManagerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterfleetmanagerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MasterFleetManagerDtoPagedResultDto> {
            return localVarFp.apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MasterFleetManagerListDtoPagedResultDto> {
            return localVarFp.apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MasterFleetManagerListDto>> {
            return localVarFp.apiAppMasterfleetmanagerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MasterFleetManagerListDto>> {
            return localVarFp.apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdGet(id: number, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: any): AxiosPromise<MasterFleetManagerDto> {
            return localVarFp.apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: any): AxiosPromise<IdentityResult> {
            return localVarFp.apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: any): AxiosPromise<MasterFleetManagerCreateResult> {
            return localVarFp.apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterFleetManagerApi - object-oriented interface
 * @export
 * @class MasterFleetManagerApi
 * @extends {BaseAPI}
 */
export class MasterFleetManagerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdDelete(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdGet(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMasterfleetmanagerIdDeleteRequest} [apiAppMasterfleetmanagerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdPut(id: number, apiAppMasterfleetmanagerIdDeleteRequest?: ApiAppMasterfleetmanagerIdDeleteRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdPut(id, apiAppMasterfleetmanagerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerIdRequestpasswordresetPost(id: number, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerIdRequestpasswordresetPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email?: string, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerRequestpasswordresetbyemailPost(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerResetpasswordPostRequest} [apiAppMasterfleetmanagerResetpasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest?: ApiAppMasterfleetmanagerResetpasswordPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerResetpasswordPost(apiAppMasterfleetmanagerResetpasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest} [apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest?: ApiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerResettwofactorauthenticationPost(apiAppMasterfleetmanagerResettwofactorauthenticationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppMasterfleetmanagerGetRequest} [apiAppMasterfleetmanagerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterFleetManagerApi
     */
    public apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest?: ApiAppMasterfleetmanagerGetRequest, options?: AxiosRequestConfig) {
        return MasterFleetManagerApiFp(this.configuration).apiAppMasterfleetmanagerWithtokenPost(apiAppMasterfleetmanagerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobileAppVersionApi - axios parameter creator
 * @export
 */
export const MobileAppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdDelete', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdGet', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdPut: async (id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppMobileappversionIdPut', 'id', id)
            const localVarPath = `/api/app/mobileappversion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMobileappversionIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionPost: async (mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileApplicationTypeString' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'mobileApplicationTypeString', mobileApplicationTypeString)
            // verify required parameter 'appVersion' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'appVersion', appVersion)
            // verify required parameter 'buildNumber' is not null or undefined
            assertParamExists('apiAppMobileappversionPost', 'buildNumber', buildNumber)
            const localVarPath = `/api/app/mobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (mobileApplicationTypeString !== undefined) { 
                localVarFormParams.append('MobileApplicationTypeString', mobileApplicationTypeString as any);
            }
    
            if (mobileApplicationType !== undefined) { 
                localVarFormParams.append('MobileApplicationType', new Blob([JSON.stringify(mobileApplicationType)], { type: "application/json", }));
            }
    
            if (appVersion !== undefined) { 
                localVarFormParams.append('AppVersion', appVersion as any);
            }
    
            if (buildNumber !== undefined) { 
                localVarFormParams.append('BuildNumber', buildNumber as any);
            }
    
            if (downloadUrl !== undefined) { 
                localVarFormParams.append('DownloadUrl', downloadUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobileappversion/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileAppVersionApi - functional programming interface
 * @export
 */
export const MobileAppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileAppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MobileAppVersionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MobileAppVersionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileAppVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileAppVersionApi - factory interface
 * @export
 */
export const MobileAppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileAppVersionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMobileappversionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<MobileAppVersionDtoPagedResultDto> {
            return localVarFp.apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<MobileAppVersionDtoPagedResultDto> {
            return localVarFp.apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<MobileAppVersionDto>> {
            return localVarFp.apiAppMobileappversionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<MobileAppVersionDto>> {
            return localVarFp.apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppMobileappversionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdGet(id: number, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mobileApplicationTypeString 
         * @param {string} appVersion 
         * @param {number} buildNumber 
         * @param {any} [file] 
         * @param {MobileApplicationType} [mobileApplicationType] 
         * @param {string} [downloadUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: any): AxiosPromise<MobileAppVersionDto> {
            return localVarFp.apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileAppVersionApi - object-oriented interface
 * @export
 * @class MobileAppVersionApi
 * @extends {BaseAPI}
 */
export class MobileAppVersionApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdDelete(id: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdGet(id: number, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppMobileappversionIdDeleteRequest} [apiAppMobileappversionIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionIdPut(id: number, apiAppMobileappversionIdDeleteRequest?: ApiAppMobileappversionIdDeleteRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionIdPut(id, apiAppMobileappversionIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mobileApplicationTypeString 
     * @param {string} appVersion 
     * @param {number} buildNumber 
     * @param {any} [file] 
     * @param {MobileApplicationType} [mobileApplicationType] 
     * @param {string} [downloadUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionPost(mobileApplicationTypeString: string, appVersion: string, buildNumber: number, file?: any, mobileApplicationType?: MobileApplicationType, downloadUrl?: string, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionPost(mobileApplicationTypeString, appVersion, buildNumber, file, mobileApplicationType, downloadUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileAppVersionApi
     */
    public apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return MobileAppVersionApiFp(this.configuration).apiAppMobileappversionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobileTrailerApi - axios parameter creator
 * @export
 */
export const MobileTrailerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerPost: async (apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobiletrailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppMobiletrailerPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/mobiletrailer/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileTrailerApi - functional programming interface
 * @export
 */
export const MobileTrailerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileTrailerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileCreateTrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppMobiletrailerSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileTrailerApi - factory interface
 * @export
 */
export const MobileTrailerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileTrailerApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: any): AxiosPromise<MobileCreateTrailerDto> {
            return localVarFp.apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<TrailerSyncDto>> {
            return localVarFp.apiAppMobiletrailerSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileTrailerApi - object-oriented interface
 * @export
 * @class MobileTrailerApi
 * @extends {BaseAPI}
 */
export class MobileTrailerApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppMobiletrailerPostRequest} [apiAppMobiletrailerPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileTrailerApi
     */
    public apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest?: ApiAppMobiletrailerPostRequest, options?: AxiosRequestConfig) {
        return MobileTrailerApiFp(this.configuration).apiAppMobiletrailerPost(apiAppMobiletrailerPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileTrailerApi
     */
    public apiAppMobiletrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return MobileTrailerApiFp(this.configuration).apiAppMobiletrailerSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationNotificationtypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notification/notificationtypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationNotificationtypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationNotificationtypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationNotificationtypesGet(options?: any): AxiosPromise<Array<NotificationTypeDto>> {
            return localVarFp.apiAppNotificationNotificationtypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public apiAppNotificationNotificationtypesGet(options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).apiAppNotificationNotificationtypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationCenterApi - axios parameter creator
 * @export
 */
export const NotificationCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterGetallnotificationsPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/getallnotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterNotificationsforuserGet: async (userId: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterNotificationsforuserGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/notificationsforuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavenotificationpreferencePost: async (apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/savenotificationpreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSavenotificationpreferencePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavesingleusernotificationpreferencePost: async (apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/savesingleusernotificationpreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSaveuserlastreadnotificationPost: async (apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationcenter/saveuserlastreadnotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUnreadnotificationnumberUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterUnreadnotificationnumberUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/unreadnotificationnumber/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUsernotificationpreferenceUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppNotificationcenterUsernotificationpreferenceUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/notificationcenter/usernotificationpreference/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationCenterApi - functional programming interface
 * @export
 */
export const NotificationCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSystemNotificationsDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemNotificationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationPreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationCenterApi - factory interface
 * @export
 */
export const NotificationCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<GetSystemNotificationsDtoPagedResultDto> {
            return localVarFp.apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<SystemNotificationResultDto> {
            return localVarFp.apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: any): AxiosPromise<UserNotificationPreferenceDto> {
            return localVarFp.apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationCenterApi - object-oriented interface
 * @export
 * @class NotificationCenterApi
 * @extends {BaseAPI}
 */
export class NotificationCenterApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterGetallnotificationsPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterNotificationsforuserGet(userId: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterNotificationsforuserGet(userId, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSavenotificationpreferencePostRequest} [apiAppNotificationcenterSavenotificationpreferencePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest?: ApiAppNotificationcenterSavenotificationpreferencePostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSavenotificationpreferencePost(apiAppNotificationcenterSavenotificationpreferencePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest} [apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest?: ApiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSavesingleusernotificationpreferencePost(apiAppNotificationcenterSavesingleusernotificationpreferencePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest} [apiAppNotificationcenterSaveuserlastreadnotificationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest?: ApiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterSaveuserlastreadnotificationPost(apiAppNotificationcenterSaveuserlastreadnotificationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterUnreadnotificationnumberUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationCenterApi
     */
    public apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return NotificationCenterApiFp(this.configuration).apiAppNotificationcenterUsernotificationpreferenceUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationSubscriptionApi - axios parameter creator
 * @export
 */
export const NotificationSubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdDelete', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdGet', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdPut: async (id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppNotificationsubscriptionIdPut', 'id', id)
            const localVarPath = `/api/app/notificationsubscription/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationsubscriptionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionPost: async (apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppNotificationsubscriptionGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/notificationsubscription/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationSubscriptionApi - functional programming interface
 * @export
 */
export const NotificationSubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationSubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationSubscriptionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationSubscriptionListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSubscriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationSubscriptionApi - factory interface
 * @export
 */
export const NotificationSubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationSubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppNotificationsubscriptionDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<NotificationSubscriptionDtoPagedResultDto> {
            return localVarFp.apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<NotificationSubscriptionListDtoPagedResultDto> {
            return localVarFp.apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<NotificationSubscriptionListDto>> {
            return localVarFp.apiAppNotificationsubscriptionGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<NotificationSubscriptionListDto>> {
            return localVarFp.apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppNotificationsubscriptionIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdGet(id: number, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: any): AxiosPromise<NotificationSubscriptionDto> {
            return localVarFp.apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationSubscriptionApi - object-oriented interface
 * @export
 * @class NotificationSubscriptionApi
 * @extends {BaseAPI}
 */
export class NotificationSubscriptionApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdDelete(id: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdGet(id: number, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionIdPut(id: number, apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionIdPut(id, apiAppNotificationsubscriptionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppNotificationsubscriptionGetRequest} [apiAppNotificationsubscriptionGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest?: ApiAppNotificationsubscriptionGetRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionPost(apiAppNotificationsubscriptionGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationSubscriptionApi
     */
    public apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return NotificationSubscriptionApiFp(this.configuration).apiAppNotificationsubscriptionUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet: async (providerName?: string, providerKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut: async (providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permission-management/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (providerName !== undefined) {
                localVarQueryParameter['providerName'] = providerName;
            }

            if (providerKey !== undefined) {
                localVarQueryParameter['providerKey'] = providerKey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiPermissionManagementPermissionsGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPermissionListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsGet(providerName, providerKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: any): AxiosPromise<GetPermissionListResultDto> {
            return localVarFp.apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [providerName] 
         * @param {string} [providerKey] 
         * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsGet(providerName?: string, providerKey?: string, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsGet(providerName, providerKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [providerName] 
     * @param {string} [providerKey] 
     * @param {ApiPermissionManagementPermissionsGetRequest} [apiPermissionManagementPermissionsGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public apiPermissionManagementPermissionsPut(providerName?: string, providerKey?: string, apiPermissionManagementPermissionsGetRequest?: ApiPermissionManagementPermissionsGetRequest, options?: AxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).apiPermissionManagementPermissionsPut(providerName, providerKey, apiPermissionManagementPermissionsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProLogsIdentityRoleApi - axios parameter creator
 * @export
 */
export const ProLogsIdentityRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdDelete', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdGet', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdPut: async (id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPrologsidentityroleIdPut', 'id', id)
            const localVarPath = `/api/app/prologsidentityrole/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityrolePost: async (apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/prologsidentityrole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProLogsIdentityRoleApi - functional programming interface
 * @export
 */
export const ProLogsIdentityRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProLogsIdentityRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityroleListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityroleListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProLogsIdentityRoleApi - factory interface
 * @export
 */
export const ProLogsIdentityRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProLogsIdentityRoleApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityRoleDtoPagedResultDto> {
            return localVarFp.apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPrologsidentityroleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdGet(id: string, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityroleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityroleListGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiAppPrologsidentityroleListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProLogsIdentityRoleApi - object-oriented interface
 * @export
 * @class ProLogsIdentityRoleApi
 * @extends {BaseAPI}
 */
export class ProLogsIdentityRoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdDelete(id: string, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdGet(id: string, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityroleListGet(options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityroleListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProLogsIdentityRoleApi
     */
    public apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig) {
        return ProLogsIdentityRoleApiFp(this.configuration).apiAppPrologsidentityrolePost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileChangePasswordPost: async (apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountMyProfileChangePasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfilePut: async (apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account/my-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAccountMyProfileGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfileGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfileGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfileGet(options?: any): AxiosPromise<ProfileDto> {
            return localVarFp.apiAccountMyProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: any): AxiosPromise<ProfileDto> {
            return localVarFp.apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @param {ApiAccountMyProfileChangePasswordPostRequest} [apiAccountMyProfileChangePasswordPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest?: ApiAccountMyProfileChangePasswordPostRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfileChangePasswordPost(apiAccountMyProfileChangePasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfileGet(options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAccountMyProfileGetRequest} [apiAccountMyProfileGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiAccountMyProfilePut(apiAccountMyProfileGetRequest?: ApiAccountMyProfileGetRequest, options?: AxiosRequestConfig) {
        return ProfileApiFp(this.configuration).apiAccountMyProfilePut(apiAccountMyProfileGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicApiClientApi - axios parameter creator
 * @export
 */
export const PublicApiClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdDelete', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdGet', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdPut: async (id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppPublicapiclientIdPut', 'id', id)
            const localVarPath = `/api/app/publicapiclient/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientPost: async (apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPublicapiclientGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/publicapiclient/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiClientApi - functional programming interface
 * @export
 */
export const PublicApiClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicApiClientApi - factory interface
 * @export
 */
export const PublicApiClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiClientApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiclientDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ApiClientDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ApiClientDtoPagedResultDto> {
            return localVarFp.apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<ApiClientDto>> {
            return localVarFp.apiAppPublicapiclientGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ApiClientDto>> {
            return localVarFp.apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppPublicapiclientIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdGet(id: string, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: any): AxiosPromise<ApiClientDto> {
            return localVarFp.apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApiClientApi - object-oriented interface
 * @export
 * @class PublicApiClientApi
 * @extends {BaseAPI}
 */
export class PublicApiClientApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdDelete(id: string, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdGet(id: string, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientIdPut(id: string, apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientIdPut(id, apiAppPublicapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPublicapiclientGetRequest} [apiAppPublicapiclientGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest?: ApiAppPublicapiclientGetRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientPost(apiAppPublicapiclientGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiClientApi
     */
    public apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return PublicApiClientApiFp(this.configuration).apiAppPublicapiclientUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RecentViolationApi - axios parameter creator
 * @export
 */
export const RecentViolationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRecentviolationGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/recentviolation/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecentViolationApi - functional programming interface
 * @export
 */
export const RecentViolationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecentViolationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentViolationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecentViolationApi - factory interface
 * @export
 */
export const RecentViolationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecentViolationApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<RecentViolationDtoPagedResultDto> {
            return localVarFp.apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecentViolationApi - object-oriented interface
 * @export
 * @class RecentViolationApi
 * @extends {BaseAPI}
 */
export class RecentViolationApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecentViolationApi
     */
    public apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RecentViolationApiFp(this.configuration).apiAppRecentviolationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportApiApi - axios parameter creator
 * @export
 */
export const ReportApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogreportPost: async (reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dailylogreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDailylogreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogsreportPost: async (reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dailylogsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDailylogsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDvirinspectionsreportPost: async (reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/dvirinspectionsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportDvirinspectionsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportEldeventsreportPost: async (reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/eldeventsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportEldeventsreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/iftamileagereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftasummaryreportPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/iftasummaryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLocationhistoryreportPost: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/locationhistoryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTestreportGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/testreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripdetailPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/tripdetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripreportdetailPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/tripreportdetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereport2Post: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicledistancereport2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereportPost: async (reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicledistancereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicledistancereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicleinactivityreportPost: async (reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehicleinactivityreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehicleinactivityreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagereportPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehiclemileagereport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagesummaryreportPost: async (reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/report/vehiclemileagesummaryreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportVehiclemileagesummaryreportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApiApi - functional programming interface
 * @export
 */
export const ReportApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDailylogreportPost(reportDailylogreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDailylogsreportPost(reportDailylogsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportEldeventsreportPost(reportEldeventsreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIftamileagereportPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIftasummaryreportPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTestreportGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTestreportGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTripdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTripdetailPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTripreportdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTripreportdetailPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportApiApi - factory interface
 * @export
 */
export const ReportApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDailylogreportPost(reportDailylogreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDailylogsreportPost(reportDailylogsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportEldeventsreportPost(reportEldeventsreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportIftamileagereportPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportIftasummaryreportPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTestreportGet(options?: any): AxiosPromise<void> {
            return localVarFp.reportTestreportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportTripdetailPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTripreportdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportTripreportdetailPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: any): AxiosPromise<string> {
            return localVarFp.reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApiApi - object-oriented interface
 * @export
 * @class ReportApiApi
 * @extends {BaseAPI}
 */
export class ReportApiApi extends BaseAPI {
    /**
     * 
     * @param {ReportDailylogreportPostRequest} [reportDailylogreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDailylogreportPost(reportDailylogreportPostRequest?: ReportDailylogreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDailylogreportPost(reportDailylogreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportDailylogsreportPostRequest} [reportDailylogsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDailylogsreportPost(reportDailylogsreportPostRequest?: ReportDailylogsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDailylogsreportPost(reportDailylogsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportDvirinspectionsreportPostRequest} [reportDvirinspectionsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest?: ReportDvirinspectionsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportDvirinspectionsreportPost(reportDvirinspectionsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportEldeventsreportPostRequest} [reportEldeventsreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportEldeventsreportPost(reportEldeventsreportPostRequest?: ReportEldeventsreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportEldeventsreportPost(reportEldeventsreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportIftamileagereportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportIftamileagereportPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportIftasummaryreportPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportIftasummaryreportPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportLocationhistoryreportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportLocationhistoryreportPost(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTestreportGet(options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTestreportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTripdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTripdetailPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportTripreportdetailPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportTripreportdetailPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicledistancereport2Post(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicledistancereport2Post(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicledistancereportPostRequest} [reportVehicledistancereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicledistancereportPost(reportVehicledistancereportPostRequest?: ReportVehicledistancereportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicledistancereportPost(reportVehicledistancereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehicleinactivityreportPostRequest} [reportVehicleinactivityreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest?: ReportVehicleinactivityreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehicleinactivityreportPost(reportVehicleinactivityreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehiclemileagereportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportVehiclemileagesummaryreportPostRequest} [reportVehiclemileagesummaryreportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApiApi
     */
    public reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest?: ReportVehiclemileagesummaryreportPostRequest, options?: AxiosRequestConfig) {
        return ReportApiApiFp(this.configuration).reportVehiclemileagesummaryreportPost(reportVehiclemileagesummaryreportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportArchiveApi - axios parameter creator
 * @export
 */
export const ReportArchiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportarchive/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppReportarchiveIdGet', 'id', id)
            const localVarPath = `/api/app/reportarchive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportArchiveApi - functional programming interface
 * @export
 */
export const ReportArchiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportArchiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportarchiveIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportarchiveIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportArchiveApi - factory interface
 * @export
 */
export const ReportArchiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportArchiveApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<ReportDtoPagedResultDto> {
            return localVarFp.apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<ReportDtoPagedResultDto> {
            return localVarFp.apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<ReportDto>> {
            return localVarFp.apiAppReportarchiveGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<ReportDto>> {
            return localVarFp.apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportarchiveIdGet(id: string, options?: any): AxiosPromise<ReportDto> {
            return localVarFp.apiAppReportarchiveIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportArchiveApi - object-oriented interface
 * @export
 * @class ReportArchiveApi
 * @extends {BaseAPI}
 */
export class ReportArchiveApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportArchiveApi
     */
    public apiAppReportarchiveIdGet(id: string, options?: AxiosRequestConfig) {
        return ReportArchiveApiFp(this.configuration).apiAppReportarchiveIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportViewApi - axios parameter creator
 * @export
 */
export const ReportViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetmastertripdetaildataPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getmastertripdetaildata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetmastertripreportdetaildataPost: async (reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getmastertripreportdetaildata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIftamileagereportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost: async (apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagebystatesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewPost: async (apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost: async (apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclemileagesummaryreportviewbyvehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclestatemileagesummaryreportviewPost: async (apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/getvehiclestatemileagesummaryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewVehiclelocationhistoryreportviewGet: async (vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/reportview/vehiclelocationhistoryreportview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['TimeFrom'] = (timeFrom as any instanceof Date) ?
                    (timeFrom as any).toISOString() :
                    timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['TimeTo'] = (timeTo as any instanceof Date) ?
                    (timeTo as any).toISOString() :
                    timeTo;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportViewApi - functional programming interface
 * @export
 */
export const ReportViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripReportDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageByStateSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMileageSummaryReportEntryListByVehicleResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleStateMileageSummaryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleLocationHistoryReportEntryListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportViewApi - factory interface
 * @export
 */
export const ReportViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportViewApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<TripDetailData> {
            return localVarFp.apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: any): AxiosPromise<TripReportDetailData> {
            return localVarFp.apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageByStateSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleMileageSummaryReportEntryListByVehicleResultDto> {
            return localVarFp.apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: any): AxiosPromise<VehicleStateMileageSummaryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [vehicleId] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleLocationHistoryReportEntryListResultDto> {
            return localVarFp.apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportViewApi - object-oriented interface
 * @export
 * @class ReportViewApi
 * @extends {BaseAPI}
 */
export class ReportViewApi extends BaseAPI {
    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetmastertripdetaildataPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportIftamileagereportPostRequest} [reportIftamileagereportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest?: ReportIftamileagereportPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetmastertripreportdetaildataPost(reportIftamileagereportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagebystatesummaryreportviewPost(apiAppReportviewGetvehiclemileagebystatesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagesummaryreportviewPost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclemileagesummaryreportviewbyvehiclePost(apiAppReportviewGetvehiclemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest} [apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest?: ApiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewGetvehiclestatemileagesummaryreportviewPost(apiAppReportviewGetvehiclestatemileagesummaryreportviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [vehicleId] 
     * @param {string} [timeFrom] 
     * @param {string} [timeTo] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportViewApi
     */
    public apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId?: number, timeFrom?: string, timeTo?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return ReportViewApiFp(this.configuration).apiAppReportviewVehiclelocationhistoryreportviewGet(vehicleId, timeFrom, timeTo, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdDelete', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdGet', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdPut: async (id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppRoleIdPut', 'id', id)
            const localVarPath = `/api/app/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppRoleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRolePost: async (apiAppRoleGetRequest?: ApiAppRoleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppRoleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/role/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesAllGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdDelete', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdGet', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdPut: async (id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityRolesIdPut', 'id', id)
            const localVarPath = `/api/identity/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesPost: async (apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppPrologsidentityroleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRolePost(apiAppRoleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesAllGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppRoleDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppRoleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<RoleDtoPagedResultDto> {
            return localVarFp.apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<RoleListDtoPagedResultDto> {
            return localVarFp.apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<RoleListDto>> {
            return localVarFp.apiAppRoleGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<RoleListDto>> {
            return localVarFp.apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppRoleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdGet(id: string, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: any): AxiosPromise<RoleDto> {
            return localVarFp.apiAppRolePost(apiAppRoleGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesAllGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityRolesAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityRoleDtoPagedResultDto> {
            return localVarFp.apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityRolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdGet(id: string, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: any): AxiosPromise<IdentityRoleDto> {
            return localVarFp.apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdDelete(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdGet(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppRoleIdDeleteRequest} [apiAppRoleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleIdPut(id: string, apiAppRoleIdDeleteRequest?: ApiAppRoleIdDeleteRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleIdPut(id, apiAppRoleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppRoleGetRequest} [apiAppRoleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRolePost(apiAppRoleGetRequest?: ApiAppRoleGetRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRolePost(apiAppRoleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiAppRoleUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesAllGet(options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdDelete(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdGet(id: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppPrologsidentityroleIdDeleteRequest} [apiAppPrologsidentityroleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesIdPut(id: string, apiAppPrologsidentityroleIdDeleteRequest?: ApiAppPrologsidentityroleIdDeleteRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesIdPut(id, apiAppPrologsidentityroleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppPrologsidentityroleGetRequest} [apiAppPrologsidentityroleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest?: ApiAppPrologsidentityroleGetRequest, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).apiIdentityRolesPost(apiAppPrologsidentityroleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyAlertsApi - axios parameter creator
 * @export
 */
export const SafetyAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetyalertsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetyalerts/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyAlertsApi - functional programming interface
 * @export
 */
export const SafetyAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyAlertListDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyAlertsApi - factory interface
 * @export
 */
export const SafetyAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyAlertsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<SafetyAlertListDtoListResultDto> {
            return localVarFp.apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyAlertsApi - object-oriented interface
 * @export
 * @class SafetyAlertsApi
 * @extends {BaseAPI}
 */
export class SafetyAlertsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAlertsApi
     */
    public apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return SafetyAlertsApiFp(this.configuration).apiAppSafetyalertsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyDashboardApi - axios parameter creator
 * @export
 */
export const SafetyDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverscoresGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverscores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithgeometrisalertsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithgeometrisalerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshaccelerationeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshaccelerationevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshbrakingeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshbrakingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshturneventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithharshturnevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithimpacteventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithimpactevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithphysicalelddisconnections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithspeedingeventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithspeedingevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithunresolveddvirdefectsGet: async (severity?: DvirFormAreaPointSeverity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/driverswithunresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardGeometriseventsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/geometrisevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardHarsheventsbreakdownGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/harsheventsbreakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdDriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdDriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/driver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdGeometriseventsfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdGeometriseventsfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/geometriseventsfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/harsheventsbreakdownfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdSpeedingeventsfordriverGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppSafetydashboardIdSpeedingeventsfordriverGet', 'id', id)
            const localVarPath = `/api/app/safetydashboard/{id}/speedingeventsfordriver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardSpeedingeventssummaryGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/speedingeventssummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardTotalactivedriversGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/totalactivedrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardUnresolveddvirdefectsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/safetydashboard/unresolveddvirdefects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyDashboardApi - functional programming interface
 * @export
 */
export const SafetyDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverscoresGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverScoresOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverscoresGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithgeometrisalertsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshbrakingeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithharshturneventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithharshturneventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithimpacteventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithimpacteventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithspeedingeventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithspeedingeventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Int32CommonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardGeometriseventsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetDriverEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardGeometriseventsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardHarsheventsbreakdownGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarshEventsBreakdownDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardHarsheventsbreakdownGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdDriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyDashboardDriverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdDriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeometrisWidgetVehicleEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverHarshEventsBreakdownDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverSpeedingEventDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardSpeedingeventssummaryGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverSpeedingEventsSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardSpeedingeventssummaryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardTotalactivedriversGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalDriversWidgetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardTotalactivedriversGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppSafetydashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnresolvedDvirDefectsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppSafetydashboardUnresolveddvirdefectsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyDashboardApi - factory interface
 * @export
 */
export const SafetyDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverscoresGet(options?: any): AxiosPromise<DriverScoresOutput> {
            return localVarFp.apiAppSafetydashboardDriverscoresGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithgeometrisalertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshbrakingeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithharshturneventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithharshturneventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithimpacteventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithimpacteventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithspeedingeventsGet(options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithspeedingeventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DvirFormAreaPointSeverity} [severity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: any): AxiosPromise<Array<Int32CommonDto>> {
            return localVarFp.apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardGeometriseventsGet(options?: any): AxiosPromise<Array<GeometrisWidgetDriverEventDto>> {
            return localVarFp.apiAppSafetydashboardGeometriseventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardHarsheventsbreakdownGet(options?: any): AxiosPromise<HarshEventsBreakdownDto> {
            return localVarFp.apiAppSafetydashboardHarsheventsbreakdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdDriverGet(id: number, options?: any): AxiosPromise<SafetyDashboardDriverDto> {
            return localVarFp.apiAppSafetydashboardIdDriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: any): AxiosPromise<Array<GeometrisWidgetVehicleEventDto>> {
            return localVarFp.apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: any): AxiosPromise<DriverHarshEventsBreakdownDto> {
            return localVarFp.apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: any): AxiosPromise<Array<DriverSpeedingEventDetailsDto>> {
            return localVarFp.apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardSpeedingeventssummaryGet(options?: any): AxiosPromise<Array<DriverSpeedingEventsSummaryDto>> {
            return localVarFp.apiAppSafetydashboardSpeedingeventssummaryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardTotalactivedriversGet(options?: any): AxiosPromise<TotalDriversWidgetDto> {
            return localVarFp.apiAppSafetydashboardTotalactivedriversGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppSafetydashboardUnresolveddvirdefectsGet(options?: any): AxiosPromise<UnresolvedDvirDefectsDto> {
            return localVarFp.apiAppSafetydashboardUnresolveddvirdefectsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyDashboardApi - object-oriented interface
 * @export
 * @class SafetyDashboardApi
 * @extends {BaseAPI}
 */
export class SafetyDashboardApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverscoresGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverscoresGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithgeometrisalertsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithgeometrisalertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshaccelerationeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshbrakingeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshbrakingeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithharshturneventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithharshturneventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithimpacteventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithimpacteventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithphysicalelddisconnectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithspeedingeventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithspeedingeventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DvirFormAreaPointSeverity} [severity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity?: DvirFormAreaPointSeverity, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardDriverswithunresolveddvirdefectsGet(severity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardGeometriseventsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardGeometriseventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardHarsheventsbreakdownGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardHarsheventsbreakdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdDriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdDriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdGeometriseventsfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdGeometriseventsfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdHarsheventsbreakdownfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardIdSpeedingeventsfordriverGet(id: number, options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardIdSpeedingeventsfordriverGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardSpeedingeventssummaryGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardSpeedingeventssummaryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardTotalactivedriversGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardTotalactivedriversGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyDashboardApi
     */
    public apiAppSafetydashboardUnresolveddvirdefectsGet(options?: AxiosRequestConfig) {
        return SafetyDashboardApiFp(this.configuration).apiAppSafetydashboardUnresolveddvirdefectsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantAcquiretenantadminaccesstokenPost: async (apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/acquiretenantadminaccesstoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantAcquiretenantadminaccesstokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdDelete', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdGet', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdPut: async (id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantIdPut', 'id', id)
            const localVarPath = `/api/app/tenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantPost: async (apiAppTenantGetRequest?: ApiAppTenantGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenant/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/multi-tenancy/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringDelete', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringGet', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringPut: async (id: string, defaultConnectionString?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDefaultConnectionStringPut', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}/default-connection-string`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (defaultConnectionString !== undefined) {
                localVarQueryParameter['defaultConnectionString'] = defaultConnectionString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdDelete', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdGet', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdPut: async (id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMultiTenancyTenantsIdPut', 'id', id)
            const localVarPath = `/api/multi-tenancy/tenants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiMultiTenancyTenantsIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsPost: async (apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/multi-tenancy/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiMultiTenancyTenantsGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOverrideOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantPost(apiAppTenantGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: any): AxiosPromise<UserOverrideOutput> {
            return localVarFp.apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdGet(id: string, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantPost(apiAppTenantGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantDtoPagedResultDto> {
            return localVarFp.apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [defaultConnectionString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMultiTenancyTenantsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdGet(id: string, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: any): AxiosPromise<TenantDto> {
            return localVarFp.apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTenantAcquiretenantadminaccesstokenPostRequest} [apiAppTenantAcquiretenantadminaccesstokenPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest?: ApiAppTenantAcquiretenantadminaccesstokenPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantAcquiretenantadminaccesstokenPost(apiAppTenantAcquiretenantadminaccesstokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppTenantIdDeleteRequest} [apiAppTenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantIdPut(id: string, apiAppTenantIdDeleteRequest?: ApiAppTenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantIdPut(id, apiAppTenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantGetRequest} [apiAppTenantGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantPost(apiAppTenantGetRequest?: ApiAppTenantGetRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantPost(apiAppTenantGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiAppTenantUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [defaultConnectionString] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDefaultConnectionStringPut(id: string, defaultConnectionString?: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDefaultConnectionStringPut(id, defaultConnectionString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiMultiTenancyTenantsIdDeleteRequest} [apiMultiTenancyTenantsIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsIdPut(id: string, apiMultiTenancyTenantsIdDeleteRequest?: ApiMultiTenancyTenantsIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsIdPut(id, apiMultiTenancyTenantsIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiMultiTenancyTenantsGetRequest} [apiMultiTenancyTenantsGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest?: ApiMultiTenancyTenantsGetRequest, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).apiMultiTenancyTenantsPost(apiMultiTenancyTenantsGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantEldDeviceViewApi - axios parameter creator
 * @export
 */
export const TenantEldDeviceViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantelddeviceview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantelddeviceviewIdGet', 'id', id)
            const localVarPath = `/api/app/tenantelddeviceview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantEldDeviceViewApi - functional programming interface
 * @export
 */
export const TenantEldDeviceViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantEldDeviceViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantEldDeviceViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantEldDeviceViewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantelddeviceviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantEldDeviceViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantelddeviceviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantEldDeviceViewApi - factory interface
 * @export
 */
export const TenantEldDeviceViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantEldDeviceViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantEldDeviceViewDtoPagedResultDto> {
            return localVarFp.apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantEldDeviceViewDtoPagedResultDto> {
            return localVarFp.apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TenantEldDeviceViewDto>> {
            return localVarFp.apiAppTenantelddeviceviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantEldDeviceViewDto>> {
            return localVarFp.apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantelddeviceviewIdGet(id: number, options?: any): AxiosPromise<TenantEldDeviceViewDto> {
            return localVarFp.apiAppTenantelddeviceviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantEldDeviceViewApi - object-oriented interface
 * @export
 * @class TenantEldDeviceViewApi
 * @extends {BaseAPI}
 */
export class TenantEldDeviceViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantEldDeviceViewApi
     */
    public apiAppTenantelddeviceviewIdGet(id: number, options?: AxiosRequestConfig) {
        return TenantEldDeviceViewApiFp(this.configuration).apiAppTenantelddeviceviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantRegistrationApi - axios parameter creator
 * @export
 */
export const TenantRegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationApproveordenypendingrequestPost: async (apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/approveordenypendingrequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationApproveordenypendingrequestPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationChangeStatusPost: async (id?: string, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationDeleteManyDelete: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDeactivatePost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdDeactivatePost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/deactivate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdDelete', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdGet', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGrantmasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdGrantmasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/grantmasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdPut: async (id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdPut', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdReactivatemasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdReactivatemasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/reactivatemasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdRemovemasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdRemovemasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/removemasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdResendwelcomeemailPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdResendwelcomeemailPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/resendwelcomeemail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSuspendmasteraccountPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantregistrationIdSuspendmasteraccountPost', 'id', id)
            const localVarPath = `/api/app/tenantregistration/{id}/suspendmasteraccount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationPost: async (apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationReassigntenantPost: async (apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/reassigntenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTenantregistrationReassigntenantPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/tenantregistration/tenantregistrationbasicinfo/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationUpdateManyPut: async (apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantregistration/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppDemoaccountUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantRegistrationApi - functional programming interface
 * @export
 */
export const TenantRegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantRegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantRegistrationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantRegistrationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdDeactivatePost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdDeactivatePost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdGrantmasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdReactivatemasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdRemovemasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdResendwelcomeemailPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationIdSuspendmasteraccountPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantRegistrationBasicInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantRegistrationApi - factory interface
 * @export
 */
export const TenantRegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantRegistrationApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantregistrationDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantRegistrationDtoPagedResultDto> {
            return localVarFp.apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantRegistrationDtoPagedResultDto> {
            return localVarFp.apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantRegistrationDto>> {
            return localVarFp.apiAppTenantregistrationGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantRegistrationDto>> {
            return localVarFp.apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDeactivatePost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdDeactivatePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGet(id: string, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdGrantmasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdReactivatemasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdRemovemasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdResendwelcomeemailPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationIdSuspendmasteraccountPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: any): AxiosPromise<TenantRegistrationDto> {
            return localVarFp.apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: any): AxiosPromise<TenantRegistrationBasicInfoDto> {
            return localVarFp.apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantRegistrationApi - object-oriented interface
 * @export
 * @class TenantRegistrationApi
 * @extends {BaseAPI}
 */
export class TenantRegistrationApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTenantregistrationApproveordenypendingrequestPostRequest} [apiAppTenantregistrationApproveordenypendingrequestPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest?: ApiAppTenantregistrationApproveordenypendingrequestPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationApproveordenypendingrequestPost(apiAppTenantregistrationApproveordenypendingrequestPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationChangeStatusPost(id?: string, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationDeleteManyDelete(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdDeactivatePost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdDeactivatePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdDelete(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdGrantmasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdGrantmasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppTenantregistrationIdDeleteRequest} [apiAppTenantregistrationIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdPut(id: string, apiAppTenantregistrationIdDeleteRequest?: ApiAppTenantregistrationIdDeleteRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdPut(id, apiAppTenantregistrationIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdReactivatemasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdReactivatemasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdRemovemasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdRemovemasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdResendwelcomeemailPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdResendwelcomeemailPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationIdSuspendmasteraccountPost(id: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationIdSuspendmasteraccountPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantregistrationGetRequest} [apiAppTenantregistrationGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest?: ApiAppTenantregistrationGetRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationPost(apiAppTenantregistrationGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTenantregistrationReassigntenantPostRequest} [apiAppTenantregistrationReassigntenantPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest?: ApiAppTenantregistrationReassigntenantPostRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationReassigntenantPost(apiAppTenantregistrationReassigntenantPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId: string, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationTenantregistrationbasicinfoTenantIdGet(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppDemoaccountUpdateManyPutRequest} [apiAppDemoaccountUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistrationApi
     */
    public apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest?: ApiAppDemoaccountUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TenantRegistrationApiFp(this.configuration).apiAppTenantregistrationUpdateManyPut(apiAppDemoaccountUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantViewApi - axios parameter creator
 * @export
 */
export const TenantViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewAccessibletenantsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/accessibletenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyGet: async (ids?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tenantview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTenantviewIdGet', 'id', id)
            const localVarPath = `/api/app/tenantview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantViewApi - functional programming interface
 * @export
 */
export const TenantViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewAccessibletenantsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewAccessibletenantsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantOutputDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTenantviewIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantOutputDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTenantviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantViewApi - factory interface
 * @export
 */
export const TenantViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantViewApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewAccessibletenantsGet(options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewAccessibletenantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TenantOutputDtoPagedResultDto> {
            return localVarFp.apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyGet(ids?: Array<string>, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TenantOutputDto>> {
            return localVarFp.apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTenantviewIdGet(id: string, options?: any): AxiosPromise<TenantOutputDto> {
            return localVarFp.apiAppTenantviewIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantViewApi - object-oriented interface
 * @export
 * @class TenantViewApi
 * @extends {BaseAPI}
 */
export class TenantViewApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewAccessibletenantsGet(options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewAccessibletenantsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetManyGet(ids?: Array<string>, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantViewApi
     */
    public apiAppTenantviewIdGet(id: string, options?: AxiosRequestConfig) {
        return TenantViewApiFp(this.configuration).apiAppTenantviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailerApi - axios parameter creator
 * @export
 */
export const TrailerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdDelete', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdGet', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdPut: async (id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailerIdPut', 'id', id)
            const localVarPath = `/api/app/trailer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerPost: async (apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailerGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailer/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerApi - functional programming interface
 * @export
 */
export const TrailerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerPost(apiAppTrailerGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailerApi - factory interface
 * @export
 */
export const TrailerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailerDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TrailerDtoPagedResultDto> {
            return localVarFp.apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TrailerListDtoPagedResultDto> {
            return localVarFp.apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TrailerListDto>> {
            return localVarFp.apiAppTrailerGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TrailerListDto>> {
            return localVarFp.apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdGet(id: number, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: any): AxiosPromise<TrailerDto> {
            return localVarFp.apiAppTrailerPost(apiAppTrailerGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<TrailerSyncDto>> {
            return localVarFp.apiAppTrailerSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerApi - object-oriented interface
 * @export
 * @class TrailerApi
 * @extends {BaseAPI}
 */
export class TrailerApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdDelete(id: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdGet(id: number, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppTrailerIdDeleteRequest} [apiAppTrailerIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerIdPut(id: number, apiAppTrailerIdDeleteRequest?: ApiAppTrailerIdDeleteRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerIdPut(id, apiAppTrailerIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTrailerGetRequest} [apiAppTrailerGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerPost(apiAppTrailerGetRequest?: ApiAppTrailerGetRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerPost(apiAppTrailerGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerApi
     */
    public apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TrailerApiFp(this.configuration).apiAppTrailerUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailerTrackingProviderApi - axios parameter creator
 * @export
 */
export const TrailerTrackingProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdDelete', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdGet', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdPut: async (id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppTrailertrackingproviderIdPut', 'id', id)
            const localVarPath = `/api/app/trailertrackingprovider/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailertrackingproviderIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderPost: async (apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTrailertrackingproviderGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/trailertrackingprovider/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerTrackingProviderApi - functional programming interface
 * @export
 */
export const TrailerTrackingProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerTrackingProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailerTrackingProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerTrackingProviderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailerTrackingProviderApi - factory interface
 * @export
 */
export const TrailerTrackingProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerTrackingProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailertrackingproviderDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<TrailerTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TrailerTrackingProviderDtoPagedResultDto> {
            return localVarFp.apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<TrailerTrackingProviderDto>> {
            return localVarFp.apiAppTrailertrackingproviderGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<TrailerTrackingProviderDto>> {
            return localVarFp.apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTrailertrackingproviderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdGet(id: number, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: any): AxiosPromise<TrailerTrackingProviderDto> {
            return localVarFp.apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerTrackingProviderApi - object-oriented interface
 * @export
 * @class TrailerTrackingProviderApi
 * @extends {BaseAPI}
 */
export class TrailerTrackingProviderApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdDelete(id: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdGet(id: number, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppTrailertrackingproviderIdDeleteRequest} [apiAppTrailertrackingproviderIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderIdPut(id: number, apiAppTrailertrackingproviderIdDeleteRequest?: ApiAppTrailertrackingproviderIdDeleteRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderIdPut(id, apiAppTrailertrackingproviderIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTrailertrackingproviderGetRequest} [apiAppTrailertrackingproviderGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest?: ApiAppTrailertrackingproviderGetRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderPost(apiAppTrailertrackingproviderGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerTrackingProviderApi
     */
    public apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return TrailerTrackingProviderApiFp(this.configuration).apiAppTrailertrackingproviderUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrailersHistoryApi - axios parameter creator
 * @export
 */
export const TrailersHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerstatusinfoTrailerIdGet: async (trailerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('apiAppTrailershistoryTrailerstatusinfoTrailerIdGet', 'trailerId', trailerId)
            const localVarPath = `/api/app/trailershistory/trailerstatusinfo/{trailerId}`
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerusagehistoryTrailerIdGet: async (trailerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('apiAppTrailershistoryTrailerusagehistoryTrailerIdGet', 'trailerId', trailerId)
            const localVarPath = `/api/app/trailershistory/trailerusagehistory/{trailerId}`
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailersHistoryApi - functional programming interface
 * @export
 */
export const TrailersHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailersHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrailerHistoryStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrailersUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrailersHistoryApi - factory interface
 * @export
 */
export const TrailersHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailersHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: any): AxiosPromise<TrailerHistoryStatusInfoDto> {
            return localVarFp.apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} trailerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: any): AxiosPromise<Array<TrailersUsageHistoryListDto>> {
            return localVarFp.apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailersHistoryApi - object-oriented interface
 * @export
 * @class TrailersHistoryApi
 * @extends {BaseAPI}
 */
export class TrailersHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} trailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersHistoryApi
     */
    public apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId: number, options?: AxiosRequestConfig) {
        return TrailersHistoryApiFp(this.configuration).apiAppTrailershistoryTrailerstatusinfoTrailerIdGet(trailerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} trailerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersHistoryApi
     */
    public apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId: number, options?: AxiosRequestConfig) {
        return TrailersHistoryApiFp(this.configuration).apiAppTrailershistoryTrailerusagehistoryTrailerIdGet(trailerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TripsViewApi - axios parameter creator
 * @export
 */
export const TripsViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbystateGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsviewbystate/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbyvehicleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/tripsviewbyvehicle/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TripsViewApi - functional programming interface
 * @export
 */
export const TripsViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TripsViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewByStateListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripsViewByVehicleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TripsViewApi - factory interface
 * @export
 */
export const TripsViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TripsViewApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewByStateListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<TripsViewByVehicleListDtoPagedResultDto> {
            return localVarFp.apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TripsViewApi - object-oriented interface
 * @export
 * @class TripsViewApi
 * @extends {BaseAPI}
 */
export class TripsViewApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewbystateGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripsViewApi
     */
    public apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return TripsViewApiFp(this.configuration).apiAppTripsviewbyvehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TwoFactorAuthenticationSettingsApi - axios parameter creator
 * @export
 */
export const TwoFactorAuthenticationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGenerateonetimecodePost: async (apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/generateonetimecode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsSavePost: async (apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsSavePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsVerifyonetimecodePost: async (apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/twofactorauthenticationsettings/verifyonetimecode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwoFactorAuthenticationSettingsApi - functional programming interface
 * @export
 */
export const TwoFactorAuthenticationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwoFactorAuthenticationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateOneTimeCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwoFactorAuthenticationSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyOneTimeCodeOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TwoFactorAuthenticationSettingsApi - factory interface
 * @export
 */
export const TwoFactorAuthenticationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwoFactorAuthenticationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: any): AxiosPromise<GenerateOneTimeCodeOutput> {
            return localVarFp.apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsGet(options?: any): AxiosPromise<TwoFactorAuthenticationSettingsDto> {
            return localVarFp.apiAppTwofactorauthenticationsettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: any): AxiosPromise<VerifyOneTimeCodeOutput> {
            return localVarFp.apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwoFactorAuthenticationSettingsApi - object-oriented interface
 * @export
 * @class TwoFactorAuthenticationSettingsApi
 * @extends {BaseAPI}
 */
export class TwoFactorAuthenticationSettingsApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsGenerateonetimecodePost(apiAppTwofactorauthenticationsettingsGenerateonetimecodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsGet(options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsSavePostRequest} [apiAppTwofactorauthenticationsettingsSavePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest?: ApiAppTwofactorauthenticationsettingsSavePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsSavePost(apiAppTwofactorauthenticationsettingsSavePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest} [apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorAuthenticationSettingsApi
     */
    public apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest?: ApiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options?: AxiosRequestConfig) {
        return TwoFactorAuthenticationSettingsApiFp(this.configuration).apiAppTwofactorauthenticationsettingsVerifyonetimecodePost(apiAppTwofactorauthenticationsettingsVerifyonetimecodePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UnidentifiedEventsApi - axios parameter creator
 * @export
 */
export const UnidentifiedEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsDelete: async (eventId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdGet: async (id: number, driverId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppUnidentifiedeventsIdGet', 'id', id)
            const localVarPath = `/api/app/unidentifiedevents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdPut: async (id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppUnidentifiedeventsIdPut', 'id', id)
            const localVarPath = `/api/app/unidentifiedevents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsIdGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsMastercreatePost: async (apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents/mastercreate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsPost: async (apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/unidentifiedevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUnidentifiedeventsDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnidentifiedEventsApi - functional programming interface
 * @export
 */
export const UnidentifiedEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnidentifiedEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsDelete(eventId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsDelete(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsIdGet(id, driverId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnidentifiedEventsListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnidentifiedEventsApi - factory interface
 * @export
 */
export const UnidentifiedEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnidentifiedEventsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [eventId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsDelete(eventId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUnidentifiedeventsDelete(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<UnidentifiedEventsListDtoPagedResultDto> {
            return localVarFp.apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} [driverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsIdGet(id, driverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: any): AxiosPromise<UnidentifiedEventsListDto> {
            return localVarFp.apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnidentifiedEventsApi - object-oriented interface
 * @export
 * @class UnidentifiedEventsApi
 * @extends {BaseAPI}
 */
export class UnidentifiedEventsApi extends BaseAPI {
    /**
     * 
     * @param {number} [eventId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsDelete(eventId?: number, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsDelete(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} [driverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsIdGet(id: number, driverId?: number, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsIdGet(id, driverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppUnidentifiedeventsIdGetRequest} [apiAppUnidentifiedeventsIdGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsIdPut(id: number, apiAppUnidentifiedeventsIdGetRequest?: ApiAppUnidentifiedeventsIdGetRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsIdPut(id, apiAppUnidentifiedeventsIdGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsMastercreatePost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUnidentifiedeventsDeleteRequest} [apiAppUnidentifiedeventsDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnidentifiedEventsApi
     */
    public apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest?: ApiAppUnidentifiedeventsDeleteRequest, options?: AxiosRequestConfig) {
        return UnidentifiedEventsApiFp(this.configuration).apiAppUnidentifiedeventsPost(apiAppUnidentifiedeventsDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAssignableRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/assignable-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByEmailEmailGet: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiIdentityUsersByEmailEmailGet', 'email', email)
            const localVarPath = `/api/identity/users/by-email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByUsernameUserNameGet: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('apiIdentityUsersByUsernameUserNameGet', 'userName', userName)
            const localVarPath = `/api/identity/users/by-username/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdDelete', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdGet', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdPut: async (id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdPut', 'id', id)
            const localVarPath = `/api/identity/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdRolesGet', 'id', id)
            const localVarPath = `/api/identity/users/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesPut: async (id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersIdRolesPut', 'id', id)
            const localVarPath = `/api/identity/users/{id}/roles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersIdRolesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersPost: async (apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiIdentityUsersGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersAssignableRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersAssignableRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersByEmailEmailGet(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersByEmailEmailGet(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersByUsernameUserNameGet(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdRolesGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityRoleDtoListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdRolesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersPost(apiIdentityUsersGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAssignableRolesGet(options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityUsersAssignableRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByEmailEmailGet(email: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersByEmailEmailGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersByUsernameUserNameGet(userName: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersByUsernameUserNameGet(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<IdentityUserDtoPagedResultDto> {
            return localVarFp.apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdGet(id: string, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesGet(id: string, options?: any): AxiosPromise<IdentityRoleDtoListResultDto> {
            return localVarFp.apiIdentityUsersIdRolesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: any): AxiosPromise<IdentityUserDto> {
            return localVarFp.apiIdentityUsersPost(apiIdentityUsersGetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersAssignableRolesGet(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersAssignableRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersByEmailEmailGet(email: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersByEmailEmailGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersByUsernameUserNameGet(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdDelete(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdGet(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiIdentityUsersIdDeleteRequest} [apiIdentityUsersIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdPut(id: string, apiIdentityUsersIdDeleteRequest?: ApiIdentityUsersIdDeleteRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdPut(id, apiIdentityUsersIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdRolesGet(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdRolesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiIdentityUsersIdRolesGetRequest} [apiIdentityUsersIdRolesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersIdRolesPut(id: string, apiIdentityUsersIdRolesGetRequest?: ApiIdentityUsersIdRolesGetRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersIdRolesPut(id, apiIdentityUsersIdRolesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiIdentityUsersGetRequest} [apiIdentityUsersGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiIdentityUsersPost(apiIdentityUsersGetRequest?: ApiIdentityUsersGetRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).apiIdentityUsersPost(apiIdentityUsersGetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserLookupApi - axios parameter creator
 * @export
 */
export const UserLookupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupByUsernameUserNameGet: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('apiIdentityUsersLookupByUsernameUserNameGet', 'userName', userName)
            const localVarPath = `/api/identity/users/lookup/by-username/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupCountGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/lookup/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiIdentityUsersLookupIdGet', 'id', id)
            const localVarPath = `/api/identity/users/lookup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupSearchGet: async (filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/users/lookup/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLookupApi - functional programming interface
 * @export
 */
export const UserLookupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLookupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupByUsernameUserNameGet(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupCountGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupCountGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataListResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserLookupApi - factory interface
 * @export
 */
export const UserLookupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLookupApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: any): AxiosPromise<UserData> {
            return localVarFp.apiIdentityUsersLookupByUsernameUserNameGet(userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupCountGet(filter?: string, options?: any): AxiosPromise<number> {
            return localVarFp.apiIdentityUsersLookupCountGet(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupIdGet(id: string, options?: any): AxiosPromise<UserData> {
            return localVarFp.apiIdentityUsersLookupIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<UserDataListResultDto> {
            return localVarFp.apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserLookupApi - object-oriented interface
 * @export
 * @class UserLookupApi
 * @extends {BaseAPI}
 */
export class UserLookupApi extends BaseAPI {
    /**
     * 
     * @param {string} userName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupByUsernameUserNameGet(userName: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupByUsernameUserNameGet(userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupCountGet(filter?: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupCountGet(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupIdGet(id: string, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserLookupApi
     */
    public apiIdentityUsersLookupSearchGet(filter?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return UserLookupApiFp(this.configuration).apiIdentityUsersLookupSearchGet(filter, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPreferenceApi - axios parameter creator
 * @export
 */
export const UserPreferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceSaveuserpreferencesPost: async (apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/userpreference/saveuserpreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUserpreferenceSaveuserpreferencesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceUserpreferencesUserIdGet: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiAppUserpreferenceUserpreferencesUserIdGet', 'userId', userId)
            const localVarPath = `/api/app/userpreference/userpreferences/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPreferenceApi - functional programming interface
 * @export
 */
export const UserPreferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPreferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPreferenceGetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUserpreferenceUserpreferencesUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPreferenceApi - factory interface
 * @export
 */
export const UserPreferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPreferenceApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: any): AxiosPromise<UserPreferenceGetDto> {
            return localVarFp.apiAppUserpreferenceUserpreferencesUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPreferenceApi - object-oriented interface
 * @export
 * @class UserPreferenceApi
 * @extends {BaseAPI}
 */
export class UserPreferenceApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppUserpreferenceSaveuserpreferencesPostRequest} [apiAppUserpreferenceSaveuserpreferencesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceApi
     */
    public apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest?: ApiAppUserpreferenceSaveuserpreferencesPostRequest, options?: AxiosRequestConfig) {
        return UserPreferenceApiFp(this.configuration).apiAppUserpreferenceSaveuserpreferencesPost(apiAppUserpreferenceSaveuserpreferencesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferenceApi
     */
    public apiAppUserpreferenceUserpreferencesUserIdGet(userId: string, options?: AxiosRequestConfig) {
        return UserPreferenceApiFp(this.configuration).apiAppUserpreferenceUserpreferencesUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilApi - axios parameter creator
 * @export
 */
export const UtilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilFmcsacredentialsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/fmcsacredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilObtainfmcsacredentialsPost: async (apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/obtainfmcsacredentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilObtainfmcsacredentialsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilServertimeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/servertime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobileappversionPost: async (apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/setmobileappversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilSetmobileappversionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobiledeviceinformationPost: async (apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/setmobiledeviceinformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppUtilSetmobiledeviceinformationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilTaskcanceledexceptionGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/taskcanceledexception`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilUploadmobileappdatabasePost: async (input?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/util/uploadmobileappdatabase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (input !== undefined) { 
                localVarFormParams.append('input', input as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilGetlogsarchivestreamGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/util/getlogsarchivestream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilApi - functional programming interface
 * @export
 */
export const UtilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilFmcsacredentialsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FmcsaMobileCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilFmcsacredentialsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilServertimeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilServertimeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilTaskcanceledexceptionGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilTaskcanceledexceptionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppUtilUploadmobileappdatabasePost(input?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppUtilUploadmobileappdatabasePost(input, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilGetlogsarchivestreamGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilGetlogsarchivestreamGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilApi - factory interface
 * @export
 */
export const UtilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilFmcsacredentialsGet(options?: any): AxiosPromise<FmcsaMobileCredentials> {
            return localVarFp.apiAppUtilFmcsacredentialsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilServertimeGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiAppUtilServertimeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilTaskcanceledexceptionGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiAppUtilTaskcanceledexceptionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [input] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppUtilUploadmobileappdatabasePost(input?: any, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppUtilUploadmobileappdatabasePost(input, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilGetlogsarchivestreamGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiUtilGetlogsarchivestreamGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilApi - object-oriented interface
 * @export
 * @class UtilApi
 * @extends {BaseAPI}
 */
export class UtilApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilFmcsacredentialsGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilFmcsacredentialsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilObtainfmcsacredentialsPostRequest} [apiAppUtilObtainfmcsacredentialsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest?: ApiAppUtilObtainfmcsacredentialsPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilObtainfmcsacredentialsPost(apiAppUtilObtainfmcsacredentialsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilServertimeGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilServertimeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilSetmobileappversionPostRequest} [apiAppUtilSetmobileappversionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest?: ApiAppUtilSetmobileappversionPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilSetmobileappversionPost(apiAppUtilSetmobileappversionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppUtilSetmobiledeviceinformationPostRequest} [apiAppUtilSetmobiledeviceinformationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest?: ApiAppUtilSetmobiledeviceinformationPostRequest, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilSetmobiledeviceinformationPost(apiAppUtilSetmobiledeviceinformationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilTaskcanceledexceptionGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilTaskcanceledexceptionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [input] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiAppUtilUploadmobileappdatabasePost(input?: any, options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiAppUtilUploadmobileappdatabasePost(input, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilApi
     */
    public apiUtilGetlogsarchivestreamGet(options?: AxiosRequestConfig) {
        return UtilApiFp(this.configuration).apiUtilGetlogsarchivestreamGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleApi - axios parameter creator
 * @export
 */
export const VehicleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdDelete', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdGet', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdPut: async (id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleIdPut', 'id', id)
            const localVarPath = `/api/app/vehicle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclePost: async (apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehicleGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleSyncGet: async (lastSyncTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lastSyncTime !== undefined) {
                localVarQueryParameter['lastSyncTime'] = (lastSyncTime as any instanceof Date) ?
                    (lastSyncTime as any).toISOString() :
                    lastSyncTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicle/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleApi - functional programming interface
 * @export
 */
export const VehicleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclePost(apiAppVehicleGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleSyncDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleSyncGet(lastSyncTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleApi - factory interface
 * @export
 */
export const VehicleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicleDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleDtoPagedResultDto> {
            return localVarFp.apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleListDtoPagedResultDto> {
            return localVarFp.apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleListDto>> {
            return localVarFp.apiAppVehicleGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleListDto>> {
            return localVarFp.apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehicleIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdGet(id: number, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehiclePost(apiAppVehicleGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [lastSyncTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleSyncGet(lastSyncTime?: string, options?: any): AxiosPromise<Array<VehicleSyncDto>> {
            return localVarFp.apiAppVehicleSyncGet(lastSyncTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleApi - object-oriented interface
 * @export
 * @class VehicleApi
 * @extends {BaseAPI}
 */
export class VehicleApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppVehicleIdDeleteRequest} [apiAppVehicleIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleIdPut(id: number, apiAppVehicleIdDeleteRequest?: ApiAppVehicleIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleIdPut(id, apiAppVehicleIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVehicleGetRequest} [apiAppVehicleGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehiclePost(apiAppVehicleGetRequest?: ApiAppVehicleGetRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehiclePost(apiAppVehicleGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [lastSyncTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleSyncGet(lastSyncTime?: string, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleSyncGet(lastSyncTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).apiAppVehicleUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleHistoryApi - axios parameter creator
 * @export
 */
export const VehicleHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehicledriversusagehistory/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicleelddevicesusagehistoryGet: async (vehicleId: number, tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicleelddevicesusagehistoryGet', 'vehicleId', vehicleId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicleelddevicesusagehistoryGet', 'tenantId', tenantId)
            const localVarPath = `/api/app/vehiclehistory/vehicleelddevicesusagehistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vehicleId !== undefined) {
                localVarQueryParameter['VehicleId'] = vehicleId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['TenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehiclestatusinfo/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehiclehistory/vehicletrailersusagehistory/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleHistoryApi - functional programming interface
 * @export
 */
export const VehicleHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleDriversAndDrivingPeriodListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleEldDevicesUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleUsageStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleTrailersUsageHistoryListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleHistoryApi - factory interface
 * @export
 */
export const VehicleHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleDriversAndDrivingPeriodListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: any): AxiosPromise<Array<VehicleEldDevicesUsageHistoryListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<VehicleUsageStatusInfoDto> {
            return localVarFp.apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<Array<VehicleTrailersUsageHistoryListDto>> {
            return localVarFp.apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleHistoryApi - object-oriented interface
 * @export
 * @class VehicleHistoryApi
 * @extends {BaseAPI}
 */
export class VehicleHistoryApi extends BaseAPI {
    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicledriversusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId: number, tenantId: string, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicleelddevicesusagehistoryGet(vehicleId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehiclestatusinfoVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleHistoryApi
     */
    public apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleHistoryApiFp(this.configuration).apiAppVehiclehistoryVehicletrailersusagehistoryVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleMaintenanceApi - axios parameter creator
 * @export
 */
export const VehicleMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceChangeStatusPost: async (id?: number, status?: RecordStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/change-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceDeleteManyDelete: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/delete-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceExportPost: async (apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyExportPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdDelete', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdGet', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdPut: async (id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenanceIdPut', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenance/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehiclemaintenanceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancePost: async (apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVehiclemaintenanceIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceUpdateManyPut: async (apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenance/update-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyUpdateManyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehiclemaintenancesummary/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehiclemaintenancesummaryIdGet', 'id', id)
            const localVarPath = `/api/app/vehiclemaintenancesummary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleMaintenanceApi - functional programming interface
 * @export
 */
export const VehicleMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceChangeStatusPost(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceDeleteManyDelete(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleMaintenanceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleMaintenanceListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceSummaryListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehiclemaintenancesummaryIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleMaintenanceSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehiclemaintenancesummaryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleMaintenanceApi - factory interface
 * @export
 */
export const VehicleMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {RecordStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceChangeStatusPost(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehiclemaintenanceDeleteManyDelete(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleMaintenanceDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleMaintenanceListDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleMaintenanceListDto>> {
            return localVarFp.apiAppVehiclemaintenanceGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleMaintenanceListDto>> {
            return localVarFp.apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVehiclemaintenanceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdGet(id: number, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: any): AxiosPromise<VehicleMaintenanceDto> {
            return localVarFp.apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: any): AxiosPromise<object> {
            return localVarFp.apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleMaintenanceSummaryListDtoPagedResultDto> {
            return localVarFp.apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehiclemaintenancesummaryIdGet(id: number, options?: any): AxiosPromise<VehicleMaintenanceSummaryDto> {
            return localVarFp.apiAppVehiclemaintenancesummaryIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleMaintenanceApi - object-oriented interface
 * @export
 * @class VehicleMaintenanceApi
 * @extends {BaseAPI}
 */
export class VehicleMaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {RecordStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceChangeStatusPost(id?: number, status?: RecordStatus, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceChangeStatusPost(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceDeleteManyDelete(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceDeleteManyDelete(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyExportPostRequest} [apiAppCompanyExportPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest?: ApiAppCompanyExportPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceExportPost(apiAppCompanyExportPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceIdPut(id: number, apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceIdPut(id, apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVehiclemaintenanceIdDeleteRequest} [apiAppVehiclemaintenanceIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest?: ApiAppVehiclemaintenanceIdDeleteRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancePost(apiAppVehiclemaintenanceIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyUpdateManyPutRequest} [apiAppCompanyUpdateManyPutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest?: ApiAppCompanyUpdateManyPutRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenanceUpdateManyPut(apiAppCompanyUpdateManyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancesummaryGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMaintenanceApi
     */
    public apiAppVehiclemaintenancesummaryIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleMaintenanceApiFp(this.configuration).apiAppVehiclemaintenancesummaryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VehicleViewApi - axios parameter creator
 * @export
 */
export const VehicleViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGet: async (filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterRuleField !== undefined) {
                localVarQueryParameter['FilterRule.Field'] = filterRuleField;
            }

            if (filterRuleOperator !== undefined) {
                localVarQueryParameter['FilterRule.Operator'] = filterRuleOperator;
            }

            if (filterRuleValue !== undefined) {
                localVarQueryParameter['FilterRule.Value'] = filterRuleValue;
            }

            if (filterRuleCondition !== undefined) {
                localVarQueryParameter['FilterRule.Condition'] = filterRuleCondition;
            }

            if (filterRuleFilterRules) {
                localVarQueryParameter['FilterRule.FilterRules'] = filterRuleFilterRules;
            }

            if (filterRuleIsNestedRule !== undefined) {
                localVarQueryParameter['FilterRule.IsNestedRule'] = filterRuleIsNestedRule;
            }

            if (filterRuleIsValid !== undefined) {
                localVarQueryParameter['FilterRule.IsValid'] = filterRuleIsValid;
            }

            if (searchRuleColumns) {
                localVarQueryParameter['SearchRule.Columns'] = searchRuleColumns;
            }

            if (searchRuleText !== undefined) {
                localVarQueryParameter['SearchRule.Text'] = searchRuleText;
            }

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyGet: async (ids?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyReferencePost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/vehicleview/get-many-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVehicleviewIdGet', 'id', id)
            const localVarPath = `/api/app/vehicleview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewVehiclecurrentdriverVehicleIdGet: async (vehicleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiAppVehicleviewVehiclecurrentdriverVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/app/vehicleview/vehiclecurrentdriver/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleViewApi - functional programming interface
 * @export
 */
export const VehicleViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleViewListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetManyGet(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleViewApi - factory interface
 * @export
 */
export const VehicleViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [filterRuleField] 
         * @param {string} [filterRuleOperator] 
         * @param {string} [filterRuleValue] 
         * @param {string} [filterRuleCondition] 
         * @param {Array<FilterRule>} [filterRuleFilterRules] 
         * @param {boolean} [filterRuleIsNestedRule] 
         * @param {boolean} [filterRuleIsValid] 
         * @param {Array<string>} [searchRuleColumns] 
         * @param {string} [searchRuleText] 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: any): AxiosPromise<VehicleDtoPagedResultDto> {
            return localVarFp.apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VehicleViewListDtoPagedResultDto> {
            return localVarFp.apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: any): AxiosPromise<Array<VehicleViewListDto>> {
            return localVarFp.apiAppVehicleviewGetManyGet(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<Array<VehicleViewListDto>> {
            return localVarFp.apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewIdGet(id: number, options?: any): AxiosPromise<VehicleDto> {
            return localVarFp.apiAppVehicleviewIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} vehicleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: any): AxiosPromise<number> {
            return localVarFp.apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleViewApi - object-oriented interface
 * @export
 * @class VehicleViewApi
 * @extends {BaseAPI}
 */
export class VehicleViewApi extends BaseAPI {
    /**
     * 
     * @param {string} [filterRuleField] 
     * @param {string} [filterRuleOperator] 
     * @param {string} [filterRuleValue] 
     * @param {string} [filterRuleCondition] 
     * @param {Array<FilterRule>} [filterRuleFilterRules] 
     * @param {boolean} [filterRuleIsNestedRule] 
     * @param {boolean} [filterRuleIsValid] 
     * @param {Array<string>} [searchRuleColumns] 
     * @param {string} [searchRuleText] 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGet(filterRuleField?: string, filterRuleOperator?: string, filterRuleValue?: string, filterRuleCondition?: string, filterRuleFilterRules?: Array<FilterRule>, filterRuleIsNestedRule?: boolean, filterRuleIsValid?: boolean, searchRuleColumns?: Array<string>, searchRuleText?: string, sorting?: string, skipCount?: number, maxResultCount?: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGet(filterRuleField, filterRuleOperator, filterRuleValue, filterRuleCondition, filterRuleFilterRules, filterRuleIsNestedRule, filterRuleIsValid, searchRuleColumns, searchRuleText, sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetManyGet(ids?: Array<number>, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetManyGet(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewGetManyReferencePost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleViewApi
     */
    public apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId: number, options?: AxiosRequestConfig) {
        return VehicleViewApiFp(this.configuration).apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VirtualTenantApi - axios parameter creator
 * @export
 */
export const VirtualTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetFilteredListPost: async (apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/get-filtered-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppCompanyGetFilteredListPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetvehicledriversPost: async (apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/getvehicledrivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantGetvehicledriversPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdDelete', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdGet', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdPut: async (id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAppVirtualtenantIdPut', 'id', id)
            const localVarPath = `/api/app/virtualtenant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantPost: async (apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantValidateEmailPost: async (email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/app/virtualtenant/validate-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAppVirtualtenantIdDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VirtualTenantApi - functional programming interface
 * @export
 */
export const VirtualTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VirtualTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantListDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverViewListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualTenantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VirtualTenantApi - factory interface
 * @export
 */
export const VirtualTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VirtualTenantApiFp(configuration)
    return {
        /**
         * 
         * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: any): AxiosPromise<VirtualTenantListDtoPagedResultDto> {
            return localVarFp.apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: any): AxiosPromise<Array<DriverViewListDto>> {
            return localVarFp.apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiAppVirtualtenantIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdGet(id: string, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<VirtualTenantDto> {
            return localVarFp.apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VirtualTenantApi - object-oriented interface
 * @export
 * @class VirtualTenantApi
 * @extends {BaseAPI}
 */
export class VirtualTenantApi extends BaseAPI {
    /**
     * 
     * @param {ApiAppCompanyGetFilteredListPostRequest} [apiAppCompanyGetFilteredListPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest?: ApiAppCompanyGetFilteredListPostRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantGetFilteredListPost(apiAppCompanyGetFilteredListPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVirtualtenantGetvehicledriversPostRequest} [apiAppVirtualtenantGetvehicledriversPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest?: ApiAppVirtualtenantGetvehicledriversPostRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantGetvehicledriversPost(apiAppVirtualtenantGetvehicledriversPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdDelete(id: string, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdGet(id: string, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantIdPut(id: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantIdPut(id, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantPost(apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {ApiAppVirtualtenantIdDeleteRequest} [apiAppVirtualtenantIdDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualTenantApi
     */
    public apiAppVirtualtenantValidateEmailPost(email?: string, apiAppVirtualtenantIdDeleteRequest?: ApiAppVirtualtenantIdDeleteRequest, options?: AxiosRequestConfig) {
        return VirtualTenantApiFp(this.configuration).apiAppVirtualtenantValidateEmailPost(email, apiAppVirtualtenantIdDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


